export default {
  common: {
    noFace: 'មិនមានរបស់មាត្រ',
    noPermissionTip: 'អ្នកមិនមានសិទ្ធិសម្រាប់ការប្រើប្រាស់កម្មវិធីនេះ។ សូមជ្រើសរើសចូលរួម ឬការជ្រើសរើសបន្ថែមដើម្បីបន្ត។',
    selected: 'បានជ្រើសរើស',
    continue: 'បន្ត',
    open1: 'បើក',
    doubleClick: 'ចុចពីរដង',
    inputKeywordSearch: 'បញ្ចូលពាក្យគន្លឹះស្វែងរក',
    inputKeywordStartSearch: 'បញ្ចូលពាក្យគន្លឹះដើម្បីចាប់ផ្តើមស្វែងរក',
    searchHistory: 'ប្រវត្តិស្វែងរក',
    clearHistory: 'លុបប្រវត្តិ',
    notFoundRelatedResults: 'មិនឃើញលទ្ធផលពាក់ព័ន្ធ',
    switch: 'ប្ដូរ',
    searchProductionLine: 'ខ្សែផលិតកម្ម',
    selectProductionLine: 'ជ្រើសខ្សែផលិតកម្ម',
    rotateAngleTip: '{angle} បង្វិល',
    plankText: 'បន្ទះ',
    sendToEzSort: 'ផ្ញើទៅ EzSort',
    downloadEzSort: 'ទាញយក EzSort',
    notDownloadTip: 'បើ EzSort មិនអាចបើកបាន ប្រហែលអ្នកមិនទាន់ទាញយក សូមចុចប៊ូតុងខាងក្រោមដើម្បីទាញយក',
    updateTip: 'រកឃើញការអាប់ដេតកម្មវិធី សូមចាប់ផ្តើមឡើងវិញ',
    betaTest: 'ឥតគិតថ្លៃក្នុងអំឡុងពេលសាកល្បង',
    ersortSpecail: 'សម្រាប់តែស្លាកពណ៌',
    exclusiveFeature: 'មុខងារផ្តាច់មុខ',
    elementCanBeDragTip: 'ធាតុអាចអូសបាន',
    checkPlankIsConflict: 'កំពុងពិនិត្យស្ថានភាពផ្ទាំង',
    preferenceSaveErr: 'កំហុសក្នុងការរក្សាទុកការកំណត់ចំណូលចិត្ត',
    guimen: 'ទ្វារទូ',
    preferenceLoadTip: 'កំពុងផ្ទុកការកំណត់របស់អ្នក',
    preferenceLoadErrTip: 'បរាជ័យក្នុងការផ្ទុកការកំណត់ចំណូលចិត្ត សូមធ្វើឱ្យស្រស់ហើយព្យាយាមម្តងទៀត ដើម្បីជៀសវាងការកំណត់មិនត្រឹមត្រូវ!',
    localFileIsBeingWrite: 'កំពុងសរសេរឯកសារក្នុងម៉ាស៊ីន',
    unnamedFile: 'ឯកសារគ្មានឈ្មោះ',
    taskMonitor: 'តាមដានភារកិច្ច',
    downloadByType: '{type} ធ្វើចំនុច',
    slotKnifeErr: 'ខ្វះមុខកាត់ដំណើរការរយៈស្នឹង សូមពិនិត្យការកំណត់ខ្សែផលិតកម្ម! 【{msg}】',
    anewChooseCatalog: 'ជ្រើសថតឡើងវិញ',
    downloadSetting: 'ទាញយកការកំណត់',
    attention: 'សូមចំណាំ',
    unit: 'ដុំ',
    defaultUse: 'ប្រើលំនាំដើម',
    defaultChooseUse: 'ជ្រើសលំនាំដើម',
    requestFail: 'សំណើបរាជ័យ',
    downloadDoneByType: '{type} ធ្វើចំនុច',
    sysTip: 'ការជូនដំណឹងប្រព័ន្ធ',
    pleaseChoose: 'សូមជ្រើសរើស',
    confirmDelete: 'បញ្ជាក់ការលុប',
    notDataTipByType: 'មិនមានទិន្នន័យទេ សូម {msg} ជាមុន',
    paginationTotalTip: '{current}-{page} / {total} គតិ',
    chooseAmountData: '{number} គតិទិន្នន័យតែងតែបានជ្រើសរើស',
    moreOperate: 'ចាប់ផ្តើម',
    transferByType: '{type} ធ្វើចំនុច',
    clickCopy: 'ចុចដើម្បីចម្លង {type}',
    currentLine: 'ជួរបច្ចុប្បន្ន',
    remark: 'កំណត់ចំណាំ',
    customFunction: 'មុខងារតាមតម្រូវការ',
    limitedTimeTrial: 'Limited Free',
    startDate: 'កាលបរិច្ឆេទចាប់ផ្តើម',
    endDate: 'កាលបរិច្ឆេទបញ្ចប់',
    startTime: 'ម៉ោងចាប់ផ្តើម',
    endTime: 'ម៉ោងបញ្ចប់',
    lastMonth: 'ខែចុងក្រោយ',
    lastSixMonth: 'ប្រាំមួយខែចុងក្រោយ',
    lastYear: 'ឆ្នាំចុងក្រោយ',
    searchByType: '{type} ធ្វើចំនុច',
    addTime: 'ពេលវេលាបន្ថែម',
    startArrange: 'ចាប់ផ្តើមរៀបចំ',
    select: 'ជ្រើសរើស',
    search: 'ធ្វើចំនុច',
    name: 'ឈ្មោះ',
    plankNo: 'ផ្ទះបានជ្រើសរើស',
    plankName: 'ផ្ទះបានជ្រើសរើស',
    orderNo: 'លេខការបញ្ជាទិញ',
    order: 'ការបញ្ជាទិញ',
    partNameWithoutRoomCabinet: 'ឈ្មោះបន្ទះ (មិនរួមបន្ទប់/ទូ)',
    plankRemark: 'កំណត់ចំណាំផ្ទាំង',
    room: 'បន្ទប់',
    orderAddress: 'អាសយដ្ឋានគម្រោង',
    matCode: 'សម្ភារៈ',
    matCode2: 'សម្ភារៈ',
    plankMatCode: 'សម្ភារៈផ្ទាំង',
    count: 'ចំនួន',
    customer: 'អតិថិជន',
    customerInfo: 'ព័ត៌មានអតិថិជន',
    factoryOrderNo: 'លេខបញ្ជារោងចក្រ',
    roomName: 'ឈ្មោះបន្ទប់',
    color: 'ពណ៌',
    plankColor: 'ពណ៌ផ្ទាំង',
    plankThick: 'កម្រាស់ផ្ទាំង',
    plankHighGloss: 'លក្ខណៈពន្លឺខ្ពស់',
    thick: 'កម្រាស់',
    front: 'ផ្ទៃមុខ',
    back: 'ផ្ទៃខាងក្រោយ',
    slot: 'រយៈស្នឹង',
    hole: 'រន្ធ',
    hsInfo: '{hole} ផ្ទុកការកំណត់របស់អ្នក',
    diameter: 'អង្កត់ផ្ចិត',
    finishedWidth: 'ទទឹងផលិតផ្សារ',
    finishedHeight: 'បណ្តោយផលិតផ្សារ',
    finishedArea: 'ផ្ទៃផលិតផ្សារសំរេច (㎡)',
    remarks: 'ការពិពាហ្ឋដំណឹង',
    remark1: 'ការពិពាហ្ឋដំណឹង 1',
    remark2: 'ការពិពាហ្ឋដំណឹង 2',
    remark3: 'ការពិពាហ្ឋដំណឹង 3',
    remark4: 'ការពិពាហ្ឋដំណឹង 4',
    remark5: 'ការពិពាហ្ឋដំណឹង 5',
    remark6: 'ការពិពាហ្ឋដំណឹង 6',
    remark7: 'ការពិពាហ្ឋដំណឹង 7',
    remark8: 'ការពិពាហ្ឋដំណឹង 8',
    remark9: 'ការពិពាហ្ឋដំណឹង 9',
    remark10: 'ការពិពាហ្ឋដំណឹង 10',
    remark11: 'ការពិពាហ្ឋដំណឹង 11',
    remark12: 'ការពិពាហ្ឋដំណឹង 12',
    remark13: 'ការពិពាហ្ឋដំណឹង 13',
    remark14: 'ការពិពាហ្ឋដំណឹង 14',
    remark15: 'ការពិពាហ្ឋដំណឹង 15',
    remark16: 'ការពិពាហ្ឋដំណឹង 16',
    texture: 'វាល',
    normal: 'វាលបញ្ឈរ',
    reverse: 'វាលផ្ដេក',
    notCare: 'គ្មានវាល',
    holeSlotsStastic: 'ចំនួនរន្ធនិងរយៈស្នឹង',
    edge: {
      title: 'រុំគែម',
      info: 'ព័ត៌មានរុំគែម',
      front: 'រុំគែមខាងមុខ',
      back: 'រុំគែមខាងក្រោយ',
      left: 'រុំគែមខាងឆ្វេង',
      right: 'រុំគែមខាងស្តាំ',
      up: 'រុំគែមខាងលើ',
      down: 'រុំគែមខាងក្រោម'
      },
    isSpecial: 'រាងពិសេស',
    notSpecial: 'មិនមែនរាងពិសេស',
    textOfDoorPlank: 'បន្ទះទ្វារ',
    textOfNotDoorPlank: 'បន្ទះមិនមែនទ្វារ',
    isDoorPlank: 'បន្ទះទ្វារ',
    notDoorPlank: 'មិនមែនបន្ទះទ្វារ',
    width: 'ទទឹង',
    long: 'បណ្តោយ',
    plankWidth: 'ទទឹងផ្ទាំង',
    plankHeight: 'បណ្តោយផ្ទាំង',
    shortLong: 'បណ្តោយជ្រុងខ្លី',
    shortWidth: 'ទទឹងជ្រុងខ្លី',
    plankShape: 'រាងផ្ទាំង',
    detail: 'ព័ត៌មានលម្អិត',
    cancel: 'បោះបង់',
    confirm: 'បញ្ជាក់',
    alreadyKnow: 'ខ្ញុំបានដឹងហើយ',
    Noprompts: 'កុំបង្ហាញទៀត',
    deep: 'ជម្រៅ',
    other: 'ផ្សេងៗ',
    heighGloss: 'ពន្លឺខ្ពស់',
    heighGlossPlank: 'ផ្ទាំងពន្លឺខ្ពស់',
    heighGlossSide: 'ផ្ទាំងពន្លឺខ្ពស់',
    notHeighGloss: 'មិនមែនពន្លឺខ្ពស់',
    notHeighGlossPlank: 'មិនមែនផ្ទាំងពន្លឺខ្ពស់',
    saveSuccess: 'រក្សាទុកជោគជ័យ',
    deleteSuccess: 'លុបជោគជ័យ',
    addSuccess: 'បន្ថែមជោគជ័យ',
    editSuccess: 'កែប្រែជោគជ័យ',
    engraving: 'ម៉ាស៊ីនចាក់រូប',
    electronicSaw: 'រណាអេឡិចត្រូនិច',
    glassEquip: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    labelingMachine: 'ម៉ាស៊ីនបិទស្លាក',
    copy: 'ចម្លង',
    paste: 'បិទភ្ជាប់',
    undo: 'មិនធ្វើវិញ',
    move: 'ផ្លាស់ទី',
    PTP: 'PTP',
    dock56FDrill: 'ម៉ាស៊ីនខ្នាត 5/6 ផ្នែក',
    sideHoleDrill: 'ម៉ាស៊ីនរន្ធចិញ្ចឹម',
    combination: 'ឧបករណ៍បន្សំ',
    integration: 'ម៉ាស៊ីនរួមបញ្ចូល',
    standardPlank: 'ផ្ទាំងធំស្តង់ដារ',
    standardMaterial: 'សម្ភារៈស្តង់ដារ',
    standardMaterialTip: '',
    specialMaterial: 'សម្ភារៈពិសេស',
    specialPlank: 'បន្ទះពិសេស',
    singlePlank: 'ផ្ទៃបាតមួយ',
    previous: 'មុន',
    plankInfo: 'ព័ត៌មានលម្អិតឥតធំ',
    moreResult: 'ដំណោះស្រាយលេអូតបន្ថែម',
    moreResultTip: 'មានរន្ទះសម្រាប់ដំណើរការគែមលើបន្ទះធំ បន្ទះធំហើយនឹងមិនចូលរួមក្នុងការរៀបចំឡើងវិញទេ',
    ok: 'បញ្ជាក់',
    dispersePaibanTip: 'បានរកឃើញបន្ទះធំប 일부មិនអាចរៀបចរបាន សូមកែតម្រូវដោយដៃ ឬប្ដូរផែនការរៀបចំ ដើម្បីទប់ស្កាត់បញ្ហា!',
    next: 'បន្ទាប់',
    rate: 'អត្រាការប្រើប្រាស់',
    paibanBatch: 'ចុងក្រុមឡេអូត',
    return: 'ត្រលប់',
    FGNo: 'លេខកិច្ចសន្យា',
    refresh: 'ធ្វើឱ្យទាន់សម័យ',
    inde: 'លេខស៊េរី',
    productionLine: 'ខ្សែផលិត',
    operation: 'ប្រតិបត្តិការ',
    colorPlaceHolder: 'ចុច Enter ដើម្បីបង្កើតកាតពណ៌',
    saveAndContinue: 'រក្សាទុក និងបន្ត',
    reset: 'កំណត់ឡើងវិញ',
    check: 'សំណើ',
    inputPlaceholder: 'សូមបញ្ជូល',
    filter: 'លៃតម្រូវ',
    all: 'ទាំងអស់',
    exportPDF: 'នាំចេញ PDF',
    exportPic: 'នាំចេញរូបភាព',
    add: 'បន្ថែម',
    edit: 'កែសម្រួល',
    delete: 'លុប',
    restore: 'បង្រៀនម្តងទី២',
    save: 'រក្សាទុក',
    saveSetting: 'រក្សាទុកការកំណត់',
    isHeightGloss: 'សូមជ្រើសរើសថាជាបន្ទះពន្លឺខ្ពស់ឬអត់',
    noSync: 'មិនបានសមកាលកម្ម',
    sync: 'សមកាលកម្ម',
    formatSuccess: '{type} ជោគជ័យ',
    dataLoading: 'ទិន្នន័យកំពុងផ្ទុក...',
    warmTip: 'ការរំលឹក',
    importantTip: 'ការរំលឹកសំខាន់',
    wellcome: 'សូមស្វាគមន៍មកកាន់ការរៀបចំក្នុងពពក',
    timeOut: 'រៀបចំហួសម៉ោង តើចង់រៀបចំឡើងវិញទេ?',
    notSawKnifeTip: 'សូមចំណាំ៖ ម៉ាស៊ីនចាក់រូបកាត់ដោយរណាមិនបានកំណត់ «ក្បាលរណាកាត់ទទឹង» ទើបមិនអាចរៀបចំបាន សូមទៅបន្ថែម!',
    doorFrameKnifeRadiusErr: 'អ្នកបានបើកមុខងារ «ម៉ាស៊ីនចាក់រូបកាត់ដោយរណា-កាត់ស៊ុមទ្វារ» កាំបិទកាត់មានកាំរយៈក្រោយធំជាងក្រាស់រណា មិនអាចរៀបចំបាន!',
    doorFrameIrregularPlankErr: 'អ្នកបានបើកមុខងារ «ម៉ាស៊ីនចាក់រូបកាត់ដោយរណា-កាត់ស៊ុមទ្វារ» មុខងារនេះមិនទាន់គាំទ្រការរៀបចំបន្ទះរាងមិនប规则ទេ!',
    warning: 'ការព្រមាន',
    export: 'នាំចេញ',
    mark: 'សម្គាល់',
    noMark: 'កុំសម្គាល់',
    sawArrange: 'ការរៀបចំកាត់ដោយក្រុម',
    directArrange: 'ការ​បោះពុម្ព​ផ្ទាល់',
    area: 'ផ្ទៃ',
    plankNum: 'លេខកូដរបារ​បន្ទះ',
    loc: 'ទូ',
    cutHeight: 'ប្រវែងកាត់',
    cutWidth: 'ទទឹងកាត់',
    defaultProduction: 'ខ្សែផលិតលំនាំដើម',
    surplusNum: 'លេខកូដបាក់ទុក',
    tip: 'ដំបូន្មាន',
    history: 'ប្រវត្តិ',
    hinge: 'រន្ទះបង្វិល',
    hingeScrew: 'រន្ទះណែនាំកៅស៊ូទ្វារ',
    CCPXHole: 'រន្ទះអិកសង់ទ្រិកបីក្នុងមួយ',
    stretchHinge: 'រន្ធស្លុត និង រន្ធពែងចង្កៀង',
    stretch: 'ឧបករណ៍ដោះស្មោះ',
    stretcher: 'រន្ធស្លុត',
    eccHole: 'រន្ធមុំអ៊ីសង់ត្រិច',
    preHole: 'រន្ធដាក់មុន',
    clothole: 'រន្ធដាក់ទ្រនាប់សម្លៀកបំពាក់',
    backPlank: 'រន្ធស្លុតផ្ទាំងខាងក្រោយ',
    ALS: 'រន្ធទាញលាក់',
    doorSlot: 'រន្ធស្លុតលោហៈទ្វារ',
    drawerSlot: 'រន្ធស្លុតដ្រាវហ្វ',
    lkSlot: 'រន្ធស្លុតចាក់សោ',
    KC: 'រន្ធដាក់ខោ',
    stealth: 'ឧបករណ៍មិនឃើញ',
    lightSlot: 'រន្ធស្លុតពន្លឺ',
    ConventionalHole: 'រន្ធសាធារណៈ',
    Keyhole: 'រន្ធសោ',
    allHole: 'រន្ធទាំងអស់នៅលើក្តារឯកទេស',
    allSlot: 'រន្ធស្លុតទាំងអស់នៅលើក្តារឯកទេស',
    freedomAllHoleSlot: 'រន្ធទាំងអស់នៅលើក្តារឯកទេសជាមួយនឹង រន្ធទាំងអស់នៅលើក្តារឯកទេស',
    freedomAllHoleSlotTip: 'ក្តារឯកទេស: ក្តារឯកទេសដែលមានកម្ពុជាមិនជាបឋម',
    millInfo: 'ចំណុចឡើងលើដៃ',
    haiTang: 'ជ្រុងឈាមក្ដៅ',
    FSDrill: 'ម៉ាស៊ីនដោះលក់ប្រាំ/ប្រាំមួយមុខ',
    engraving2: 'ម៉ាស៊ីនឆ្លាក់',
    xyReverse: 'ការផ្លាស់ប្តូរអ័ក្ស XY',
    autoXYReverse: 'រន្ធស្លុតទាំងអស់នៅលើក្តារឯកទេស',
    autoXYReverseTip: 'ម៉ាស៊ីនដោះលក់ប្រាំ/ប្រាំមួយមុខ និងម៉ាស៊ីនដោះលក់ប្រាំមួយមុខតាមសាកល្បងតាមអ័ក្ស XY នៃម៉ាស៊ីនដោះលក់ប្រាំមួយមុខ',
    autoXYReverseTip2: 'PTP មិនបានជោគជ័យ',
    xyReverseTip: 'មុខងារផ្លាស់ប្តូរអ័ក្ស XY មិនឥឡូវដែលឆបគ្នាជាមួយនឹងការដាក់정確នៃគម្រោងលើសនៃរូបធាតុ L ទេ សូមប្រើប្រាស់ដោយប្រុងប្រយ័ត្ន',
    rect: 'ចតុកោណកែង',
    Ltype: 'រាង L',
    archive: 'ឯកសារ',
    tellPlaceholder: 'សូមបញ្ចូលលេខទូរស័ព្ទ',
    knivesStore: 'ឃ្លាំងកាំបិត',
    roll: 'សន្លឹកដែលលាក់',
    pause: 'ផ្អាក',
    editTrans: 'កែប្រែលើកលែង',
    translateManager: 'អ្នកគ្រប់គ្រងលើកលែង',
    grating: 'ឈាលលំនាប់',
    addressEditErr: 'ការកែប្រែលម្អាងគម្រោងមិនត្រូវបានគាំទ្របន្ថែមទៀតម្សចនៃលេខគណនាចាប់ផ្តើម',
    customerEditErr: 'ការកែប្រែលឿនឹងក្នុងលក្ខណៈច្រើនលេខ តម្លៃគាត់មិនត្រូវបានគាំទ្ដ្បា',
    factoryEditErr: 'ការកែប្រែលេខលំដាប់រោងចក្រមិនត្រូវបានគាំទ្បឌើនលេខគណនា',
    roomNameEditErr: 'ការកែប្រែលេខឈ្មោះបន្ទប់មិនត្រូវបានគាំទ្បឌើនលេខគណនា',
    remarkEditErr: 'ការកែប្រែលេខទីភ្នាក់ងារមិនត្រូវបានគាំទ្ដួលលេខគណនា',
    toMaterialList: 'ទៅបញ្ជីសម្ភារ',
    deleteFail: 'ការលុបបាត់មិនបានជោគជ័យ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!',
    batchRestore: 'ស្តារឡើងវិញជាបង្គុំ',
    batchDelete: 'លុបបាត់ជាបង្គុំ',
    workShop: 'ផលិតកម្មកម្មន្តិក',
    FGAdrress: 'អាសយដ្ឋានគម្រោង/លេខសន្យា',
    cuttingSize: 'ទំហំកង្កាប់',
    finishedSize: 'ទំហំផលិតផលដែលបានបញ្ចប់',
    labelImg: 'រូបភាពស្លាក',
    layoutImg: 'គ្រោងលម្អាងរូបមន្ត',
    file: 'ឯកសារ',
    folder: 'ឯកសារ',
    reName: 'ផ្លាស់ប្តូរឈ្មោះ',
    to: 'ដល់',
    plankUnit: 'សន្លឹក',
    tagTemp: 'គំរូស្លាក',
    roomRemark: 'កំណត់ចំណាំបន្ទប់',
    noModificationPermission: 'គ្មានការអនុញ្ញាតកែប្រែ',
    modificationRecord: 'ឯកសារកែប្រែ',
    page: 'ទំព័រ',
    strip: 'ផ្នែក',
    jump: 'លោត',
    freeAgreement: 'កិច្ចព័ន្ធនានyal់លើផ្នែកទ責',
    preStep: 'ជំហានមុន',
    nextStep: 'ជំហានបន្ទាប់',
    upload: 'ផ្ទុកឡើង',
    uploading: 'កំពុងផ្ទុកឡើង',
    iAgree: 'ខ្ញុំយល់ព្រម',
    pleaseSelectPlank: 'សូមជ្រើសរើសក្តារយ៉ាងតិច១',
    saveToStoreTip: 'សូមជ្រើសរើសយ៉ាងតិច១ផ្នែកដែលមិនបានកាត់',
    fileIsNotExist: 'ឯកសារមិនមាន',
    selectAll: 'ជ្រើសរើសទាំងអស់',
    pdfTag: 'ស្លាក PDF',
    tagImage: 'រូបភាពស្លាក',
    guigui: 'Guigui',
    gratingSlot: 'របៀងលំនាប់ក្រឡា',
    deleteTip: 'បន្ទាប់ពីលុបទិន្នន័យនេះ វាមិនអាចបានស្ដារឡើងវិញ តើលុបទិន្នន័យនេះដែរឬទេ?',
    deleteError: 'ក្រុមហ៊ុនដែលមិនស្គាល់បានកើតឡើង និងលុបបាត់មិនបានជោគជ័យ',
    cancelDelete: 'ការលុបបាត់ត្រូវបានលុបចោល',
    confirmDeleteTip: 'បន្ទាប់ពីលុបក្ដារនឹងចូលក្នុង "ក្ដាររង់ចាំចងក្រងនៅលើវេទិកា - មិនបានរក្សាទុក" តើលុបទិន្នន័យដែរឬទេ?',
    confirmDeleteBujianTip: 'បន្ទាប់ពីលុប ផ្នែកនឹងត្រូវបានបញ្ចូលទៅក្នុង "បណ្ណាល័យផ្នែក" តើអ្នកបញ្ជាក់ការលុបទិន្នន័យដែរឬទេ?',
    confirmSureDeleteTip: 'បង្ហាញថារូបរាងដែលរង់ចាំមានក្ដារតូចដែលមានលក្ខណៈដូចគ្នា ដូច្នេះលុបក្ដារធំរឹងឹងនេះដែរឬទេ?',
    deleteEmptyTip: 'តើលុបក្ដារធំនេះដែរឬទេ?',
    notCanDelete: 'ឧបករណ៍ដែលនៅសល់បង្ហាញមិនគាំទ្ដាច្ចុပ្បន្នដ្ឋាននោះទេ',
    new: 'New',
    innerBluneFailure: 'ការរៀបចំដែលបង្កប់ក្នុងពពក មិនដំណើរការលើមុខងារនេះទេ',
    deleteBigPlankTip: 'នៅលើក្ដារធំចុងក្រោយមានក្ដារតូច មិនអាចលុបបានទេ!',
    continueExport: 'មិនអើពើ ហើយបន្តផ្នែកលទ្ធផល',
    toCheck: 'ទៅពិនិត្យ',
    pleaseCheck: 'លទ្ធផលប្លង់បច្ចុប្បន្នមានការប៉ះទង្គិចរន្ធ-រន្ធស្លុត/បន្ទះតូចហោះចេញ/ជម្រៅមិនប្រក្រតី សូមពិនិត្យ!',
    clampHandCheck: 'បានរកឃើញថារន្ធ និងស្លុតលើបន្ទះខ្លះៗរបស់អ្នកមិនអាចជៀសវាងទីតាំងក្ដាប់បានទេ សូមកែសម្រួលដោយដៃ',
    conflictPartDetail: 'ព័ត៌មានលម្អិតនៃបន្ទះដែលប៉ះទង្គិច',
    colorNotUndefined: 'ពណ៌មិនអាចទទេបានទេ',
    materialNotUndefined: 'សម្ភារៈមិនអាចទទេបានទេ',
    newSetting: 'មុខងារថ្មី',
    downImageErrTip: 'នាំចេញរូបភាពបរាជ័យ ពីព្រោះបានបើកការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅកាន់ថតផ្សេងៗ ដូច្នេះត្រូវជ្រើសស្លាកបន្ទះតូចនាំចេញជាមួយគ្នា',
    downNcErrTip: 'ទាញយក NC បរាជ័យ ពីព្រោះបានបើកការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅកាន់ថតផ្សេងៗ ដូច្នេះត្រូវជ្រើសស្លាកបន្ទះតូចនាំចេញជាមួយគ្នា',
    downNcErrTipForSurFolder: 'ទាញយក NC បរាជ័យ ការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅថតផ្សេងៗ និងការកំណត់ឯកសារបន្ទះធំសំណល់ មិនអាចបើកក្នុងពេលតែមួយបានទេ',
    yes: 'បាទ',
    no: 'ទេ',
    checkColorPrint: 'បច្ចុប្បន្នបានបើកស្លាកពណ៌ហើយ សូមប្រើម៉ាស៊ីនបោះពុម្ពពណ៌ដើម្បីបោះពុម្ព~',
    colorRules: 'បន្ទាប់ពីបើកការបង្កើតស្លាកពណ៌ ការបញ្ជាទិញ/បន្ទប់/ទូ/បន្ទះទ្វារ នឹងត្រូវបែងចែកតាមពណ៌។ បច្ចុប្បន្ន ស្លាកពណ៌សម្រាប់ទិន្នន័យប្រភេទដូចគ្នា គាំទ្របានអតិបរមា 12 ហើយច្បាប់លម្អិតមានដូចខាងក្រោម៖',
    greyPart: 'ផ្នែកពណ៌ប្រផេះក្នុងស្លាកខាងស្តាំគឺ',
    region: 'តំបន់',
    notSame: 'តំបន់ {regionName} ខុសៗគ្នា មានពណ៌ខុសគ្នា',
    doorTip: 'ពណ៌ប្រផេះជាបន្ទះទ្វារ ពណ៌សជាបន្ទះមិនមែនទ្វារ',
    exist: 'មាន',
    limitNotEffect: 'ប្រសិនបើទិន្នន័យលើស 12 ស្លាកពណ៌នឹងមិនមានប្រសិទ្ធភាពទេ',
    hoverTip: 'រូបភាពបច្ចុប្បន្នមានកន្ទុយឯកសារ bmp ទ្រង់ទ្រាយកូដជាសខ្មៅ ហើយមិនអាចបង្កើតរូបភាពស្លាកពណ៌បានទេ',
    lock: 'ចាក់សោ',
    unlock: 'ដោះសោ',
    batchLock: 'ចាក់សោ/ដោះសោជាក្រុម',
    surplusLock: 'ចាក់សោសំណល់សម្ភារៈ',
    surplusUnlock: 'ដោះសោសំណល់សម្ភារៈ',
    is: 'បាទ',
    not: 'ទេ',
    savingHistory: 'កំពុងរក្សាទុកឯកសារប្រវត្តិ',
    saveHistorySuccess: 'រក្សាទុកឯកសារប្រវត្តិដោយជោគជ័យ',
    saveHistoryFail: 'រក្សាទុកឯកសារប្រវត្តិបរាជ័យ',
    bw: 'តើត្រូវនាំចេញស្លាកសខ្មៅឬទេ',
    modular: 'ទូឯកតា',
    autoAdjust: 'កែសម្រួលដោយស្វ័យប្រវត្តិ',
    cutOrderTip: 'បានរកឃើញកំហុសក្នុងលំដាប់កាត់របស់【បន្ទះធំទី {errorCutOrdersString}】! សូមកែសម្រួលសិន រួចទើបទាញយកឯកសារ NC',
    lockedCutOrderTip: '【បន្ទះធំទី {errorCutOrdersString}】ត្រូវបានចាក់សោ សូមទៅកែប្រែដោយដៃ',
    paibanImgCutOrderTip1: 'របស់អ្នក',
    paibanImgCutOrderTip: 'មានកំហុសក្នុងលំដាប់កាត់! សូមទៅកាន់ទំព័រប្លង់ ដើម្បីកែសម្រួលសិន ហើយបន្ទាប់មកនាំចេញឯកសាររូបភាពប្លង់',
    goAdjust: 'ទៅកែសម្រួល',
    autoAdjustWarning: 'លទ្ធផលប្លង់បច្ចុប្បន្នមិនគាំទ្រការកែសម្រួលដោយស្វ័យប្រវត្តិទេ',
    checkNetwork: 'សូមពិនិត្យបណ្តាញ',
    moreInfo: 'មើលព័ត៌មានបន្ថែម',
    continueLayout: 'បន្តប្លង់',
    adjustPosition: 'កែសម្រួលការកំណត់',
    specialAndFiveSix: 'នៅពេលកែច្នៃបន្ទះរាងពិសេសដោយប្រើការខួងប្រាំ/ប្រាំមួយមុខ ការបើក nested រាងពិសេសអាចបណ្តាលឱ្យកាត់ទៅលើបន្ទះបាន។ សូមបញ្ជាក់ថាតើត្រូវបន្តប្លង់ឬទេ?',
    plankPathErr: 'ទិន្នន័យរាងពិសេសខាងក្នុងបន្ទះមានកំហុស សូមពិនិត្យថាតើសមនឹងលក្ខណៈបច្ចេកទេសឧបករណ៍ឬទេ! លេខបន្ទះ【{plankIDList}】',
    edgeCheck: 'ប្រព័ន្ធបានរកឃើញថាការកាត់ជ្រុងរបស់បន្ទះធំត្រូវបានកែប្រែ សូមប្លង់ឡើងវិញ ដើម្បីធានាភាពត្រឹមត្រូវក្នុងការផលិត',
    iKnow: 'ខ្ញុំយល់ហើយ',
    versionErrTip: 'សូមធ្វើបច្ចុប្បន្នភាព Guigui ទៅកំណែចុងក្រោយបំផុត!',
    annualFeeExpired: 'ថ្លៃប្រចាំឆ្នាំរបស់អ្នកបានផុតកំណត់ សូមបន្តបង់!',
    holeEquipment: 'ឧបករណ៍ខួង {num}',
    customizedService: 'គាំទ្រសេវាកម្មប្ដូរតាមតម្រូវការ ដើម្បីបង្កើតផែនការផលិតផ្ទាល់ខ្លួនរបស់អ្នក',
    exampleCombination1: 'ការរួមបញ្ចូលម៉ាស៊ីនឆ្លាក់ + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ + ម៉ាស៊ីនរន្ធចំហៀង',
    exampleCombination2: 'ការរួមបញ្ចូលម៉ាស៊ីនកាត់អេឡិចត្រូនិក + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ + ម៉ាស៊ីនរន្ធចំហៀង',
    exampleCombination3: 'ការរួមបញ្ចូលខ្សែផលិតកម្មស្វ័យប្រវត្តិពេញលេញ + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ',
    feedback: 'អ្នកអាចផ្តល់តម្រូវការរបស់អ្នកដោយផ្ទាល់ទៅបុគ្គលិកផ្នែកលក់ ឬបន្ទាប់ពីលក់របស់កម្មវិធី Guigui',
    markModifiedBoards: 'សម្គាល់បន្ទះតូចដែលបានកែប្រែ',
    showMoveStep: 'កែប្រែការវិញ្ញាណិតការផ្លាស់ប្តូរ',
    moveStep: 'ការផ្លាស់ប្តូរការវិញ្ញាណិត',
    existChangeBoards: 'មានបន្ទះតូចដែលមានការផ្លាស់ប្តូរ',
    crossMaterialBoard: 'ក្តារឆ្លងសម្ភារៈពណ៌',
    skipCrossMaterialTip: 'មិនបង្ហាញម្តងទៀតក្នុងការរៀបចំនេះ',
    crossMaterialConfirmTip: 'អ្នកកំពុងផ្លាស់ទីក្តារតូចឆ្លងកាត់សម្ភារៈឬពណ៌ខុសគ្នា។ {highlight} បន្ត?',
    crossMaterialConfirmTipHighlight: 'ក្តារដែលផលិតអាចមិនត្រូវនឹងការបំបែកការបញ្ជាទិញ',
    exportHoleSlotPDF: 'នាំចេញគំនូសរន្ធ និងស្លុត',
    pdfFormat: 'ទ្រង់ទ្រាយ PDF',
    dxfFormat: 'ទ្រង់ទ្រាយ DXF',
    specialShapeKnivesInfo: 'ការជូនដំណឹងជ្រើសរើសកាំបិតរាងពិសេស',
    specialShapeKnivesInfoTips: 'បន្ទះទី {stockNum}:',
    specialShapeKnivesInfoTips2: 'បានបើកការជ្រើសរើសឧបករណ៍កាត់រាងពិសេសដោយស្វ័យប្រវត្តិ ទិន្នន័យប្លង់មានភាពមិនប្រក្រតី សូមប្លង់ឡើងវិញពីបញ្ជីកាត់ ឬបិទមុខងារជ្រើសរើសឧបករណ៍កាត់ស្វ័យប្រវត្តិសម្រាប់រាងពិសេស',
    default: 'លំនាំដើម',
    exportLanguage: 'ភាសានាំចេញ',
    exportLanguageTip: 'ចំណាំ៖ ខ្លឹមសារអត្ថបទខ្លះ មិនអាចបកប្រែបាននៅពេលនាំចេញជា PDF',
    highGlossNameTip: 'បន្ទះរលោងខ្ពស់ដែលសមកាលកម្មពីទូ អាចត្រូវបានពិពណ៌នាដោយអត្ថបទផ្សេងៗ ដោយមិនប៉ះពាល់ដល់លក្ខណៈរលោងរបស់វា',
    mixPaibanPlanSetting: 'ការកំណត់ផែនការប្លង់ចម្រុះ',
    mixPaibanPlanSettingTip: 'ប្រព័ន្ធបានរកឃើញថាការកំណត់ផែនការប្លង់ចម្រុះបានផ្លាស់ប្តូរ សូមជ្រើសផែនការប្លង់ចម្រុះសម្រាប់លើកនេះឡើងវិញ!',
    mixPaibanPlanSettingOk: 'កំណត់ផែនការប្លង់ចម្រុះ',
    mixPaibanPlanSettingCancel: 'ទេ ប្លង់ដោយផ្ទាល់',
    noMixPaibanPlan: 'មិនមានផែនការប្លង់ចម្រុះដែលអាចប្រើបានទេ',
    mixColors: 'ពណ៌ចម្រុះ',
    mixPai: 'ប្លង់ចម្រុះ',
    plan: 'ផែនការ',
    mixPaibanTitle: 'ដាក់បន្ទះតូចពណ៌ខុសៗគ្នារួមគ្នា',
    mixColorsTip: 'អ្នកអាចកំណត់ថាបន្ទះពណ៌ណាខ្លះអាចត្រូវបានផលិតជាពណ៌តែមួយនៅលើបន្ទះធំតែមួយ ដោយមិនផ្លាស់ប្តូរព័ត៌មានពណ៌ដើមរបស់បន្ទះឡើយ',
    mixColorsTip2: 'បន្ទាប់ពីបន្ថែមផែនការ ត្រូវបើកវានៅក្នុងបញ្ជីកាត់ ទើបមានប្រសិទ្ធភាព',
    mixColorsTip3: 'មុខងារបិទគែមពណ៌ខុសមានការប៉ះទង្គិច ដូច្នេះបច្ចុប្បន្នមិនអាចមានប្រសិទ្ធភាពជាមួយគ្នាបានទេ',
    mixErrTip: 'ផែនការប្លង់ចម្រុះខ្វះធាតុចាំបាច់ សូមពិនិត្យ',
    addPlan: 'បន្ថែមផែនការ',
    chooseMatcode: 'ជ្រើសសម្ភារៈ',
    chooseColor: 'ជ្រើសពណ៌',
    defineColor: 'កំណត់ពណ៌ដែលបានជ្រើសជា',
    confirmDeletePlan: 'តើអ្នកប្រាកដជាចង់លុបផែនការនេះមែនទេ',
    trimmingMethod: 'វិធីកាត់ជ្រុង',
    followStandardTrim: 'អនុវត្តតាមតម្លៃកាត់ជ្រុងរបស់បន្ទះស្តង់ដារនៅក្នុងបន្ទះដើម',
    trimToast: 'ចំណាំ៖ អ្នកកំពុងប្រើមុខងារកាត់ជ្រុងផ្ទាល់ខ្លួនសម្រាប់សំណល់សម្ភារៈ ដូច្នេះអាចជ្រើសបានតែប្លង់កាត់ដោយម៉ាស៊ីនអារប៉ុណ្ណោះ',
    individualTrimValue: 'កំណត់តម្លៃកាត់ជ្រុងដោយឡែក',
    topTrimEmptyToast: 'តម្លៃកាត់ជ្រុងខាងលើមិនអាចទទេបានទេ!',
    bottomTrimEmptyToast: 'តម្លៃកាត់ជ្រុងខាងក្រោមមិនអាចទទេបានទេ!',
    leftTrimEmptyToast: 'តម្លៃកាត់ជ្រុងខាងឆ្វេងមិនអាចទទេបានទេ!',
    rightTrimEmptyToast: 'តម្លៃកាត់ជ្រុងខាងស្តាំមិនអាចទទេបានទេ!',
    topTrimBlurToast: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងលើ',
    bottomTrimBlurToast: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងក្រោម',
    leftTrimBlurToast: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងឆ្វេង',
    rightTrimBlurToast: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងស្តាំ',
    effectToast: '1. មុខងារកាត់ជ្រុងផ្ទាល់ខ្លួន មានប្រសិទ្ធភាពតែលើបន្ទះផ្សារប៉ុណ្ណោះ',
    defaultTrimSetting: 'ការកំណត់កាត់ជ្រុងលំនាំដើមសម្រាប់សំណល់សម្ភារៈ',
    enterHere: 'បញ្ចូលនៅទីនេះ',
    permissionTipExportDxf: 'នាំចេញដ្យាក្រាមប្រហោងឆ្អឹង DXF',
    permissionTipSurplusRecycleBin: 'ស្ថានីយ៍ប្រមូលផ្តុំសំណល់',
    permissionTipAdvancedNesting: 'ការរួមបញ្ចូលរូបរាងមិនទៀងទាត់កម្រិតខ្ពស់',
    permissionTipPanelGrainAlign: 'តម្រឹមមុនពង្រីកផ្ទាំង',
    permissionSeparator: ', ',
    missingPermissionTip: 'អវត្តមានសិទ្ធិដូចខាងក្រោម: {permissions}'
    },
  home: {
    head: {
      production: 'ការណែនាំផលិតផល',
      resolve: 'ដំណោះស្រាយ',
      about: 'អំពីពួកយើង',
      equipment: 'ឧបករណ៍',
      tell: 'ទូរស័ព្ទបណ្តឹង',
      enter: 'ចូលទៅកាន់ការរៀបប្លង់លើពពក'
      },
    swiper: {
      case1: {
        tag: 'កំណែអាប់ដេតថ្មី',
        subTitle: 'ខួរក្បាលឆ្លាតវៃរបស់ម៉ាស៊ីន',
        description: 'កម្មវិធីបង្កើនប្រសិទ្ធភាពការរៀបប្លង់អនឡាញលើពពក ដែលកំពុងផ្លាស់ប្តូរឧស្សាហកម្ម'
        },
      case2: {
        title: 'ការផលិតទូ',
        subTitle: 'នវានុវត្តន៍បច្ចេកវិទ្យា',
        description: 'គាំទ្រការតភ្ជាប់ជាមួយម៉ាស៊ីនបិទស្លាក ម៉ាស៊ីនកាត់ ម៉ាស៊ីនរន្ធចំហៀង PTP ប្រាំមុខ និងម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខជាច្រើនប្រភេទ'
        },
      case3: {
        title: 'ខួរក្បាលឧស្សាហកម្ម',
        subTitle: 'ដំណោះស្រាយ',
        description: 'ក្បួនដោះស្រាយរៀបប្លង់ឆ្លាតវៃ ធ្វើឱ្យអត្រាប្រើប្រាស់បន្ទះកាន់តែខ្ពស់'
        }
      },
    statistics: {
      today: 'បរិមាណប្លង់ថ្ងៃនេះ',
      toMounth: 'បរិមាណប្លង់ប្រចាំខែ',
      outturn: 'អត្រាទិន្នផល',
      cumulative: 'អ្នកប្រើប្រាស់សរុប'
      },
    intro: {
      title: 'កម្មវិធីរៀបប្លង់អនឡាញលើពពកកម្រិតសហគ្រាសសម្រាប់ទិន្នន័យធំ',
      subTitle: 'យល់ដឹងអំពីនិន្នាការឧស្សាហកម្ម ផ្តោតលើតម្រូវការអតិថិជន ពង្រឹងការប្រែប្រួលឌីជីថលរបស់សហគ្រាស ជំរុញការផ្លាស់ប្តូរឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹមអ៊ីនធឺណិតដោយស្វ័យប្រវត្តិ ហើយសម្រាប់សេណារីយ៉ូផលិតគ្រឿងសង្ហារឹមបន្ទះដែលមានស្រាប់ បានណែនាំក្បួនដោះស្រាយជំនួយដោយ AI ដើម្បីបន្តនាំមកនូវកំណើនថ្មីសម្រាប់សហគ្រាស',
      menue: {
        case1: {
          title: 'ការរៀបប្លង់អនឡាញ',
          subTitle: 'អាចរៀបប្លង់បានគ្រប់ពេល',
          description: 'មិនចាំបាច់ទាញយកកម្មវិធី អាចរៀបប្លង់បានគ្រប់ពេល ហើយអាចបញ្ជាពីចម្ងាយដោយមិនចាំបាច់ពឹងផ្អែកលើកុំព្យូទ័រ'
          },
        case2: {
          title: 'ការផលិតច្រើនខ្សែ',
          subTitle: 'ប្ដូរខ្សែផលិតកម្មយ៉ាងរហ័ស',
          description: 'គាំទ្រការកែច្នៃលឿនលើខ្សែផលិតកម្មជាច្រើនក្នុងពេលតែមួយ ហើយអាចប្ដូររវាងខ្សែផលិតកម្មបានយ៉ាងរហ័ស'
          },
        case3: {
          title: 'ការផលិតច្បាស់លាស់',
          subTitle: 'ការរៀបប្លង់លម្អិត និងការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត',
          description: 'ការរៀបប្លង់លម្អិត និងការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត ធ្វើឱ្យការផលិតបន្ទះកាន់តែត្រឹមត្រូវ'
          },
        case4: {
          title: 'ការផលិតតាមបំណង',
          subTitle: 'ស្លាកផ្ទាល់ខ្លួន ការខួងប្រាំ/ប្រាំមួយមុខ និងរាងសំណល់សម្ភារៈ',
          description: 'គាំទ្រស្លាកផ្ទាល់ខ្លួន ការខួងប្រាំ/ប្រាំមួយមុខផ្ទាល់ខ្លួន រាងសំណល់សម្ភារៈផ្ទាល់ខ្លួន និងការកែច្នៃដោយឧបករណ៍រួមបញ្ចូល'
          }
        }
      },
    fangan: {
      title: 'ដំណោះស្រាយវិជ្ជាជីវៈសម្រាប់ឧស្សាហកម្ម',
      subTitle: 'ចំណាយទាប តម្លៃផលិតកម្មខ្ពស់ ក្បួនដោះស្រាយឆ្លាតវៃបង្កើនអត្រាប្រើប្រាស់បន្ទះ សមស្របជាមួយកម្មវិធីរចនាជាច្រើន និងផ្តល់ផែនការផលិតល្អបំផុតដល់អ្នកប្រើប្រាស់',
      menue: {
        case1: {
          title: 'ការរួមបញ្ចូលការទទួលបញ្ជាទិញអនឡាញ និងការផលិត',
          description: 'ប្រតិបត្តិការអនឡាញពីចម្ងាយ ឆ្លងកាត់ឧបសគ្គផ្នែកលំហ អាចបញ្ជូនការបញ្ជាទិញទៅរោងចក្របានគ្រប់ពេល ហើយការរចនា និងការផលិតត្រូវបានបញ្ចប់ស្របពេលគ្នា'
          },
        case2: {
          title: 'ប្ដូរខ្សែផលិតកម្មដោយចុចម្តង',
          description: 'ខ្សែផលិតកម្មអាចប្ដូរតាមតម្រូវការ គាំទ្រខ្សែផលិតកម្មច្រើន និងការតភ្ជាប់ឧបករណ៍ច្រើនប្រភេទ'
          },
        case3: {
          title: 'ក្បួនដោះស្រាយឆ្លាតវៃបង្កើនអត្រាប្រើប្រាស់បន្ទះ',
          description: 'ក្បួនដោះស្រាយបុរាណមានអត្រាប្រើប្រាស់បន្ទះទាប ខណៈដែលក្បួនដោះស្រាយឆ្លាតវៃផ្តល់ការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត និងផែនការផលិតតាមបំណង'
          },
        case4: {
          title: 'ដំណោះស្រាយកាត់ជំនាញវិជ្ជាជីវៈ',
          description: 'បង្កើនប្រសិទ្ធភាពលំដាប់កាត់ និងចំណុចចាប់កាត់ ធ្វើឱ្យផ្លូវខ្លីជាងមុន និងការកាត់មានស្ថិរភាពជាងមុន'
          }
        }
      },
    aboutUs: {
      title1: 'បច្ចេកវិទ្យាលំនៅឋានមនុស្ស Xingeer',
      subTitle: 'អ្នកដឹកនាំការផ្លាស់ប្តូរនៃឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹម',
      description: 'សហគ្រាស Xingeer ផ្តោតលើការធ្វើឱ្យមានការប្រែប្រួលតាមអ៊ីនធឺណិតសម្រាប់ឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹមបុរាណ',
      culture: {
        case1: {
          title: 'គោលបំណងសហគ្រាស',
          subTitle: 'ជួយរោងចក្រឲ្យរីកចម្រើនបីដង'
          },
        case2: {
          title: 'តម្លៃវប្បធម៌',
          subTitle: 'ផ្តោតលើអតិថិជន យកអ្នកខិតខំប្រឹងប្រែងជាមូលដ្ឋាន ប្រឹងប្រែងយ៉ាងលំបាក និងផ្តល់អត្ថប្រយោជន៍ដល់ប្រជាជន'
          },
        case3: {
          title: 'គំនិតណែនាំ',
          subTitle: 'ប្រើប្រាស់ផ្លូវមហាជន ដើម្បីបង្កើតក្រុមឆ្នើមដែលមានសមត្ថភាពផ្នែកលក់ ផលិតផល និងការរៀបចំ'
          }
        },
      feature: {
        case1: 'ការថែទាំដោយក្រុមជំនាញ',
        case2: 'ការអាប់ដេត និងកែលម្អជាបន្តបន្ទាប់',
        case3: 'សេវាកម្មបន្ទាប់ពីលក់មួយទល់មួយ',
        case4: 'សេវាកម្មប្ដូរមុខងារ'
        }
      },
    cooperation: {
      title: 'សហការដោយស្មោះត្រង់ បង្កើតអនាគតរួមគ្នា',
      subTitle: 'ម៉ាកឧបករណ៍ដែលភ្ជាប់គ្របដណ្តប់ 90% នៃឧបករណ៍ដែលប្រើជាទូទៅក្នុងស្រុក ហើយមានពាណិជ្ជករ 107,554 រូបដើរជាមួយយើង'
      },
    footer: {
      contact: {
        title: 'ទាក់ទងមកយើង',
        adrres: 'អាសយដ្ឋាន៖ លេខ 50 Xiuxi សង្កាត់ Binhu ទីក្រុង Wuxi ខេត្ត Jiangsu',
        subAdrres: 'អគារ 1 ជាន់ទី 16 មជ្ឈមណ្ឌលសេវាកម្ម K-park',
        tell: 'ទូរស័ព្ទ'
        },
      business: {
        title: 'អាជីវកម្មស្នូលរបស់ Xingeer',
        department1: 'នាយកដ្ឋានកម្មវិធីទ្វារ និងបង្អួច',
        department2: 'នាយកដ្ឋានកម្មវិធីគ្រឿងសង្ហារឹម',
        department3: 'នាយកដ្ឋានសំណង់តំឡើងជាស្រេច',
        department4: 'គេហទំព័រផ្លូវការរបស់ទីស្នាក់ការកណ្ដាល Xingeer'
        },
      brand: {
        title: 'ម៉ាកសញ្ញាក្រោម Xingeer',
        brand1: 'Cai Shen Jin Fu',
        brand2: 'Mentu.com',
        brand3: 'ការវិនិយោគ Ding Xin',
        brand4: 'បច្ចេកវិទ្យា San Zhang Tu',
        brand5: 'បច្ចេកវិទ្យា Shanghai Fen Mo'
        },
      organization: {
        title: 'សាខាសកលរបស់ Xingeer',
        organization1: 'Xingeer - ការិយាល័យភាគខាងត្បូងចិន (សាខា Foshan)',
        organization2: 'Xingeer - ការិយាល័យភាគខាងជើង (សាខា Linyi)',
        organization3: 'Xingeer - ការិយាល័យភាគនិរតី (សាខា Chengdu)',
        organization4: 'Xingeer - មជ្ឈមណ្ឌលសេវាកម្មភាគខាងលិច GG',
        organization5: 'Xingeer - មជ្ឈមណ្ឌលសេវាកម្មភាគខាងកើត GG',
        organization6: 'Xingeer - ក្រុមតំណាងចែកចាយ',
        organization7: 'Xingeer - នាយកដ្ឋានទីផ្សារអន្តរជាតិ'
        },
      follow: {
        title: 'ស្កេនដើម្បី "តាមដាន GG"'
        },
      friendLink: {
        link1: 'កម្មវិធី Xingeer',
        link2: 'កម្មវិធីណែនាំការទិញ K Show',
        link3: 'Mentu.com',
        link4: 'កម្មវិធីទូអាលុយមីញ៉ូមទាំងមូល',
        link5: 'ទាញយកកម្មវិធី ZOL',
        link6: 'សួនកម្មវិធី Hua Jun',
        link7: 'គេហទំព័រទាញយក',
        link8: 'ទាញយកកម្មវិធី ZOL',
        link9: 'បណ្តាញធនធានបៃតង',
        link10: 'ហ្វ្រេនឆាយទូខោអាវ',
        link11: 'ហ្វ្រេនឆាយគ្រឿងសង្ហារឹមផ្ទះ',
        link12: 'ហ្វ្រេនឆាយបន្ទប់ទឹក American Standard'
        }
      }
    },
  login: {
    title: 'ចូល',
    tell: 'លេខទូរស័ព្ទ',
    password: 'ពាក្យសម្ងាត់',
    passwordPlaceholder: 'សូមបញ្ចូលពាក្យសម្ងាត់',
    forget: 'ភ្លេចពាក្យសម្ងាត់',
    registerAccount: 'ចុះឈ្មោះគណនី',
    backLog: 'ត្រឡប់ទៅការចូល',
    verifyCode: 'លេខកូដផ្ទៀងផ្ទាត់',
    getVerifyCode: 'ទទួលលេខកូដផ្ទៀងផ្ទាត់',
    verifyCodeErr: 'លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ',
    confimPassword: 'បញ្ជាក់ពាក្យសម្ងាត់',
    confimPasswordPlaceholder: 'សូមបញ្ជាក់ពាក្យសម្ងាត់',
    editPassword: 'ប្តូរពាក្យសម្ងាត់',
    register: 'ចុះឈ្មោះ',
    reSend: 'ទទួលម្តងទៀត',
    loginLoadText: 'កំពុងចូល សូមរង់ចាំ...',
    loadingPageTextL: 'ចូលបានជោគជ័យ កំពុងផ្ទុករចនាសម្ព័ន្ធទំព័រ...',
    loginSuccess: 'ចូលបានជោគជ័យ',
    tellErr: 'ទម្រង់លេខទូរស័ព្ទមិនត្រឹមត្រូវ',
    passwordErr: 'សូមបញ្ចូលពាក្យសម្ងាត់'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'ទទួលភារកិច្ច',
      arrange: 'ការរៀបប្លង់',
      surplus: 'សំណល់សម្ភារៈ',
      setting: 'ការកំណត់',
      find: 'ស្វែងរក',
      upgrade: 'ធ្វើបច្ចុប្បន្នភាពឥឡូវនេះ',
      editNickName: 'កែប្រែឈ្មោះហៅក្រៅ',
      editPassword: 'កែប្រែពាក្យសម្ងាត់',
      logout: 'ចាកចេញ',
      notice: 'សេចក្តីជូនដំណឹង',
      enterOfficial: 'ចូលទៅកាន់គេហទំព័រផ្លូវការ',
      equipment: 'ឧបករណ៍',
      help: 'ជំនួយ',
      importFunc: 'មើលមុខងារពិសេស',
      enterThinkerOfficial: 'ចូលទៅកាន់គេហទំព័រផ្លូវការរបស់ Xingeer',
      history: 'រក្សាទុកប្រវត្តិ',
      plankManager: 'ការគ្រប់គ្រងបន្ទះដើម',
      tagManager: 'ការគ្រប់គ្រងស្លាក',
      suplumentManager: 'បណ្ណាល័យគ្រឿងបន្លាស់ និងរង់ចាំប្លង់',
      fileManager: 'ការគ្រប់គ្រងឯកសារ',
      productionLine: 'ការភ្ជាប់ឧបករណ៍',
      workeShop: 'ផលិតកម្មលើពពក',
      useLesson: 'មេរៀនប្រើប្រាស់',
      videoLesson: 'វីដេអូសិក្សា',
      prolineManager: 'ការគ្រប់គ្រងខ្សែផលិតកម្ម',
      materialManager: 'ការគ្រប់គ្រងបន្ទះ',
      productManual: 'សៀវភៅណែនាំផលិតផល',
      medialRelated: 'ការចេញផ្សាយជាដំណាក់កាល'
      },
    sideBar: {
      title: 'ការបង្កើនប្រសិទ្ធភាពផលិតកម្ម',
      materialList: 'បញ្ជីកាត់',
      paibanTask: 'ការគ្រប់គ្រងប្លង់',
      paibanResult: 'ផែនការប្លង់',
      printTag: 'បោះពុម្ពស្លាក',
      history: 'រក្សាទុកប្រវត្តិ',
      limitDate: 'Limited Free',
      surplusManager: 'ការគ្រប់គ្រងសំណល់សម្ភារៈ',
      translateManager: 'ការគ្រប់គ្រងការបកប្រែ',
      moreSettings: 'ការកំណត់បន្ថែម',
      deepSeekTitle: 'អ្នកប្រឹក្សា',
      paibanCommune: 'ក្រុមពិភាក្សាប្លង់'
      },
    allRead: 'អានទាំងអស់រួច',
    learnMore: 'ស្វែងយល់បន្ថែម',
    noticeEmpty: 'មិនទាន់មានសេចក្តីជូនដំណឹងទេ....',
    noticeErr: 'មានកំហុសក្នុងការទទួលយកខ្លឹមសារសេចក្តីជូនដំណឹងលម្អិត',
    feedBack: {
      tab1: 'ដាក់ស្នើមតិត្រឡប់',
      tab2: 'កំណត់ត្រាមតិត្រឡប់',
      type: 'ប្រភេទមតិ',
      typePlaceholder: 'សូមជ្រើសមុខងារ',
      description: 'ការពិពណ៌នា',
      descriptionPlaceholder: 'សួស្តី~ សូមបំពេញការពិពណ៌នាសេណារីយ៉ូការប្រើប្រាស់លម្អិតយ៉ាងហោចណាស់ 15 ពាក្យ ដើម្បីឱ្យយើងអាចជួយអ្នកបានកាន់តែល្អ សូមអរគុណសម្រាប់កិច្ចសហការ!',
      uploadPic: 'បន្ថែមរូបភាព (អាចបន្ថែមបានច្រើនបំផុត 6 សន្លឹក ហើយរូបភាពនីមួយៗមិនលើស 10MB)',
      tell: 'លេខទំនាក់ទំនង',
      submit: 'ដាក់ស្នើ',
      admin: 'អ្នកគ្រប់គ្រងការរៀបប្លង់លើពពក៖',
      picTip: 'រូបភាព៖ (ចុចដើម្បីពង្រីក និងមើលព័ត៌មានលម្អិត)',
      empty: 'មិនទាន់មានទិន្នន័យមតិត្រឡប់ទេ',
      picErr: 'រូបភាពនីមួយៗមិនអាចលើស 10MB បានទេ',
      contentErr: 'ចំនួនតួអក្សរត្រូវនៅចន្លោះ 15 ដល់ 300',
      necessary: 'ជម្រើសនេះត្រូវបំពេញជាចាំបាច់'
      }
    },
  taskPage: {
    tab1: 'ភារកិច្ចផលិតកម្ម',
    tab2: 'ជួរផលិតកម្មច្រើន',
    filter: {
      title: 'តម្រង',
      unArrange: 'មិនទាន់រៀបប្លង់',
      arranged: 'បានរៀបប្លង់',
      allArranged: 'ទាំងអស់បានរៀបប្លង់',
      preLayout: 'ប្លង់មុន'
      },
    search: {
      placeholder: 'សូមបញ្ចូលមាតិកាស្វែងរក',
      orderName: 'ឈ្មោះការបញ្ជាទិញ',
      sender: 'អ្នកផ្ញើ'
      },
    importTask: 'នាំចូលភារកិច្ច',
    refuseTask: 'បដិសេធភារកិច្ច',
    refreshList: 'ផ្ទុកបញ្ជីឡើងវិញ',
    refuseRecord: 'កំណត់ត្រាបដិសេធ',
    taskCard: {
      sender: 'បញ្ជីសម្ភារៈដែលបាននាំចូល',
      delivery: 'កាលបរិច្ឆេទដឹកជញ្ជូន',
      delete: 'លុប',
      addToBatch: 'បន្ថែមទៅជាក្រុម',
      save: 'រក្សាទុកក្នុងបណ្ណសារ',
      arrange: 'រៀបប្លង់ដោយផ្ទាល់',
      deleteTitle: 'លុបភារកិច្ច',
      checkDetail: 'ចុចដើម្បីមើលព័ត៌មានលម្អិត',
      refuse: 'បដិសេធ',
      refuseTime: 'ពេលវេលាបដិសេធ',
      refuseReason: 'ហេតុផលបដិសេធ',
      refuseTask: 'បដិសេធទទួលភារកិច្ច',
      refuseTaskPlaceholder: 'សូមបញ្ចូលហេតុផលបដិសេធ',
      addErr: 'បន្ថែមបរាជ័យ សូមព្យាយាមម្តងទៀតពេលក្រោយ!'
      },
    batchNo: 'លេខបាច់',
    batchArrange: 'ប្លង់ជាក្រុម',
    clearBatch: 'សម្អាតជួរ',
    taskCount: 'ចំនួនភារកិច្ចបច្ចុប្បន្ន៖',
    checkAllTask: 'មើលបញ្ជីសម្ភារៈទាំងអស់',
    clearSuccess: 'សម្អាតបានជោគជ័យ',
    record: {
      batchNo: 'បាច់',
      saveDate: 'ពេលវេលារក្សាទុក',
      materialList: 'បញ្ជីសម្ភារៈ',
      arrangedRecord: 'ផែនការប្លង់',
      searchPlaceholder: 'សូមបញ្ចូលលេខបាច់',
      tipText: 'តើអ្នកចង់លុបបណ្ណសារនេះឬទេ?'
      },
    errTip: 'មិនមានទិន្នន័យភារកិច្ចដែលអាចដំណើរការបានទេ សូមទៅកាន់បញ្ជីភារកិច្ចដើម្បីបន្ថែម!',
    emptyErr: 'ការបញ្ជាទិញភារកិច្ចនេះមិនមានទិន្នន័យបន្ទះទេ មិនអាចធ្វើប្លង់ផលិតកម្មបានទេ!',
    operationSuccess: 'ប្រតិបត្តិការជោគជ័យ',
    operationFail: 'ប្រតិបត្តិការបរាជ័យ សូមព្យាយាមម្តងទៀតពេលក្រោយ!',
    saveSuccess: 'រក្សាទុកក្នុងបណ្ណសារបានជោគជ័យ',
    plankMaxLimit: 'ចំនួនបន្ទះតូចលើសកម្រិតប្លង់អតិបរមា',
    batchWorning: 'សូមផលិតជាបាច់ៗ',
    batchEmptyErr: 'បញ្ជីការបញ្ជាទិញមិនមានទិន្នន័យបន្ទះទេ មិនអាចធ្វើផលិតកម្មជាក្រុមបានទេ!',
    noRoomTip: 'មិនមានបន្ទប់ទេ មិនអាចធ្វើផលិតកម្មជាក្រុមបានទេ!',
    refuseHistory: 'ប្រវត្តិបដិសេធ'
    },
  materialPage: {
    specialProcess: 'ដំណើរការពិសេស',
    distanceFromTop: 'ចម្ងាយពីខាងលើ',
    distanceFromRight: 'ចម្ងាយពីខាងស្តាំ',
    hingeData: 'ទិន្នន័យហ៊ីង',
    labelBackProcTip: 'ការអាប់ដេតនេះបានបង្កើនប្រសិទ្ធភាពវិធីបិទស្លាកនៅផ្នែកខាងក្រោយនៃបន្ទះធំ។ ឥឡូវនេះ អ្នកអាចបិទគែម ខួងរន្ធ និងបើកស្លុតដោយផ្ទាល់តាមព័ត៌មានលើស្លាកបាន សូមជ្រាប!',
    openDir: 'ទិសបើកទ្វារ',
    edgeEmptyTip: 'តម្លៃកាត់ជ្រុងមិនអាចទទេបានទេ',
    edgeNumberLimit: 'តម្លៃកាត់ជ្រុងអាចបញ្ចូលបានតែជាលេខប៉ុណ្ណោះ',
    chooseSurplusQuantity: 'សម្ភារៈសំណល់ដែលអាចប្រើបានមានសរុប {total} ប្រភេទ បានជ្រើស {quantity} ប្រភេទ',
    noCanSaveInfo: 'មិនមានព័ត៌មានអាចរក្សាទុកបានទេ',
    chooseBujianStoreQuantity: 'មានគ្រឿងបំពេញសរុប {total} បន្ទះ អាចបន្ថែមបន្ទះគ្រឿងបំពេញបានសរុប {quantity} បន្ទះ បានជ្រើស {chooseQuantity} បន្ទះ',
    isConfirmPushToAwaitStore: 'តើអ្នកបញ្ជាក់ថាចង់បន្ថែមបន្ទះដែលបានជ្រើសទៅក្នុងបណ្ណាល័យរង់ចាំប្លង់មែនទេ?',
    enterAutoCreateMatCode: 'ចុច Enter ដើម្បីបង្កើតសម្ភារៈដោយស្វ័យប្រវត្តិ',
    chooseAwaitStoreQuantity: 'មានបន្ទះតូចក្នុងបណ្ណាល័យរង់ចាំប្លង់សរុប {total} បន្ទះ អាចប្លង់រួមបាន {quantity} បន្ទះ បានជ្រើស {chooseQuantity} បន្ទះ',
    defaultFold: 'ទិន្នន័យបន្ទះត្រូវបានបត់ជាលំនាំដើម',
    startArrange: 'ចាប់ផ្តើមប្លង់',
    importMaterial: 'នាំចូលបញ្ជីកាត់',
    saveToHistory: 'រក្សាទុកទៅប្រវត្តិ',
    addPlank: 'បន្ថែមបន្ទះ',
    addBujian: 'បន្ថែមគ្រឿងបំពេញ',
    deletePlank: 'លុបបន្ទះ',
    batchEdit: 'កែប្រែជាក្រុម',
    moreSetting: 'ការកំណត់បន្ថែម',
    plankSize: 'ទំហំបន្ទះ',
    plankSize2: 'ទំហំ (បណ្តោយ*ទទឹង*កម្រាស់)',
    searchPlaceholder: 'ស្វែងរកឈ្មោះបន្ទះ/លេខបន្ទះ',
    checkArranged: 'មើលប្លង់',
    checkErr: 'មិនទាន់ធ្វើប្លង់ទេ មិនអាចមើលបាន!',
    downloadSheet: 'ទាញយកតារាងគំរូ',
    downloadSheetShowScientific: 'ទាញយកតារាងគំរូ (បង្ហាញជាទម្រង់វិទ្យាសាស្ត្រ)',
    exportHoleSlotPDF: 'នាំចេញគំនូសរន្ធ និងរន្ធបន្ទះ',
    style1: 'រចនាប័ទ្ម 1',
    style2: 'រចនាប័ទ្ម 2',
    style2PDF: 'រចនាប័ទ្ម 2 (PDF)',
    style2DXF: 'រចនាប័ទ្ម 2 (DXF)',
    style3: 'រចនាប័ទ្ម 3',
    importNoCover: 'ការនាំចូលបញ្ជីសម្ភារៈនឹងមិនសរសេរជាន់ទេ',
    openBujianPlankRecommend: 'បើកការណែនាំបន្ទះតូចគ្រឿងបំពេញ',
    openAwaitStorePlankRecommend: 'បើកការណែនាំបន្ទះតូចនៃបណ្ណាល័យរង់ចាំប្លង់',
    openSurplusPlankRecommend: 'បើកការណែនាំបន្ទះធំនៃសម្ភារៈសំណល់',
    pushToAwaitStore: 'រក្សាទុកទៅបណ្ណាល័យរង់ចាំប្លង់',
    setTableHead: 'កំណត់ក្បាលតារាងបញ្ជីកាត់',
    syncConfirm: 'ទិន្នន័យសន្លឹកដើមរបស់ប្រព័ន្ធទូ និងប្លង់ពពកមិនស្របគ្នាទេ! តើត្រូវធ្វើសមកាលកម្មទៅជាទិន្នន័យសន្លឹកដើមរបស់ប្រព័ន្ធទូឬ?',
    handleSync: 'ចំណាំ៖ អាចធ្វើសមកាលកម្មដោយដៃក្នុងការគ្រប់គ្រងសន្លឹកដើម',
    noMoreTip: 'កុំរំលឹកម្តងទៀត',
    checkMore: 'មើលបន្ថែម',
    noHistory: 'មិនទាន់មានប្រវត្តិដែលបានរក្សាទុកទេ...',
    sameOrder: 'មានការបញ្ជាទិញដែលបាននាំចេញឯកសារផលិតកម្មរួច សូមប្រយ័ត្នបញ្ហាផលិតកម្មស្ទួន!',
    markOrder: 'តើត្រូវសម្គាល់ថាបានផលិតនៅទំព័រការបញ្ជាទិញឬទេ?',
    editErrTip: 'បច្ចុប្បន្នមិនគាំទ្រការកែព័ត៌មានសម្រាប់ការបញ្ជាទិញច្រើនទេ',
    autoSaveSuccess: 'បានរក្សាទុកទៅប្រវត្តិដោយស្វ័យប្រវត្តិ!',
    goAdd: 'ទៅបន្ថែម',
    noProductionLine: 'ខ្សែផលិតកម្មនៃកំណត់ត្រានេះត្រូវបានលុប សូមទៅកាន់បញ្ជីកាត់ដើម្បីរៀបប្លង់ឡើងវិញ',
    fileErr: 'បកស្រាយខ្លឹមសារឯកសារបរាជ័យ សូមបញ្ជាក់ខ្លឹមសារឯកសារ!',
    noCheckData: 'រកមិនឃើញទិន្នន័យទេ!',
    noArrangeTip: 'មិនអាចមើលផែនការប្លង់ដោយផ្ទាល់បានទេ សូមចុចចាប់ផ្តើមប្លង់!',
    tooOld: 'ការកំណត់ខួងប្រាំ/ប្រាំមួយផ្ទៃចាស់ពេក',
    contactUs: 'សូមទាក់ទងបុគ្គលិកបន្ទាប់ពីការលក់ ដើម្បីភ្ជាប់ឡើងវិញ',
    pathErr: 'មានទិន្នន័យមិនប្រក្រតីនៅក្នុងបន្ទះ (លេខបន្ទះ៖ {errorPathPlankID}) សូមពិនិត្យ!',
    sizeErr: 'មានបន្ទះធំពេក! ទំហំបន្ទះតូច៖ {width}-{height}',
    noKnife: 'មិនទាន់កំណត់អង្កត់ផ្ចិតកាំបិតកាត់ទេ សូមទៅកាន់ម៉ាស៊ីនឆ្លាក់ដើម្បីកំណត់ឧបករណ៍!',
    noKnifeDiameter: 'អង្កត់ផ្ចិតកាំបិតកាត់ ({name}) នៃខ្សែផលិតកម្មនេះទទេ សូមទៅបន្ថែមអង្កត់ផ្ចិតកាំបិតដែលត្រូវគ្នា',
    openDifferentMaterialCuttingKnives: 'បានបើកកាំបិតកាត់សម្រាប់សម្ភារៈផ្សេងៗ',
    sendFactorySuccess: 'ផ្ញើទៅសិក្ខាសាលាបានជោគជ័យ',
    sendFactoryErr: 'ផ្ញើទៅសិក្ខាសាលាបរាជ័យ សូមទាក់ទងបុគ្គលិកបន្ទាប់ពីការលក់សម្រាប់ជំនួយ',
    createTaskCard: 'តើត្រូវបង្កើតកាតភារកិច្ចដែលត្រូវគ្នាឬទេ?',
    surplusStatistics: 'សម្ភារៈសំណល់ដែលអាចប្រើបានសរុប',
    surplusStatistics2: 'បានជ្រើស',
    suplementStatistic: 'បន្ទះគ្រឿងបំពេញ អាចរួមបញ្ចូលបន្ទះគ្រឿងបំពេញសរុប',
    expand: 'ពង្រីក',
    packUp: 'បង្រួម',
    importErr: 'សូមជ្រើសឯកសារត្រឹមត្រូវ!',
    sendLoadingText: 'កំពុងដំណើរការ និងផ្ញើឯកសារ NC......',
    arrangeLoading: 'សរុប',
    arrangeLoading2: 'បន្ទះតូចកំពុងត្រូវបានបង្កើនប្រសិទ្ធភាពសម្រាប់ប្លង់......',
    dealing: 'កំពុងដំណើរការ...',
    deleteConfirm: 'បន្ទាប់ពីលុប សម្ភារៈសំណល់នឹងត្រូវបានផ្លាស់ទីទៅធុងសំរាម។ តើអ្នកប្រាកដថាចង់លុបសម្ភារៈនេះទេ?',
    copyTip: 'ជិតធ្វើការចម្លងសម្ភារៈសំណល់ដែលបានជ្រើស',
    copyTip2: 'សូមបញ្ជាក់បរិមាណដែលត្រូវចម្លង',
    surplusHead: {
      shape: 'រូបរាង',
      type: 'ប្រភេទ',
      remark: 'ចំណាំ',
      area: 'ផ្ទៃក្រឡា(m²)',
      area1: 'ផ្ទៃក្រឡា'
      },
    surplusTip: 'បច្ចុប្បន្នមិនមានសម្ភារៈសំណល់ដែលអាចប្រើបានទេ អ្នកអាចទៅកាន់',
    creatSurplus: 'បង្កើតសម្ភារៈសំណល់ថ្មី',
    orderInfo: 'ព័ត៌មានការបញ្ជាទិញ',
    suplement: {
      statistic: 'មានគ្រឿងបំពេញសរុប {total} បន្ទះ អាចប្រើរួមបាន {useable} បន្ទះ បានជ្រើស {selected} បន្ទះ',
      exportSuplement: 'នាំចេញបញ្ជីគ្រឿងបំពេញ',
      suplementLoading: 'កំពុងផ្ទុកទិន្នន័យគ្រឿងបំពេញ',
      exportSuplementIng: 'កំពុងនាំចេញបញ្ជីគ្រឿងបំពេញ',
      noMatchSup: 'រកមិនឃើញទិន្នន័យគ្រឿងបំពេញដែលអាចប្រើបានទេ',
      exportTip: 'សូមជ្រើសគ្រឿងបំពេញយ៉ាងហោចណាស់មួយ មុននឹងនាំចេញ'
      },
    empty: 'មិនមានទិន្នន័យបន្ទះទេ',
    paibanSetting: {
      title: 'ការកំណត់ប្លង់',
      createTask: 'បង្កើតការបង្កើតប្លង់',
      selectProduction: 'ជ្រើសរើសខ្សែផលិតកម្ម',
      arrangeWay: 'ជ្រើសរើសផែនការប្លង់',
      suitText: 'សមស្របសម្រាប់：',
      surplusTrimTip: 'ចំណាំ៖ អ្នកបានប្រើមុខងារកាត់គែមផ្ទាល់ខ្លួនសម្រាប់សម្ភារៈសំណល់ ដូច្នេះអាចជ្រើសបានតែប្លង់កាត់ដោយរណារ',
      suitEquipmentNormal: 'ម៉ាស៊ីនឆ្លាក់ធម្មតា',
      suitEquipmentSpecial: 'ម៉ាស៊ីនកាត់កញ្ចក់ ម៉ាស៊ីនកាត់ដោយផ្លិតរណារ',
      lessRoll: 'បង្វិលតិច',
      computedSpecial: 'គណនារាងមិនទៀងទាត់',
      specialTip: 'ប៉ះពាល់ដល់ល្បឿនប្លង់',
      irregularNesting: 'ការរៀបចំជាន់គ្នាមិនទៀងទាត់',
      primaryNesting: 'ការរៀបចំជាន់គ្នាធម្មតា',
      specialShapedPanel: 'បន្ទះរាងពិសេសជាន់ក្នុងបន្ទះធម្មតា',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'ការរៀបចំជាន់គ្នាកម្រិតខ្ពស់',
      heteromorphicInlay: 'ការដាក់បញ្ចូលរាងមិនទៀងទាត់ក្នុងរាងមិនទៀងទាត់',
      autoCutSurplus: 'កាត់សម្ភារៈសំណល់ដោយស្វ័យប្រវត្តិ',
      cutWay: 'វិធីកាត់',
      maxRect: 'កាត់ជាចតុកោណកែងអតិបរមា',
      fixedRect: 'កាត់ជាទំហំថេរ',
      minRectSetting: 'ទំហំកាត់អប្បបរមា',
      firstCutL: 'ផ្តល់អាទិភាពបង្កើតសំណល់រាង L',
      firstCutLTip: 'បន្ទាប់ពីបើក វានឹងផ្តល់អាទិភាពកាត់បន្ទះចតុកោណដែលបំពេញលក្ខខណ្ឌឱ្យក្លាយជាសំណល់រាង L',
      shortLine: 'ជ្រុងខ្លីធំជាង',
      longLine: 'ជ្រុងវែងធំជាង',
      setDifferentThickness: 'កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះដែលមានកម្រាស់ខុសៗគ្នា',
      defaultRuleTip: 'នៅពេលកម្រាស់បន្ទះមិនត្រូវនឹងច្បាប់ សូមកាត់តាមច្បាប់លំនាំដើម',
      panelThickness: 'កម្រាស់បន្ទះធំ',
      duplicateMinCutSize: 'កម្រាស់បច្ចុប្បន្នមានទំហំកាត់អប្បបរមាដូចគ្នារួចហើយ',
      templateEmpty: '"កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះកម្រាស់ខុសៗគ្នា" ទិន្នន័យគំរូមិនអាចទទេបានទេ!',
      duplicateThicknessData: '"កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះកម្រាស់ខុសៗគ្នា" មានទិន្នន័យកម្រាស់ស្ទួនក្នុងគំរូ!',
      atLeastOne: 'យ៉ាងហោចណាស់ត្រូវរក្សាទុកមួយ!',
      maxAddFive: 'អាចបន្ថែមបានច្រើនបំផុតប្រាំ!',
      surplusTemplate: 'គំរូសម្ភារៈសំណល់ដែលប្រើញឹកញាប់',
      add: 'បន្ថែម',
      templateErr: 'នៅពេលជ្រើសកាត់ជាទំហំទូទៅ ត្រូវជ្រើសគំរូទិន្នន័យយ៉ាងហោចណាស់មួយ',
      cutLong: 'ប្រវែងកាត់',
      cutWidth: 'ទទឹងកាត់',
      baseInfo: 'ព័ត៌មានមូលដ្ឋាន',
      continue: 'បញ្ជាក់ និងបន្ត',
      standardSelect: 'ជ្រើសរើសបន្ទះធំស្តង់ដារ',
      customPlankOrder: 'ប្ដូរលំដាប់ប្លង់បន្ទះធំតាមបំណង',
      customPlankOrderDetail: 'បញ្ជីបន្ទះតូចដែលមិនទាន់ប្លង់',
      customPlankOrderTip: 'ប្លង់ពពកដែលភ្ជាប់មកជាមួយ មិនមានប្រសិទ្ធភាពសម្រាប់មុខងារនេះទេ',
      customPlankOrderBrandTip: 'ការបញ្ជាទិញដែលរង់ចាំប្លង់មានបន្ទះកាតពណ៌ម៉ាក មុខងារនេះត្រូវបានប្រើតាមលំនាំដើម',
      surplusPlank: 'បញ្ជីបន្ទះតូចដែលនៅសល់',
      overSizePlank: 'បញ្ជីបន្ទះលើសទំហំ',
      plankOrder: 'លំដាប់ប្លង់',
      plankType: 'ប្រភេទបន្ទះ',
      plankSize: 'ទំហំបន្ទះ',
      plankEdgeOff: 'តម្លៃកាត់គែម',
      amount: 'បរិមាណកាត់',
      amountMax: 'បរិមាណកាត់អតិបរមា',
      numAndOverSizeTip: 'មានបន្ទះតូចលើសទំហំ ហើយបរិមាណបន្ទះធំមិនគ្រប់គ្រាន់ ដូច្នេះមិនអាចធ្វើប្លង់បាន',
      numErrorTip: 'បរិមាណបន្ទះធំមិនគ្រប់គ្រាន់ មិនអាចធ្វើប្លង់បាន',
      overSizeTip: 'មានបន្ទះតូចលើសទំហំ មិនអាចធ្វើប្លង់បាន',
      restPartList: 'បញ្ជីបន្ទះតូចដែលមិនទាន់ប្លង់',
      layoutOrder: 'លំដាប់ប្លង់',
      arrangeAmount: 'បរិមាណកាត់',
      specialShapeTip: 'សម្ភារៈសំណល់រាងពិសេសមិនអាចប្រើប្លង់កាត់ដោយរណារបានទេ',
      surplusConflictTip: 'ការកាត់សម្ភារៈសំណល់ប៉ះទង្គិចជាមួយគ្រោងបន្ទះ សូមកាត់ម្តងទៀត',
      stackingMethod: {
        title: 'កម្មវិធីរៀបចំផ្ទាំង',
        long: 'កម្មវិធីរៀបចំផ្ទាំងតូចគឺចង់រៀបចំជាក្រុម',
        short: 'កម្មវិធីរៀបចំផ្ទាំងតូចគឺចង់រៀបចំជាក្រុម'
        },
      seniorShapeTip: '【ការរួមបញ្ចូលកម្រិតខ្ពស់】ការសាកល្បងឥតគិតថ្លៃបានផុតកំណត់แล้ว អ្នកអាចមើលលទ្ធផលការរៀបចំការរួមបញ្ចូលកម្រិតខ្ពស់ជាមុន (អ្នកក៏អាចប្តូរទៅការរួមបញ្ចូលធម្មតាសម្រាប់ការផលិតធម្មតា)។ ប្រសិនបើអ្នកត្រូវការនាំចេញឯកសារផលិតកម្មការរួមបញ្ចូលកម្រិតខ្ពស់ សូមទាក់ទងបុគ្គលិកលក់ដើម្បីទិញ~'
      },
    filter: {
      title: 'តម្រងបន្ទះ',
      search: 'ស្វែងរក',
      all: 'ជ្រើសទាំងអស់',
      diskSize: 'បោះបង់តម្រង',
      resetFilter: 'បោះបង់តម្រង'
      },
    edit: {
      title: 'កែប្រែជាក្រុម',
      target: 'វត្ថុដែលត្រូវកែប្រែ',
      onlineSelectRow: 'តែជួរដែលបានជ្រើស',
      allRow: 'ជួរទាំងអស់',
      editKey: 'មាតិកាដែលត្រូវកែប្រែ',
      editValue: 'កែប្រែជា',
      warningTip: 'ចំណាំ៖ បន្ទាប់ពីកែប្រែ រន្ធ ចង្អូរ និងរាងពិសេស នឹងត្រូវសម្អាតដោយស្វ័យប្រវត្តិ',
      allEdge: 'បិទគែមទាំងអស់'
      },
    add: {
      title: 'បន្ថែមបន្ទះ',
      continue: 'បញ្ជាក់ និងបន្ត',
      matCodeErr: 'សម្ភារៈមិនអាចទទេបានទេ',
      thickErr: 'កម្រាស់មិនអាចទទេបានទេ',
      colorErr: 'ពណ៌មិនអាចទទេបានទេ',
      longErr: 'ប្រវែងផលិតផលសម្រេចមិនអាចទទេបានទេ',
      widthErr: 'ទទឹងផលិតផលសម្រេចមិនអាចទទេបានទេ',
      countErr: 'បរិមាណត្រូវតែយ៉ាងហោចណាស់ 1'
      },
    delete: {
      tip: 'បន្ទាប់ពីលុបទិន្នន័យនេះ វាមិនអាចស្ដារឡើងវិញបានទេ តើអ្នកបញ្ជាក់លុបឬ?',
      errTip: 'សូមជ្រើសបន្ទះយ៉ាងហោចណាស់មួយ មុនពេលធ្វើប្រតិបត្តិការនេះ!',
      errTip1: 'សូមជ្រើសបន្ទះយ៉ាងហោចណាស់មួយ មុនពេលធ្វើប្លង់',
      confirm: 'បញ្ជាក់ការលុប'
      },
    restore: {
      confirm: 'បញ្ជាក់ការស្តារឡើងវិញ'
      },
    restoreConfirm: 'បន្ទាប់ពីស្តារឡើងវិញ សម្ភារៈសំណល់នឹងត្រូវបានផ្លាស់ទីទៅបញ្ជីឬឃ្លាំងសំណល់វិញ។ តើអ្នកប្រាកដថាចង់ស្តារសម្ភារៈនេះទេ?',
    restoreBatchConfirm: 'តើអ្នកប្រាកដថាចង់ស្តារសម្ភារៈសំណល់ដែលបានជ្រើសរើសទេ?',
    save: {
      errTip: 'មិនមានព័ត៌មានអាចរក្សាទុកបានទេ!',
      title: 'រក្សាទុកគ្រោងការណ៍',
      subTitle: '(ចំណាំ៖ ប្រវត្តិរក្សាទុកត្រឹមមួយឆ្នាំប៉ុណ្ណោះ)',
      name: 'ឈ្មោះគ្រោងការណ៍',
      historyName: 'គ្រោងការណ៍ប្រវត្តិសាស្ត្រ',
      successTip: 'រក្សាទុកជោគជ័យ!',
      fieldTip: 'រក្សាទុកបរាជ័យ!'
      },
    exportErr: 'មិនមានក្តារអាចនាំចេញបានទេ',
    exportPicErr: 'បានជួបប្រទះកំហុសមិនស្គាល់នៅពេលនាំចេញដ្យាក្រាមរន្ធក្តារ សូមទាក់ទងយើងខ្ញុំដើម្បីដោះស្រាយ',
    plankNotFound: 'រកមិនឃើញក្តារពាក់ព័ន្ធទេ! សូមបញ្ជាក់ថាតើគូសក្តាររួចឬនៅ!',
    noPlankName: 'រកមិនឃើញឈ្មោះក្តារទេ',
    plankDataErr: 'ទិន្នន័យក្តារមានកំហុស សូមពិនិត្យដោយប្រុងប្រយ័ត្នដើម្បីជៀសវាងការខាតបង់ផលិតកម្ម',
    exportThreeViewErr: 'ការនាំចេញទិដ្ឋភាពបីរន្ធបរាជ័យ សូមទាក់ទងសេវាក្រោយការលក់',
    heighGlossWarning: 'ចំណាំ៖ នៅពេលសម្ភារៈជាក្តារភ្លឺ ក្តារមិនអាចស្តារឡើងវិញជាក្តារភ្លឺបានទេបន្ទាប់ពីកែប្រែសម្ភារៈ!',
    reset: 'ស្តារលំនាំដើម',
    settingHead: {
      title: 'កំណត់ក្បាលរបារបញ្ជីកាត់',
      head: 'ក្បាលរបារ',
      customHeadName: 'ឈ្មោះក្បាលរបារផ្ទាល់ខ្លួន',
      example: 'គំរូ',
      tip: 'ព័ត៌មានប្រតិបត្តិការ៖ អាចអូសស្លាកទិន្នន័យក្បាលរបារឆ្វេងស្តាំដើម្បីផ្លាស់ប្តូរទីតាំង',
      headerNameEmpty: 'ក្បាលរបារមិនអាចទទេបានទេ',
      duplicateHeader: 'មានក្បាលរបារស្ទួន'
      },
    copyLine: 'ចុចដើម្បីចម្លងជួរបច្ចុប្បន្នទៅខាងក្រោម',
    copySuccess: 'ចម្លងទិន្នន័យ {name} ជោគជ័យ',
    arranging: 'សរុបក្តារតូច {count} កំពុងបង្កើនប្រសិទ្ធភាពរចនាសម្ព័ន្ធ......',
    overSize: {
      title: 'ក្តារលើសវិមាត្រ',
      subTitle: 'បញ្ជីក្តារលើសវិមាត្រ',
      overSizeTip: 'ការជូនដំណឹងក្តារលើសវិមាត្រ',
      nonWorkInfo: 'ព័ត៌មានលម្អិតក្តារមិនអាចដំណើរការបាន',
      mergeFrameDoorWholeTip: 'មានការព័ត៌មាត្រ: សន្លឹកនេះគឺជាកន្ទការបង្ហាញនៃរបារពិន្ទុដែលបានបង្ហាញជាមួយគ្នា',
      conflictWorkInfo: 'ព័ត៌មានលម្អិតក្តារជម្លោះ',
      warning: 'រកឃើញថាវិមាត្រក្តារតូចវែងពេក មិនអាចរៀបចំបាន! សូមកែតម្រូវវិមាត្រក្តារតូច ឬបន្ថែមសន្លឹកដើមវិមាត្រដែលត្រូវគ្នា',
      checkInfo: 'មើលព័ត៌មានលម្អិតក្តារ',
      tipContent: 'ប្រព័ន្ធរកឃើញក្តារលើសវិមាត្រក្នុងក្តារតូចរៀបចំ ខាងក្រោមជាការណែនាំបន្ថែមក្តារពិសេស អាចកែប្រែប្រវែងទទឹងក្តារដោយដៃ រួចចុចប៊ូតុង "បន្ថែមមួយចុច" ខាងក្រោមតារាង ឬបន្ថែមក្តារដោយដៃនៅការកំណត់សន្លឹកដើម-ក្តារពិសេស',
      add: 'បន្ថែមមួយចុច',
      addPlank: 'បន្ថែមសន្លឹកដើម',
      error: 'ក្តារលើសវិមាត្រ រចនាសម្ព័ន្ធបរាជ័យ',
      successTip: 'បន្ថែមក្តារជោគជ័យ! កំពុងរៀបចំឡើងវិញ',
      warningTip: 'សូមបំពេញប្រវែងនិងទទឹងក្តារ!'
      },
    arrangeErr: 'ទិន្នន័យខាងក្នុងក្តារមានភាពមិនធម្មតា មិនអាចផលិតរចនាសម្ព័ន្ធបានទេ',
    nonDelete: 'មិនអាចលុបបានទេ',
    addOverSizeTip: 'មានវិមាត្រលើស សូមបន្ថែមម្តងទៀត',
    addPlankSuccess: 'បន្ថែមក្តារធំពិសេសជោគជ័យ',
    addPlankFail: 'បន្ថែមក្តារធំពិសេសបរាជ័យ',
    paibanFeedback: 'មតិការតបរចនាសម្ព័ន្ធ',
    cuttingAndPaoban: 'កាត់និងរៀបចំ',
    lowUtilizationRate: 'អត្រាប្រើប្រាស់ទាប',
    unreasonableLayout: 'រចនាសម្ព័ន្ធមិនសមហេតុផល',
    feedbackSuccessTip: 'មតិការតបជោគជ័យ!',
    feedbackFailTip: 'មតិការតបបរាជ័យ!',
    mixedLayoutScheme: 'គ្រោងការណ៍រចនាសម្ព័ន្ធលាយលក្ខណ៍នេះ'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'ទិន្នន័យក្តារបានផ្លាស់ប្តូរ ប៉ុន្តែគ្រោងការណ៍មិនទាន់រក្សាទុក សូមចុចយល់ព្រមដើម្បីរក្សាទុកគ្រោងការណ៍ រួចធ្វើប្រតិបត្តិការបន្ត',
    paibanRequestFailed: 'សំណើរៀបចំប្លង់បរាជ័យ សូមព្យាយាមម្តងទៀត',
    accordingPlankCountOrder: 'រៀបតាមចំនួនក្តារធំពីខ្ពស់ទៅទាប',
    editOrder: 'កែសម្រួលលេខរៀង',
    dragOrder: 'អូសដើម្បីរៀបចំ',
    inputOrder: 'បញ្ចូលលំដាប់',
    editOrderTip: 'កែតម្រូវលំដាប់',
    range: 'ជួរ',
    unsupportRotateTip: 'ក្តារធំមួយចំនួនត្រូវបានបង្វិល ការរៀបចំឡើងវិញមិនត្រូវបានគាំទ្រនាពេលបច្ចុប្បន្នទេ។ លេខក្តារធំដែលបានបង្វិល៖',
    slotErrTip: 'ក្តារបច្ចុប្បន្នមានរន្ធដំណើរការគែម ការរៀបចំឡើងវិញមិនត្រូវបានគាំទ្រទេ!',
    lockedPaibanTip: 'ក្តារធំត្រូវបានចាក់សោ មិនអាចរៀបចំឡើងវិញបានទេ',
    batchBujianErrTip: 'ផ្នែកក្តារបច្ចុប្បន្នមិនមានក្នុងទិន្នន័យបញ្ជីសម្ភារៈដើម អាចជ្រើសរើសពីបណ្ណាល័យបន្ថែម/រង់ចាំរៀបចំដើម្បីរៀបចំឡើងវិញ',
    useFolderIsNot: 'រកឃើញថាទីតាំងរក្សាទុកអានឯកសាររបស់អ្នក "{type}" មិនមានទេ! សូមពិនិត្យមើលថាតើថតត្រូវបានលុបឬនៅ។ ប្រើ USB សូមពិនិត្យការភ្ជាប់',
    useFolderIsNot1: 'រកឃើញថាអ្នកមិនបានកំណត់ទីតាំងអានឯកសារទេ សូមជ្រើសរើសថតមុន',
    downloadNC: 'ទាញយក NC',
    downloadNC1: 'ទាញយកឯកសារ NC',
    reArrange: 'រៀបចំឡើងវិញ',
    reArrangeSpecifiedMaterialGroup: 'រៀបចំក្រុមបន្ទះដែលបានបញ្ជាក់ឡើងវិញ',
    specifiedMaterialRelayoutMoreResultTip: 'បន្ទាប់ពីរៀបចំក្រុមបន្ទះដែលបានបញ្ជាក់ឡើងវិញ នឹងមិនផ្តល់លទ្ធផលរៀបចំបន្ថែមទៀតទេ',
    searchMaterialGroup: 'ស្វែងរកក្រុមបន្ទះ',
    saveToHistory: 'រក្សាទុកទៅប្រវត្តិ',
    moreSetting: 'បន្ថែម',
    cutIndexRe: 'ប្រសិទ្ធភាពលំដាប់ ctrl+z ដើម្បីបង់ប្រាក់សំបុត្រដែលមុន',
    followExportTag: 'ទាញយក NC រួមជាមួយនាំចេញឯកសារស្លាក',
    followExportPaibanImg: 'ទាញយក NC រួមជាមួយនាំចេញឯកសាររូបភាពរចនាសម្ព័ន្ធ',
    followExportWorkerShop: 'ទាញយក NC រួមជាមួយនាំចេញការបញ្ជាទិញ',
    tagTemplateSelect: 'ការជ្រើសរើសគំរូស្លាក',
    showCuttingSequence: 'បង្ហាញលំដាប់កាត់',
    showPlankSize: 'បង្ហាញវិមាត្រក្តារតូច',
    sendToFactory: {
      title: 'ផ្ញើទៅរោងចក្រសម្រាប់ផលិតកម្ម',
      fileType: 'ប្រភេទឯកសារស្លាក'
      },
    checkData: 'កំពុងពិនិត្យភាពពេញលេញនៃទិន្នន័យ...',
    dataLoading: 'កំពុងផ្ទុក......',
    addToBujianStore: 'កំពុងបន្ថែមទៅឃ្លាំងគ្រឿងបន្ថែម...',
    updateTaskStatus: 'កំពុងធ្វើបច្ចុប្បន្នភាពស្ថានភាពភារកិច្ច...',
    sending: 'កំពុងផ្ញើទៅរោងចក្រ',
    waitLoadding: 'រង់ចាំ',
    loadding: 'កំពុង',
    finish: 'បានបញ្ចប់',
    loadSetting: 'ផ្ទុកការកំណត់',
    loadPreference: 'ផ្ទុកចំណូលចិត្ត',
    dealTemplate: 'ដំណើរការគំរូ',
    initTagData: 'ចាប់ផ្តើមទិន្នន័យស្លាក',
    prepareDrawData: 'រៀបចំទិន្នន័យគូសស្លាក',
    drawDataText: 'ទិន្នន័យគូសស្លាក',
    genPdfTagFile: 'បង្កើតឯកសារស្លាក PDF',
    genPicTagFile: 'បង្កើតឯកសាររូបភាពស្លាក',
    uploadFile: 'ផ្ទុកឯកសារឡើង',
    dealNCFile: 'ដំណើរការឯកសារ NC',
    zipFile: 'បង្កើតឯកសារបង្គត់ក្នុងតំបន់',
    plankCount: 'ចំនួនផ្ទាំងធំ',
    rollCount: 'ចំនួនដងកែប្រែ',
    totalRate: 'អត្រាប្រសើរឡើងសរុប',
    rate: 'អត្រាប្រសើរឡើង',
    useArea: 'ផ្ទៃដីដែលបានប្រសើរឡើង',
    materialList: 'បញ្ជីសម្ភារៈ',
    saveSurplus: 'រក្សាទុកសម្ភារៈសល់ចូលឃ្លាំង',
    workeShop: 'បញ្ជាទិញ',
    batchTagging: 'បំពេញស្លាកជាក្រុម',
    batchTaggingTip: 'សូមជ្រើសរើសផ្ទាំងដែលត្រូវការស្លាកបន្ថែមខាងក្រោម',
    holeSlotErr: 'រកឃើញជម្រៅរណ្តៅ/រន្ធ​មិនប្រក្រតីនៅលើផ្ទាំង!',
    knivesErr: 'រកមិនឃើញឧបករណ៍ដំណើរការពេលរកឃើញផ្ទាំង!',
    checkDetail: 'មើលព័ត៌មានលម្អិត',
    deepErr: {
      title: 'ជម្រៅរណ្តៅ/រន្ធ​ផ្ទាំងមិនប្រក្រតី',
      errStatistic: 'ផ្ទាំងរងមានភាពមិនប្រក្រតី {count} កន្លែង',
      errText: 'ផ្នែកមិនប្រក្រតី',
      markErrPart: 'ដាក់ស៊ុមលើផ្នែកមិនប្រក្រតី'
      },
    warningTip: 'ផ្ទាំងរលោងពីរមុខ៖ ដំណើរការ <span class="font-style">ផ្ទៃរលោង</span> មុន រួចដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span>។ ផ្ទាំងរលោងមុខតែមួយ៖ ដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span> ដោយផ្ទាល់។',
    showDetail: {
      tip1: 'ចុចដើម្បីជ្រើសរើសផ្ទាំងតែមួយ',
      tip2: 'មើលស្លាកផ្ទាំង'
      },
    arrangeTip: '(គាំទ្រការរៀបចំផ្ទាល់រូបខាងក្នុង)',
    plankOpration: 'ប្រតិបត្តិការផ្ទាំង',
    rotate: 'បង្វិល ៩០ ដឺក្រេ',
    notCare: 'ផ្ទាំងគ្មានសរសរ',
    editRemark: 'កែសម្រួលកំណត់សម្គាល់',
    clearRemark: 'សម្អាតកំណត់សម្គាល់',
    recalcIndex: 'គណនាឡើងវិញចំណុចកាត់ និងលំដាប់ការកាត់',
    recalcIndexSuccess: 'គណនាឡើងវិញចំណុចកាត់ និងលំដាប់ការកាត់បានជោគជ័យ',
    storageArea: {
      title: 'តំបន់ផ្ទុកផ្ទាំងអាចបណ្ដោះអាសន្ន',
      empty: 'គ្មានផ្ទាំងផ្ទុកអាចបណ្ដោះអាសន្ន',
      storageTip: 'អូសផ្ទាំងមកទីនេះដើម្បីផ្ទុកអាចបណ្ដោះអាសន្ន'
      },
    subtleArrange: 'ការរៀបចំលម្អិត',
    addPlank: 'បន្ថែមផ្ទាំងធំ',
    deletePlank: 'លុបផ្ទាំងធំ',
    deletePlankErr: 'ផ្ទាំងធំមានផ្ទាំងតូច មិនអាចលុបផ្ទាំងធំ!',
    useSurplus: {
      title: 'ប្រើសម្ភារៈសល់'
      },
    dragWarning: 'សូមអូសផ្ទាំងទៅផ្ទាំងធំ!',
    areaWarning: 'មិនអាចដាក់ផ្ទាំងបានទេ សូមមើលទំហំកន្លែងទំនេរ',
    subtlePage: {
      cut: 'កាត់សម្ភារៈសល់',
      lineTip: 'កាត់សម្ភារៈសល់',
      cancelCut: 'បញ្ចប់ការកាត់',
      cutPoint: 'ចំណុចរុញរបស់ការកាត់សល់',
      storageArea: 'តំបន់ផ្ទាំងរង់ចាំការរៀបចំ',
      cutErr: 'កាត់បានតែលើផ្ទាំងធំ មិនត្រូវប៉ះផ្ទាំងតូច!',
      saveErr: 'សូមជ្រើសរើសសម្ភារៈសល់ដើម្បីកាត់មុន',
      cutErr2: 'កាត់បានតែលើផ្ទាំងធំ កុំហួសផ្ទាំងធំ!',
      selectTip: 'សូមជ្រើសរើសផ្ទាំងសម្ភារៈសល់ដើម្បីកាត់',
      noCutPath: 'ផ្នែករាងមិនធម្មតាមិនអាចកាត់ចតុកោណបាន',
      cutOperate: 'ប្រតិបត្តិការកាត់សម្ភារៈសល់',
      line: 'គូរសង់ដៃ',
      cutErrtip: 'មានចំណុចកាត់ឆ្លងគ្នា សូមកាត់ឡើងវិញ',
      cutErrtip2: 'ចំណុចកាត់នឹងហួសកំណត់ ៩ សូមកាត់ឡើងវិញ'
      },
    shortCut: 'ផ្លូវកាត់',
    updownRoll: 'រំកិលឡើយចុះ',
    leftRightRoll: 'រំកិលឆ្វេងស្ដាំ',
    zoomScale: 'ពង្រីក និងបង្រួម',
    dragCanvas: 'អូសទំព័រ',
    mouseRoll: 'កង់រមូរកណ្ដុរ',
    mouseRight: 'ចុចកណ្ដុរស្ដាំ',
    mouseMultiSelect: 'ជ្រើសរើសផ្ទាំងពីរចុងក្រោយ',
    mouseLeft: 'ចុចកណ្ដុរឆ្វេង',
    doublePlank: 'ចុចពីរដងលើផ្ទាំងធំ',
    keyboard: 'ក្ដារចុច',
    picSymble: 'រូបភាពណែនាំ',
    funished: 'ផលិតផលសម្រេច',
    holeSlotConflict1: 'ការប៉ះទង្គិចរណ្តៅ-រន្ធ',
    plankErr: 'ការប៉ះទង្គិចផ្ទាំង',
    frontSlot: 'រន្ធខាងមុខ',
    backSlot: 'រន្ធខាងក្រោយ',
    frontHole: 'រណ្តៅខាងមុខ',
    backHole: 'រណ្តៅខាងក្រោយ',
    resetScale: 'កំណត់ការពង្រីកឡើងវិញ',
    maxLong: 'វែងបំផុត',
    tempErr: 'បន្ថែមបរាជ័យ ទីតាំងគំរូមិនត្រឹមត្រូវ ឬគំរូធំពេក!',
    sendErr: 'ផ្ញើទៅរោងចក្រមិនបានជោគជ័យ សូមពិនិត្យគំរូស្លាក និងទិន្នន័យផ្ទាំងរួចផ្ញើឡើងវិញ',
    someTips: 'អ្នកកំពុងសាកល្បងមុខងារការរៀបចំក្នុងពពកសម្រាប់សម្ភារៈសល់/ការរួមបញ្ចូលរាងមិនធម្មតា សូមប្រយ័ត្នពីបញ្ហាក្នុងផលិតកម្ម!',
    nestingTips: 'ការសាកល្បងឥតគិតថ្លៃមានកំណត់សម្រាប់ [ការរៀបចំការរួមបញ្ចូលរាងមិនធម្មតាកម្រិតខ្ពស់] បានផុតកំណត់ហើយ។ ដើម្បីបន្តប្រើ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញ!',
    frameDoorTip: 'បង្កើតបង្អួចព្រមានពេលបង្រួមទូរទូទាត់',
    cutOrderErr: 'លំដាប់ការកាត់មិនត្រឹមត្រូវ សូមចុចដើម្បីគណនាឡើងវិញចំណុចកាត់ និងលំដាប់!',
    holeSlotConflict: 'រកឃើញប៉ះទង្គិចរណ្តៅ-រន្ធ ឬផ្ទាំងតូចរំដោះ',
    exportSetting: 'ការកំណត់នាំចេញ',
    currentTagTemp: 'គំរូស្លារបច្ចុប្បន្ន',
    specialPaibanErr: 'មានផ្ទាំងដែលមានដំណើរការពិសេស ឬរន្ធគែម មិនទាន់គាំទ្រការរៀបចំឡើងវិញ!',
    moreResult: 'លទ្ធផលបន្ថែម',
    moreResultTip: 'ផ្ទាំងធំមានរន្ធកែគែម ផ្ទាំងធំនឹងមិនចូលរួមការរៀបចំឡើងវិញ',
    batchBujian: 'បំពេញគ្រឿងជាក្រុម',
    batchOperation: 'ប្រតិបត្តិការជាក្រុម',
    batchEditPlankSize: 'កែទំហំផ្ទាំងធំជាក្រុម',
    editPlankSize: 'កែទំហំ',
    editWay: 'វិធីកែ',
    editByType: 'កែតាមប្រភេទ',
    editByPlankNumber: 'កែតាមលេខផ្ទាំងធំ',
    editContent: 'កែមាតិកា',
    editContentTip: 'សូមជ្រើសរើសប្រភេទផ្ទាំងធំដែលត្រូវកែ',
    editContentTip1: 'សូមជ្រើសរើសលេខផ្ទាំងធំដែលត្រូវកែ',
    editStart: 'ចាប់ផ្តើម',
    editEnd: 'បញ្ចប់',
    bigPlank: 'ផ្ទាំងធំ',
    editSize: 'ទំហំត្រូវបានកែទៅ',
    bigPlankWidth: 'ទទឹងផ្ទាំងធំ',
    bigPlankHeight: 'បណ្តោយផ្ទាំងធំ',
    bigPlankLengthMarking: 'សញ្ញាបណ្តោយផ្ទាំងធំ',
    markedAs: 'សម្គាល់ជា',
    maxAddTen: 'អាចបន្ថែมបានអតិបរមា ១០',
    minValue: 'តម្លៃអប្បបរមា',
    differentKnifeErr: 'បានជ្រើសរើសផ្ទាំងធំដែលមានកាំបិតកាត់ខុសគ្នា មិនអាចកែទំហំបានទេ',
    noEditablePlank: 'គ្មានផ្ទាំងធំដែលត្រូវនឹងលក្ខខណ្ឌសម្រាប់កែប្រែទេ',
    skipBrandPlankTip: 'ក្នុងជួរដែលបានជ្រើសរើសមានផ្ទាំងធំម៉ាក {count} ផ្ទាំងដែលមិនគាំទ្រការកែទំហំ ហើយត្រូវបានរំលង',
    nonBrandToBrandTip: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌ម៉ាកបានទេ!',
    brandToNonBrandTip: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌មិនមែនម៉ាកបានទេ!',
    brandToOtherBrandTip: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌ម៉ាកផ្សេងបានទេ!',
    editNo: 'លេខ',
    editAllPlank: 'ផ្ទាំងធំទាំងអស់',
    editBigPartSize: 'កែទំហំផ្ទាំងធំ',
    disPlaySetting: 'ការកំណត់បង្ហាញ',
    stored: 'រក្សាទុកឃ្លាំងហើយ',
    onlySurplus: 'មើលតែសម្ភារៈសល់',
    UnuseSurplus: 'សម្ភារៈសល់មិនចូលរួមក្នុងការគណនាអត្រាប្រើប្រាស់',
    usePlankAdsorption: 'មុខងារស្រូបផ្ទាំង',
    dataDefaultCollapsed: 'ទិន្នន័យបិទលំនាំដើម',
    unit: 'ដុំ',
    cutSurplus: 'កាត់សម្ភារៈសល់',
    frontWarningTip: 'ផ្ទាំងរលោងពីរមុខ៖ ដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span> មុន រួច <span class="font-style">ផ្ទៃរលោង</span>។ ផ្ទាំងរលោងមុខតែមួយ៖ ដំណើរការ <span class="font-style">ផ្ទៃរលោង</span> ដោយផ្ទាល់។',
    selectTip: 'សូមជ្រើសរើសផ្ទាំងតូចដែលត្រូវការបំពេញខាងក្រោម',
    plankKeyWordPlaceholder: 'សូមបញ្ចូលឈ្មោះផ្ទាំង ឬលេខផ្ទាំង',
    surplusStoreSuccess: 'រក្សាទុកឃ្លាំងបានជោគជ័យ',
    editCutOrder: 'កែលំដាប់ការកាត់',
    setCutPoint: 'កំណត់ចំណុចចុះដារ',
    specialPaibanChangeErr: 'មានផ្ទាំងមានដំណើរការពិសេស ឬរន្ធគែម មិនទាន់គាំទ្រការប្ដូរផែនការរៀបចំ',
    storedSuccess: 'បំពេញបានជោគជ័យ! ផ្ទាំងដែលបានជ្រើសរើសត្រូវបានដាក់ចូលការគ្រប់គ្រងបំពេញ',
    noSurplus: 'រកមិនឃើញសម្ភារៈសល់ដែលប្រើបាន',
    selectErrTip: 'ផ្ទាំងសល់មិនអាចបំពេញបានទេ សូមជ្រើសរើសផ្ទាំងតូចធម្មតាមុន',
    noRoomIDTip: 'ផ្ទាំងនេះគ្មានលេខកន្លែង មិនអាចបំពេញចូលឃ្លាំងបាន សូមជ្រើសរើសផ្ទាំងតូចផ្សេងមុន',
    noPlank: 'រកមិនឃើញផ្ទាំង',
    noPaibanData: 'គ្មានទិន្នន័យរៀបចំ មិនអាចបន្តបាន',
    historyNameErr: 'សូមបញ្ចូលឈ្មោះផែនការ',
    tempErrTip: 'មិនបានបន្ថែមគំរូសម្រាប់ដីសគី ៥/៦ ផ្ទៃ ដូចនេះមិនអាចនាំចេញឯកសារដំណើរការបាន។ សម្គាល់៖ ក្រោយបន្ថែមត្រូវរៀបចំឡើងវិញ',
    changeDataTip: 'រកឃើញទិន្នន័យរបស់អ្នកបានផ្លាស់ប្ដូរ បង្កើតឯកសារប្រវត្តិថ្មីដើម្បីរក្សារបៀបនេះឬទេ?',
    upgrade: 'ធ្វើឱ្យទាន់សម័យ',
    upgradeTip: ' អ្នកអាចចុចប៊ូតុងខាងក្រោមដើម្បីធ្វើឱ្យជំនាន់ទាន់សម័យ',
    plankOverEdge: 'ទាញយកNCបរាជ័យ! សូមពិនិត្យផ្ទាំងជាន់គ្នា ឬនៅក្រៅផ្ទាំងធំ',
    useSurplusTip: 'តើដកសម្ភារៈសល់ឬទេ?',
    noDataExport: 'គ្មានទិន្នន័យរៀបចំដែលនាំចេញបាន',
    noPlankExport: 'គ្មានទិន្នន័យផ្ទាំងតូចដែលនាំចេញបាន',
    lockTip1: 'ចុចដើម្បីដោះសោ បន្ទាប់ពីដោះសោអាច',
    lockTip2: 'កែតំណែង និងលក្ខណៈផ្ទាំងតូចបាន',
    unlockTip1: 'ចុចដើម្បីចាក់សោ ក្រោយចាក់សោមិនអាច',
    unlockTip2: 'កែតំណែង និងលក្ខណៈផ្ទាំងតូចបានទេ',
    plankLockErr: 'ផ្ទាំងធំនេះចាក់សោ មិនអាចដាក់បាន',
    lockPartEditTip: 'ផ្ទាំងចាក់សោ មិនអាចកែបាន',
    glassEquipmentTip: 'នៅពេលបន្ទាត់ផលិតកម្មជាម៉ាស៊ីនកាត់កញ្ចក់ ផ្ទាំងមិនអាចផ្លាស់ទី',
    expandedTip: 'ផ្ទាំងមានដំណើរការរន្ធពិសេស មិនគាំទ្រប្រតិបត្តិការកែ',
    sameWidthPlankTip: 'បានបើកការរៀបចំដារដូចគ្នា ផ្ទាំងមិនអាចផ្លាស់ទី',
    expandedArrangeTip: 'ផ្ទាំងមានដំណើរការរន្ធពិសេស ត្រូវការរៀបចំឡើងវិញ',
    dragErrTip: 'មិនអាចដាក់បាន សូមពិនិត្យសម្ភារៈ ពណ៌ និងកម្រាស់ផ្ទាំង',
    subtleSaveTip: 'មានការប្ដូរលើផ្ទាំងដែលមិនទាន់រក្សា ចេញឬទេ?',
    rollTip: 'លើផ្ទាំងធំមានរណ្តៅ/រន្ធភ្លោះ មិនបានណែនាំឱ្យបញ្ច្រាស',
    glossRollErr: 'ផ្ទាំងរលោងហាមមិនឱ្យបញ្ច្រាស',
    lockDeleteErr: 'ផ្ទាំងចាក់សោ មិនអាចលុប',
    deleteConfirmTip: 'ប្រតិបត្តិការលុបមិនអាចស្ដារឡើងវិញ',
    deleteContinueTip: 'តើចង់បន្តទៀតទេ?',
    deleteConfirm: 'សូមបញ្ជាក់ការលុប',
    selectPlankTip: 'សូមជ្រើសរើសផ្ទាំងមុនប្រតិបត្តិការនេះ',
    storeFailTip: 'សម្ភារៈសល់រក្សាឃ្លាំងមិនបានជោគជ័យ! ពិនិត្យជាន់គ្នា ឬនៅក្រៅផ្ទាំងធំ',
    repeatStoreErr: 'ផ្ទាំងសល់ដែលកាត់ហើយបានរក្សាឃ្លាំងរួចហើយ',
    surplusStoreFail: 'រក្សាឃ្លាំងមិនបានជោគជ័យ សូមពិនិត្យផ្ទាំងជាចតុកោណ ឬរូបរាងL',
    plankConfilictErr: 'មិនគាំទ្រដាក់ចំណុចនៅទីនេះ នឹងប៉ះទង្គិចផ្ទាំងផ្សេង',
    surplusErrTip: 'មិនគាំទ្រដាក់ចំណុចនៅទីនេះ នឹងបង្កើតសម្ភារៈសល់ខុស',
    changeArrageSuccess: 'ប្ដូរផែនការរៀបចំបានជោគជ័យ',
    trialProduction: {
      trialProductionSample: 'ទូគំរូផលិតកម្មសាកល្បង',
      trialProduced: 'ខ្ញុំបានសាកល្បងផលិត',
      trialWarning: '{fontStyleStart}ប្រសិនបើ{fontStyleEnd} អ្នកមិនបានអនុវត្តការផ្ទៀងផ្ទាត់ការផលិតទូគំរូ ដែលបណ្តាលឱ្យមានការខាតបង់ទាំងអស់ និងផលអវិជ្ជមានចំពោះខ្លួនអ្នក អ្នកដទៃ និងសុហ្វវែររៀបចំពុម្ពអក្សរពពក ទំនួលខានុស័យទាំងមូលគឺជារបស់អ្នកផ្ទាល់។',
      trialSlotTip: 'នៅពេលផលិតសាកល្បង សូមពិនិត្យយ៉ាងប្រុងប្រយ័ត្នទំហំ ជម្រៅ ផ្ទៃ និងតំណែងរណ្តៅ/រន្ធមុខនិងក្រោយ',
      trialSlotTip1: 'ជៀសវាងរូបឆ្លុះទូ',
      trialSlotTip2: 'បញ្ហា',
      pleaseUploadTrial: 'សូមផ្ទុករូបភាពទូគំរូសាកល្បងបន្ទាប់ពីដំឡើងរួច',
      uploadTrial: 'ផ្ទុកទូគំរូ'
      },
    awaitPlankStore: {
      store: 'ឃ្លាំងផ្ទាំងរង់ចាំរៀបចំ',
      notTip: 'កុំរៀបរាប់ទៀតពីមិនទាន់រក្សាឃ្លាំង',
      justLookCurrent: 'មើលតែផ្ទាំងតូចនៃការបញ្ជាទិញបច្ចុប្បន្ន',
      notInPushStorage: 'មិនទាន់រក្សាឃ្លាំង',
      beInStorage: 'រក្សាទុកឃ្លាំងហើយ',
      searchPlaceholder: 'បញ្ចូលបញ្ជាទិញដើម្បីស្វែងរកផ្ទាំងតូចក្នុងឃ្លាំងរង់ចាំ',
      plankUploading: 'កំពុងរក្សាផ្ទាំង',
      oneClickStorage: 'ចុចមួយដងរក្សាចូលឃ្លាំងរង់ចាំ',
      notUsePlank: 'មិនមានផ្ទាំងតូចដែលប្រើបានជាបណ្តោះអាសន្ន',
      notPlank: 'គ្មានផ្ទាំងផ្ទុកអាចបណ្តោះអាសន្ន',
      dragPlankInHere: 'អូសផ្ទាំងមកទីនេះដើម្បីផ្ទុកជាបណ្តោះអាសន្ន',
      surplusCannotBeStorage: 'សម្ភារៈសល់មិនអាចរក្សាឃ្លាំង',
      plankHasBeenDeduction: 'ផ្ទាំងតូចត្រូវបានកាត់ចេញ ឬគ្មានទិន្នន័យដើម មិនអាចរក្សាឃ្លាំង',
      plankLoadErr: 'ផ្ទុកព័ត៌មានផ្ទាំងបរាជ័យ',
      taskTitle: 'ផ្ទុកផ្ទាំងនៅក្នុងឃ្លាំងរង់ចាំ',
      dataGenErr: 'កំហុសបង្កើតទិន្នន័យ',
      pushSuccess: 'រក្សាឃ្លាំងបានជោគជ័យ',
      pushErr: 'មានកំហុសមិនស្គាល់ រក្សាឃ្លាំងបរាជ័យ',
      awaitBoxExistPlank: 'ឃ្លាំងរង់ចាំមានផ្ទាំងតូចមិនទាន់រក្សាឃ្លាំង សូមរក្សាឃ្លាំងមុនប្រតិបត្តិការ',
      mergeFrameDoorWholeTip: 'ផ្ទាំងនៅក្នុងឃ្លាំងរង់ចាំមានផ្ទាំងតូចមិនទាន់រក្សាឃ្លាំង សូមរក្សាឃ្លាំងមុនប្រតិបត្តិការ',
      checkPlankStatus: 'កំពុងពិនិត្យស្ថានភាពផ្ទាំង...'
      },
    batchSetCut: 'កំណត់ចំណុចចុះដារជាក្រុម',
    applyTo: 'អាចអនុវត្តចំពោះ:',
    ncDownloadLifeText: {
      checkData: 'កំពុងពិនិត្យទិន្នន័យ',
      checkDone: 'ការពិនិត្យទិន្នន័យបានបញ្ចប់',
      checkDataText: 'ការពិនិត្យទិន្នន័យ',
      loadSetting: 'កំពុងផ្ទុកការកំណត់',
      settingLoadDone: 'ផ្ទុកការកំណត់បានបញ្ចប់',
      loadSettingText: 'ផ្ទុកការកំណត់',
      downloadNc: 'កំពុងទាញយកNC',
      ncDownloadDone: 'ទាញយកNCបានបញ្ចប់',
      downloadText: 'ទាញយកNC',
      loadPreferenceSetting: 'កំពុងផ្ទុកការកំណត់ចំណូលចិត្ត',
      PreferenceSettingLoadDone: 'ផ្ទុកការកំណត់ចំណូលចិត្តបានបញ្ចប់',
      loadPreferenceText: 'ផ្ទុកការកំណត់ចំណូលចិត្ត',
      dealTemp: 'កំពុងដំណើរការគំរូ',
      TempDealDone: 'ដំណើរការគំរូបានបញ្ចប់',
      dealTempText: 'ដំណើរការគំរូ',
      beBeingGenTagFile: 'កំពុងបង្កើតឯកសារ {fileType}',
      genTagFileDone: 'បានបង្កើតឯកសារ {fileType}',
      genTagFileText: 'បង្កើតឯកសារ {fileType}',
      zip: 'កំពុងបង្កើតឯកសារបង្គត់ក្នុងម៉ាស៊ីន',
      zipDone: 'បានបង្កើតឯកសារបង្គត់ក្នុងម៉ាស៊ីន',
      genZipText: 'បង្កើតឯកសារបង្គត់',
      fileTypeText: 'រូបភាព'
      },
    surplusCommonTemp: 'គំរូសម្ភារៈសល់ទូទៅ',
    plankErrTip: 'ផែនការសម្ភារៈមានផ្ទាំងតូចគ្មានផ្ទាំងធំសម្រាប់រៀបចំ',
    brandPlankErrTip: 'ផែនការសម្ភារៈបច្ចុប្បន្នមានផ្នែកម៉ាកដែលមិនមានផ្ទាំងម៉ាកសម្រាប់រៀបចំ!',
    overSizeTip: 'ផ្ទាំងធំមិនគ្រប់គ្រាន់ ឬលើសខ្នាត',
    uselessPart: 'លើផ្ទាំងធំបច្ចុប្បន្នគ្មានផ្ទាំងតូចប្រើបាន សូមរៀបចំឡើងវិញ',
    splitArranged: 'ផ្ទាំងតូចច្រើនពេក សូមរៀបចំឡើងវិញ ឬរៀបចំជាក្រុម',
    arrangedErrTip: 'រៀបចំបរាជ័យ៖ ផ្ទាំងធំមិនគ្រប់គ្រាន់ ឬផ្ទាំងតូចលើសខ្នាត',
    knivesModalTitle: 'មានរណ្តៅ/រន្ធរកមិនឃើញឧបករណ៍',
    cannotDownloadByKnivesErr: 'មិនអាចទាញយក NC បានទេ; ប្រព័ន្ធរកឃើញរណ្តៅ/រន្ធខាងក្រោមគ្មានឧបករណ៍',
    viewPart: 'មើលផ្ទាំងដែលមានបញ្ហា',
    deductionModalTitle: 'សូមជ្រើសរើសគោលដៅកាត់ចេញ',
    bujianDeduction: 'កាត់ចេញផ្ទាំងតូចបំពេញ',
    paibanDeduction: 'កាត់ចេញផ្ទាំងតូចនៅតំបន់ផ្ទុកជាបណ្តោះអាសន្ន',
    surplusDeduction: 'កាត់ចេញផ្ទាំងធំសម្ភារៈសល់',
    unlockPaiban: 'ដោះសោសម្ភារៈសល់ដែលចូលរួមរៀបចំ',
    maintain: 'រក្សាសោសម្ភារៈសល់ដែលចូលរួមរៀបចំ',
    lockModalText: 'ផ្ទាំងសល់ប្រើឡើវិញត្រូវបានការបញ្ជារផ្សេងប្រើ តើរៀបចំឡើងវិញឬទេ?',
    lockNewSModalText: 'ផ្ទាំងសល់ត្រូវការបញ្ជារផ្សេងប្រើ តើបន្តទាញយក NC ឬទេ?',
    rePaibanWarn: 'ផ្ទាំងសល់ត្រូវបានការបញ្ជារផ្សេងចាប់យោ ផ្ទាំងធំមិនគ្រប់គ្រាន់ សូមរៀបចំឡើងវិញពីបញ្ជីកាត់',
    sawRePaiban: 'កត់សម្គាល់៖ ប្រើកាំបិតកាត់ បានបន្ថែមការរៀបចំផ្ទាំងរាងមិនធម្មតា ត្រូវរៀបចំឡើងវិញដើម្បីទាញយក NC',
    togglePlankTip: 'ផ្ទាំងមានរន្ធពិសេស មិនគាំទ្រប្តូរផ្ទៃមុខ/ក្រោយ',
    stepCuttingMsg: 'ជម្រៅកាត់ជាន់ទ្រែត្រូវតិចជាងកម្រាស់ផ្ទាំង',
    stepCuttingMsg2: 'ជម្រៅកាត់ជាន់ទ្រែត្រូវជាលេខធំជាង ០ ប៉ុណ្ណោះ',
    flipPlankTip: 'បានបើកដំណើរការរណ្តៅ/រន្ធបំបែក មិនអាចបញ្ច្រាសផ្ទាំង',
    genNoCutTagNotSupportExportPic: 'បានបើកបង្កើតស្លាកផ្ទាំងមិនកាត់ មិនទាន់គាំទ្រនាំចេញរូប',
    allSmallPlanksAreNoCutNotInLayout: 'ផ្ទាំងតូចទាំងអស់ជាផ្ទាំងមិនកាត់ មិនចូលរួមរៀបចំ',
    canStillExportHoleSlotOrPrintTag: 'អ្នកអាចបន្តនាំចេញឯកសារដំណើរការរណ្តៅ/រន្ធ ឬបោះពុម្ពស្លាក',
    desMaterialNoCutNotSupportSwitchLine: 'បើកម៉ូដផ្ទាំងតូចបានកំណត់មិនកាត់ មិនគាំទ្រប្ដូរបន្ទាត់ផ្ទាល់',
    desMaterialNoCutSettingChanged: 'ប្រព័ន្ធរកឃើញការកំណត់ផ្ទាំងតូចមិនកាត់បានផ្លាស់ប្ដូរ សូមរៀបចំឡើងវិញដើម្បីភាពត្រឹមត្រូវ',
    continueDownload: 'បន្តទាញយក',
    desMaterialNoCutErrorTip: 'មានរណ្តៅ/រន្ធ/រាងបញ្ជូលម៉ាស៊ីនចិញ្ចៀននៅលើផ្ទាំងមិនកាត់។ ការទាញយកនេះគ្របទាំងអស់ទៅដីសគី ៥/៦ ផ្ទៃ។ បន្តទាញយកឯកសារឬទេ?',
    clearReuseRelation: 'ចុចដើម្បីលុបទំនាក់ទំនងការប្រើប្រាស់ម្តងទៀត',
    layoutReuseTip: 'ចម្លងប្លង់បន្ទះធំយ៉ាងលឿន ការផ្លាស់ប្តូរបន្ទះនឹងលុបទំនាក់ទំនងការប្រើប្រាស់ម្តងទៀតដោយស្វ័យប្រវត្តិ',
    hasBeenReused: 'បានប្រើប្រាស់ម្តងទៀតរួចហើយ',
    layoutReuse: 'ប្រើប្រាស់ប្លង់ម្តងទៀត',
    specialProcessNotSupported: 'បន្ទះមានដំណើរការពិសេស មិនគាំទ្រប្រតិបត្តិការនេះទេ',
    conflictNotSupported: 'បន្ទះមានជម្លោះ មិនគាំទ្រប្រតិបត្តិការនេះទេ',
    noAvailablePlankForReuse: 'មិនមានបន្ទះដែលអាចប្រើប្រាស់ម្តងទៀតបានទេ',
    noMatchingPlankFound: 'រកមិនឃើញបន្ទះដែលត្រូវគ្នាទេ',
    reuseBoard: '{number} បន្ទះប្រើប្រាស់ម្តងទៀត',
    influenceTip: {
      title: 'មុខងារដែលមានឥទ្ធិពលលើអត្រាប្រសើរឡើង',
      empty: 'គ្មាន',
      groupParams: 'ប៉ារ៉ាម៉ែត្រនៃការរៀបចំ',
      surplusNoRoll: 'សម្ភារៈសល់មិនត្រឡប់',
      surplusCustomTrim: 'តម្លៃកាត់គែមដាច់ដោយឡែក',
      otherPlateCustomTrim: 'តម្លៃកាត់គែមដាច់ដោយឡែកសម្រាប់ផ្ទាំងពិសេស',
      knifeDiameter: 'កាត់គែមកាត់គែម',
      surplusNoFlip: 'សម្ភារៈសល់មិនត្រឡប់',
      surplusNotLayout: 'សម្ភារៈសល់មិនត្រឡប់មិនបង្កើតកាត់គែមដាច់ដោយឡែក',
      plankEdgeOff: 'កាត់គែមដាច់ដោយឡែក',
      surplusCustomTrim2: 'ការកែប្រែការផ្គូរផ្គងការបន្ថែម',
      other: 'មុខងារផ្សេងទៀតដែលអាចរងផលប៉ះពាល់',
      enabled: 'បើកបាន',
      plankThicknessStacking: 'ការផ្គូរផ្គងការបន្ថែម',
      edgePreMilling: 'ការផ្គូរផ្គងការបន្ថែម',
      multiMaterialCuttingBlade: 'ការផ្គូរផ្គងការបន្ថែម',
      sawSpecialShapePart: 'បន្ទះមានស្នាមកាត់រាងពិសេសសម្រាប់ម៉ាស៊ីនកាត់ និងឆ្លាក់',
      longPlankCutting: 'ការផ្គូរផ្គងការបន្ថែម'
      }
    },
  paibanImg: {
    title: 'ការគ្រប់គ្រងរូបរៀបចំ',
    exportCustomPaibanImg: 'នាំចេញរូបរៀបចំតម្លាប់ខ្លួនឯង',
    customPaibanImg: 'រូបរៀបចំតម្លាប់ខ្លួនឯង',
    isCustomName: 'ឈ្មោះរូបរៀបចំតម្លាប់ខ្លួនឯង',
    template: 'គំរូរូបរៀបចំ',
    addTem: 'បន្ថែមគំរូ',
    canvasIndexSearch: 'ស្វែងរកលេខលំដាប់ផ្ទាំងធំ',
    symbol: 'សញ្ញារូបរៀបចំ',
    frontSlot: 'រន្ធខាងមុខ',
    backSlot: 'រន្ធខាងក្រោយ',
    frontHole: 'រណ្តៅខាងមុខ',
    backHole: 'រណ្តៅខាងក្រោយ',
    printNum: 'បង្ហាញបានច្រើនបំផុតក្នុងក្រដាសមួយ',
    printUnit: 'រូបរៀបចំ (ឯកតា)',
    edit: 'កែគំរូរូបរៀបចំ',
    temName: 'ឈ្មោះគំរូ',
    rotate: 'បង្វិលរូបរៀបចំ',
    showOverflow: 'នៅពេលអក្សរលើសផ្ទាំង បន្ទាត់សម្គាល់បង្ហាញទិន្នន័យផ្ទាំងតូច',
    showHoleSlot: 'បង្ហាញព័ត៌មានរណ្តៅ និងរន្ធ',
    bigPartCss: 'កែរចនារូបផ្ទាំងធំ',
    partCss: 'កែរចនារូបផ្ទាំងតូច',
    addTemTip: 'អាចបន្ថែមគំរូរូបរៀបចំអតិបរមា ១០',
    exportTip: 'សូមជ្រើសរើសគំរូយ៉ាងហោចណាមួយដើម្បីនាំចេញ',
    editSaveTip: 'សូមបញ្ជាក់បានបំពេញវាលចាំបាច់មុនរក្សា',
    exportDXF: 'នាំចេញ DXF',
    exportDxfGeneral: 'DXF ទូទៅ 2D',
    exportDxf3d: 'DXF ពិសេស 3D',
    exportDxfGeneralTip: 'សមស្របសម្រាប់កែច្នៃដោយដៃ កាត់តាមគំនូរ ឬពិនិត្យលទ្ធផលរៀបចំ',
    exportDxf3dTip: 'សមស្របសម្រាប់នាំចូលទៅប្រព័ន្ធភាគីទីបីសម្រាប់ផលិតកម្ម គាំទ្រម៉ាស៊ីនកាត់ឡាស៊ែររួមបញ្ចូល Huiya'
    },
  historyPage: {
    matchErrBySpecialTip1: 'ផ្ទាំងធំពិសេសខាងក្រោមរកមិនឃើញគូ—រៀបចំឡើងវិញនឹងមានបញ្ហា។ ប្រើផែនការលាយឡំ សូមមិនអើពើការព្រមាននេះ',
    specialPlankInfoErrTip2: 'ទទួលព័ត៌មានផ្ទាំងធំពិសេសមិនបានសម្រេច នឹងប៉ះពាល់មុខងាររៀបចំឡើងវិញ',
    download: 'ទាញយកក្នុងម៉ាស៊ីន',
    allType: 'រក្សាទាំងអស់',
    handleSave: 'រក្សាដោយដៃ',
    specialPlank: 'ការពិន្ទុ',
    surplusPlank: 'បន្ថែម',
    autoSave: 'រក្សាស្វ័យប្រវត្តិ',
    allArrange: 'រៀបចំទាំងអស់',
    searchPlaceholder: 'ស្វែងរកឈ្មោះការបញ្ជាទិញ / ការជ្រើសរើសបាច់រៀបចំ / លេខការបញ្ជាទិញ',
    saveHistoryName: 'ឈ្មោះប្រវត្តិដែលបានរក្សាទុក',
    trailProduction: {
      title: 'ទូគំរូផលិតកម្មសាកល្បង',
      lastTime: 'កាលបរិច្ឆេទសាកល្បងផលិតចុងក្រោយ',
      recordList: 'កំណត់ត្រាសាកល្បងផលិត',
      start: 'ចាប់ផ្តើមសាកល្បងផលិត',
      date: 'ពេលវេលា',
      outputFrom: 'ទីតាំងចេញ',
      empty: 'គ្មានទិន្នន័យ',
      record: 'កំណត់ត្រារូបទូគំរូសាកល្បងដែលបានផ្ទុក',
      tip1: 'កត់សម្គាល់៖ ការបញ្ជារសាកល្បងប្រើទិន្នន័យផលិតលំនាំដើម',
      tip2: 'កត់សម្គាល់៖ ការបញ្ជារសាកល្បងមិនប្រើប៉ារ៉ាម៉ែត្រដំណើរការចុងក្រោយ ចូលបន្ទប់សាកល្បងដើម្បីរក្សាឡើងវិញ',
      download: 'ទាញយកឯកសារដំណើរការ'
      },
    deleteTip: 'បញ្ជាក់លុបកំណត់ត្រាប្រវត្តិខាងក្រោម?',
    startDate: 'កាលបរិច្ឆេទចាប់ផ្តើម',
    endDate: 'កាលបរិច្ឆេទបញ្ចប់',
    lastWeek: 'មួយសប្តាហ៍ចុងក្រោយ',
    lastMonth: 'មួយខែចុងក្រោយ',
    lastSeason: 'បីខែចុងក្រោយ',
    toArrangePage: 'កំពុងទៅទំព័ររៀបចំ',
    notArrangedTip: 'កំណត់ត្រានេះមិនធ្វើរៀបចំ សូមទៅបញ្ជីកាត់មុន',
    toMaterialPage: 'កំពុងទៅទំព័របញ្ជីកាត់',
    lessSelectTip: 'ជ្រើសរើសយ៉ាងហោចណាមួយកំណត់ត្រាមុនធ្វើ',
    downloadNc: 'ទាញយកឯកសារដំណើរការ'
    },
  workShopPage: {
    warningTip: 'មុខងារនេះជាការសាកល្បងកំណត់ពេល សូមរៀបចំការផលិតការបញ្ជារឲ្យសមរម្យ',
    fileManager: 'ការគ្រប់គ្រងឯកសារផលិត',
    selected: 'បានជ្រើសរើស',
    suplement: 'ឃ្លាំងបំពេញ',
    size: 'ទំហំ',
    saveToStore: 'បន្ថែមទៅឃ្លាំងបំពេញ',
    enterArrange: 'កំពុងចូលរៀបចំ...',
    deleteTip: 'ទិន្នន័យនេះលុបរួចមិនអាចស្តារឡើងវិញ បញ្ជាក់លុប?',
    arrangeTip: 'កំពុងញែកទិន្នន័យបំពេញ សូមរង់ចាំ...',
    store: 'ឃ្លាំងបំពេញ',
    downloadFile: 'ទាញយកឯកសារផលិត',
    notBujianFile: 'រកមិនឃើញឯកសារបំពេញ',
    productLineDelete: 'បន្ទាត់ផលិតនេះត្រូវបានលុប មិនអាចទាញយក NC!'
    },
  basePlankManager: {
    saveTip: 'ចំណាំ៖ ចុច Enter ដើម្បីរក្សា',
    offsetSize: 'ទំហំកាត់គែម',
    overSizeTip: 'នៅពេលខ្នាតធំពេក ប្រព័ន្ធរើសផ្ទាំងធំធ្វើរៀបចំស្វ័យប្រវត្តិ',
    addTip: 'នៅពេលរៀបចំលើសខ្នាត បង្ហាញប្រអប់បន្ថែមផ្ទាំងធំពិសេស',
    defaultOversizePlankValue: 'ផ្ទាំងធំលើសខ្នាតរៀបតែផ្ទាំងតូចលើសខ្នាត',
    onlyLayoutTooBig: 'ផ្ទាំងធំលើសខ្នាតរៀបតែផ្ទាំងតូចលើសខ្នាត',
    settingRemark: 'ចំណាំ៖ មុខងារនៅទីនេះបានផ្លាស់ទៅការកំណត់ខាងស្តាំ',
    searchPlaceholder: 'ស្វែងរកសម្ភារៈ/ពណ៌ផ្ទាំង',
    syncData: 'សមកាលកម្មទិន្នន័យទូ Guigui',
    syncDataM: 'សមកាលកម្មទិន្នន័យទ្វារទូ',
    deletePlank: 'លុបផ្ទាំងធំពិសេស',
    addPlank: 'បង្កើតផ្ទាំងពិសេសថ្មី',
    matCodePlaceholder: 'សូមជ្រើសរើសផ្ទាំង',
    thickPlaceHolder: 'សូមជ្រើសរើសកម្រាស់',
    widthErr: 'ទទឹងផ្ទាំងមិនអាចទទេ',
    heightErr: 'ប្រវែងផ្ទាំងមិនអាចទទេ',
    matCodeErr: 'សម្ភារៈផ្ទាំងមិនអាចទទេ',
    colorErr: 'ពណ៌ផ្ទាំងមិនអាចទទេ',
    editPlank: 'កែផ្ទាំង',
    deleteTip: 'ទិន្នន័យនេះលុបរួចមិនអាចស្តារ បញ្ជាក់លុប?',
    plankKnifeSelect: 'ជ្រើសរើសដារកាត់ផ្ទាំងដើម',
    plankKnifeSelectTip: 'នៅពេលត្រូវច្បាប់ច្រើន កម្រាស់ផ្ទាំងមានអាទិភាពខ្ពស់ជាងសម្ភារៈ',
    knifeSelectTip: 'ចំណាំ៖ រៀបចំខាងក្នុងមិនគាំទ្រមុខងារនេះ',
    knife: 'ឧបករណ៍កាត់',
    matcodeInput: 'បញ្ចូលសម្ភារៈផ្ទាំង',
    thickInput: 'បញ្ចូលកម្រាស់ផ្ទាំង',
    default: 'លំនាំប្រព័ន្ធ',
    unessential: 'ជួរនេះ៖ មិនចាំបាច់',
    emptyTip: 'ចំណាំ៖ បើមិនបំពេញ ពេលផ្គូផ្ទាំងដើមនឹងមិនបែងចែកទិន្នន័យនេះ',
    defaultUse: 'ជ្រើសលំនាំដើម',
    editMatcode: 'កែសម្ភារៈ',
    syncTip: 'នឹងយកទិន្នន័យពី {fromMc} និងសរសេរជាន់លើទិន្នន័យគ្រប់គ្រងផ្ទាំងដើមនៅក្នុងរៀបចំពពក សមកាលឬទេ?',
    sameErr: 'មានទិន្នន័យដូចគ្នារួចហើយ',
    cancelDelete: 'បានលុបការលុប',
    syncErr: 'សមកាលកម្មបរាជ័យ',
    syncSuccess: 'សមកាលកម្មជោគជ័យ',
    syncDataTip: 'សមកាលកម្មទិន្នន័យ {fromMc}',
    editErrTip: 'មានព័ត៌មានមិនទាន់បំពេញ សូមពិនិត្យ!',
    numberCheck: '{type} បញ្ចូលបានតែលេខ',
    deleteStandardPlate: 'ដកផ្ទាំងស្តង់ដារ',
    createStandardPlate: 'ផ្ទាំងស្តង់ដារថ្មី',
    editStandardPlate: 'កែផ្ទាំងស្តង់ដារ',
    trimmingDimension: 'ទំហំកាត់គែម',
    front: 'លើ',
    back: 'ក្រោម',
    left: 'ឆ្វេង',
    right: 'ស្តាំ',
    frontTrim: 'កាត់គែមលើ',
    backTrim: 'កាត់គែមក្រោម',
    leftTrim: 'កាត់គែមឆ្វេង',
    rightTrim: 'កាត់គែមស្តាំ',
    customTrim: 'តម្លៃកាត់គែមតម្លាប់ខ្លួនឯង',
    trimValue: 'តម្លៃកាត់គែម',
    notEmpty: '{type} មិនអាចទទេ',
    edgeDir: 'កាត់គែម ({type})',
    brandPlank: 'ផ្ទាំងម៉ាក',
    brandPlankTip: 'ចំណាំ: ការលុបនិងការកែប្រែផ្ទាំងម៉ាកត្រូវបានធ្វើនៅក្នុងបណ្ណាល័យធនធានផ្ទាំងរបស់កម្មវិធី Cabinet',
    brand: 'ម៉ាក',
    supplier: 'អ្នកផ្គត់ផ្គង់',
    brandPlaceholder: 'សូមជ្រើសម៉ាក',
    supplierPlaceholder: 'សូមជ្រើសអ្នកផ្គត់ផ្គង់',
    brandInput: 'សូមបញ្ចូលម៉ាក',
    supplierInput: 'សូមបញ្ចូលអ្នកផ្គត់ផ្គង់',
    addBrandPlank: 'បន្ថែមផ្ទាំងម៉ាក',
    deleteBrandPlank: 'លុបផ្ទាំងម៉ាក',
    editBrandPlank: 'កែសម្រួលផ្ទាំងម៉ាក',
    searchBrandPlaceholder: 'ស្វែងរកម៉ាក/អ្នកផ្គត់ផ្គង់/វត្ថុធាតុ/ពណ៌'
    },
  bujianAndStore: {
    bujianStore: 'ឃ្លាំង Bujian',
    awaitStore: 'ឃ្លាំងផ្ទាំងរង់ចាំរៀបចំ',
    depositAwaitStore: 'រក្សាទៅឃ្លាំងរង់ចាំរៀបចំ',
    pushToAwaitStore: 'ដាក់ទៅឃ្លាំងរង់ចាំរៀបចំ',
    useTwoTableArrange: 'រៀបចំដោយទម្រង់ពីរ',
    confirmUseTwoTableTip: 'ផ្ទាំងតូចដែលជ្រើសមានទាំងឃ្លាំងបំពេញ និងរង់ចាំរៀបចំ បន្តរៀបចំឬទេ?',
    confirmAddPlankToAwaitStore: 'បញ្ជាក់បន្ថែមផ្ទាំងដែលជ្រើសទៅឃ្លាំងរង់ចាំរៀបចំ?',
    pushStoreSuccess: 'ចូលឃ្លាំងជោគជ័យ',
    dataGenErr: 'កំហុសបង្កើតទិន្នន័យ',
    unknownErr: 'កំហុសមិនស្គាល់ ចូលឃ្លាំងបរាជ័យ'
    },
  surplusPage: {
    surplusMaterial: 'បញ្ជីសម្ភារៈសល់',
    surplusStore: 'ឃ្លាំងសម្ភារៈសល់',
    recycleBin: 'ឃ្លាំងសម្ភារៈសល់',
    recycleBinTip: 'ទិន្នន័យសម្ភារៈសល់នៅក្នុងធុងសំរាមនឹងត្រូវលុបដោយស្វ័យប្រវត្តិ បន្ទាប់ពីមួយរយៈ ៩០ ថ្ងៃ',
    "deleteReason-0": 'លុបដោយដៃ',
    "deleteReason-1": 'កាត់បន្ថយដោយ​តម្រៀប​ទំព័រ',
    "deleteReason-2": 'ចេញឃ្លាំងតាមប្រតិបត្តិការ Guigui មូបាញ់',
    surplusShape: 'រូបរាងសម្ភារៈសល់',
    batchTransfer: 'ផ្ទេរជាក្រុម',
    createNewSurplusStore: 'ឃ្លាំងសល់ថ្មី',
    pushStoreSetting: 'ការកំណត់ចូលឃ្លាំងសល់',
    surplusStoreName: 'ឈ្មោះឃ្លាំងសល់',
    surplusStoreName2: 'ឈ្មោះឃ្លាំងសល់',
    addSurplusStore: 'បន្ថែមឃ្លាំងសល់',
    inventoryCeiling: 'ដែនកំណត់ស្តុកអតិបរមា',
    autoTransferTip: 'បន្ទាប់ពីលុប សម្ភារៈសល់ក្នុងឃ្លាំងនឹងផ្ទេរទៅបញ្ជីសល់ស្វ័យប្រវត្តិ',
    asIndexPushStore: 'ចូលឃ្លាំងតាមលំដាប់ស្ថានភាពផ្ទុក',
    pushToSurplusMaterial: 'រក្សាទៅបញ្ជីសម្ភារៈសល់',
    surplusStoreTable: {
      number: 'លេខ',
      name: 'ឈ្មោះឃ្លាំងសល់',
      quantity: 'ចំនួនសល់ដែលបានរក្សា (ឯកតា)',
      capacity: 'ដែនកំណត់ស្តុកសល់អតិបរមា (ឯកតា)',
      rules: 'ច្បាប់ចូលឃ្លាំងសល់',
      remark: 'កំណត់សម្គាល់',
      operation: 'ប្រតិបត្តិការ'
      },
    editSurplusStore: 'កែឃ្លាំងសល់',
    addSurplus: 'បន្ថែមសម្ភារៈសល់',
    importSurplus: 'នាំចូលសម្ភារៈសល់',
    downloadSurplusTemplate: 'ទាញយកគំរូនាំចូលសល់',
    batchExportSurplus: 'នាំចេញបញ្ជីសល់បច្ចុប្បន្ន',
    surplusBatchImportExport: 'នាំចូល/នាំចេញសល់ជាក្រុម',
    surplusMaterialStorageCode: 'កូដចូលឃ្លាំងសល់',
    generateQRCodeSuccess: 'បង្កើតកូដ QR ជោគជ័យ',
    generateQRCodeFailed: 'បង្កើតកូដ QR បរាជ័យ',
    refreshQRCode: 'ធ្វើកូដ QR ឡើងវិញ',
    refreshQRCodeFailed: 'ធ្វើកូដ QR ឡើងវិញបរាជ័យ',
    cancelRefresh: 'បានលុបការធ្វើឡើងវិញ',
    refreshQRCodeTip: 'ធ្វើកូដ QR ឡើងវិញឬ? កូដបច្ចុប្បន្ននឹងអស់សុពលភាពបន្ទាប់ពីធ្វើឡើងវិញ។',
    refreshQRCodeConfirm: 'បញ្ជាក់',
    refreshQRCodeCancel: 'បោះបង់',
    wechatScanTip: 'បើក WeChat ស្កេន QR ដើម្បីបន្ថែមសម្ភារៈសល់ដោយដៃចូលឃ្លាំង',
    deletSurplus: 'លុបសម្ភារៈសល់',
    editSurplus: 'កែសម្ភារៈសល់',
    surplusNoRoll: 'បើកដំណើរការសម្ភារៈសល់ដោយមិនបត់បែនឡើងវិញ',
    type: {
      all: 'រូបរាងទាំងអស់'
      },
    allMatcode: 'សម្ភារៈទាំងអស់',
    allThick: 'កម្រាស់ទាំងអស់',
    surplusName: 'ឈ្មោះសម្ភារៈសល់',
    rectSurplus: 'សម្ភារៈសល់រាងចតុកោណ',
    LTypeSurplus: 'សម្ភារៈសល់រាង L',
    noMatchSup: 'រកមិនឃើញទិន្នន័យពាក់ព័ន្ធ',
    jumpTo: 'ទៅ',
    page: 'ទំព័រ',
    newMatcode: 'បង្កើតសម្ភារៈថ្មី',
    newColor: 'បង្កើតពណ៌ថ្មី',
    autoCreateColor: 'ចុច Enter ដើម្បីបង្កើតកាតពណ៌ស្វ័យប្រវត្តិ',
    nameLimit: 'ឈ្មោះសល់អតិបរមា ១០ តួអក្សរ',
    nameLimitNameErr: 'ឈ្មោះសល់មិនអាចទទេ',
    tempLongTip: 'ប្រវែងផ្ទាំងបញ្ចូលបានតែលេខ',
    minLongLimit: 'ប្រវែងគែមខ្លីបញ្ចូលបានតែលេខ',
    minLongEmptyTip: 'ប្រវែងគែមខ្លីមិនអាចទទេ',
    minLongLimitMax: 'ប្រវែងគែមខ្លីមិនអាចលើសប្រវែងផ្ទាំង',
    widthLimit: 'ទទឹងផ្ទាំងបញ្ចូលបានតែលេខ',
    minWidthLimit: 'ទទឹងគែមខ្លីបញ្ចូលបានតែលេខ',
    minWidthEmptyLimit: 'ទទឹងគែមខ្លីមិនអាចទទេ',
    minWidthLimitMax: 'ទទឹងគែមខ្លីមិនអាចលើសទទឹងផ្ទាំង',
    thickLimit: 'កម្រាស់ផ្ទាំងបញ្ចូលបានតែលេខ',
    thickEmptyLimit: 'កម្រាស់ផ្ទាំងមិនអាចទទេ',
    countInputLimit: 'បរិមាណត្រូវជាគត់ធម្មជាតិវិជ្ជមាន',
    countEmptyLimit: 'បរិមាណមិនអាចទទេ',
    remarkMaxlimit: 'កំណត់សម្គាល់អតិបរមា ៥០ តួ',
    orderAddressMaxlimit: 'អាសយដ្ឋានការបញ្ជារប្រភពអតិបរមា ១០០ តួ',
    orderIdMaxlimit: 'លេខការបញ្ជារប្រភពអតិបរមា ១០០ តួ',
    createTime: 'ពេលវេលាបន្ថែម',
    deleteTime: 'ពេលវេលាលុប',
    deleteReason: 'ការលុបសម្រាប់ការសម្រាប់',
    branchName: 'ឃ្លាំងសល់ដែលស្ថិតនៅ',
    orderAddress: 'អាសយដ្ឋានការបញ្ជារប្រភព',
    orderId: 'លេខការបញ្ជារប្រភព',
    lockStatus: 'ស្ថានភាពសោ',
    lockOrder: 'ការបញ្ជារចាក់សោ',
    enableSurplusLock: 'បើកមុខងារចាក់សោសម្ភារៈសល់',
    isCloseSurplusLock: 'បន្ទាប់ពីបិទ សម្ភារៈសល់ទាំងអស់នឹងដោះសោ បន្តឬទេ?',
    confirm: 'បញ្ជាក់ការបិទ',
    surplusTransfer: 'ផ្ទេរសម្ភារៈសល់',
    targetSurplusStore: 'ឃ្លាំងសល់គោលដៅ',
    enableSurLockTip: 'បើករួច រៀបចំរាល់ដងសម្ភារៈសល់ដែលប្រើនឹងចាក់សោ ការបញ្ជារផ្សេងមិនអាចប្រើ',
    addMainRule: 'បន្ថែមច្បាប់ចម្បង',
    surplusRules: 'ច្បាប់ចូលឃ្លាំងសម្ភារៈសល់',
    mainRulesTip: 'ច្បាប់ចម្បងជាទំនាក់ទំនង OR បំពេញមួយគឺចូលឃ្លាំង',
    mainRulesTip1: 'បន្ទាប់ពីបន្ថែមច្បាប់ សល់ដែលត្រូវគ្នាចូលឃ្លាំងនេះមុន ពេញហើយទៅឃ្លាំងទំនេរ',
    rule: 'ច្បាប់',
    addSubRule: 'បន្ថែមច្បាប់រង',
    subRuleTip: 'ច្បាប់រងជា AND ត្រូវបំពេញទាំងអស់ក្រោមច្បាប់ចម្បងទើបចូលឃ្លាំង',
    bigPlankMatCode: 'សម្ភារៈផ្ទាំងធំ',
    bigPlankThick: 'កម្រាស់ផ្ទាំងធំ',
    bigPlankColor: 'ពណ៌ផ្ទាំងធំ',
    greaterEqual: 'ធំជាងឬស្មើ',
    lessEqual: 'តូចជាងឬស្មើ',
    capNumberCheck: 'ដែនកំណត់ស្តុកអតិបរមាបញ្ចូលបានតែគត់ធម្មជាតិ',
    capEmptyCheck: 'ដែនកំណត់ស្តុកអតិបរមាមិនអាចទទេ',
    surNameEmptyCheck: 'ឈ្មោះឃ្លាំងសល់មិនអាចទទេ',
    mainRuleLimit: 'ច្បាប់ចម្បងដល់ដែនកំណត់អតិបរមា',
    delMainRuleTip: 'លុបច្បាប់ចម្បងនេះឬ?',
    matCodeEmptyCheck: 'សម្ភារៈផ្ទាំងធំមិនអាចទទេ',
    thickEmptyCheck: 'កម្រាស់ផ្ទាំងធំមិនអាចទទេ',
    textureEmptyCheck: 'ពណ៌ផ្ទាំងធំមិនអាចទទេ',
    enableWarehouseSecondCon: 'បើកការបញ្ជាក់ទីពីរសម្រាប់ចូលឃ្លាំងសល់',
    surplusWarehouseConfirm: 'ការបញ្ជាក់ចូលឃ្លាំងសល់',
    surplusWarehouseConfirm1: 'ការបញ្ជាក់ចូលឃ្លាំង',
    closeSurplusConfirm: 'បិទការបញ្ជាក់ចូលឃ្លាំង (បើកឡើងវិញនៅការកំណត់ទំព័រគ្រប់គ្រងសល់)',
    position: 'ទីតាំងរក្សា',
    nameRepeatTip: 'មានឈ្មោះសល់នេះរួច សូមកែហើយចូលឃ្លាំងឡើងវិញ',
    surLimitTip: 'ឃ្លាំងសល់ដល់ដែនកំណត់ឬមិនបំពេញច្បាប់ចូលឃ្លាំង',
    surFailTip: 'ចូលឃ្លាំងបរាជ័យ៖ ឈ្មោះស្ទួន ឬពេញ ឬមិនត្រូវច្បាប់',
    surplusExistTip: 'សម្ភារៈសល់មួយចំនួននៅក្នុងឃ្លាំងរួច ប្រតិបត្តិការបរាជ័យ',
    surplusExistTip2: 'សម្ភារៈសល់បច្ចុប្បន្ននៅក្នុងឃ្លាំងរួច មិនអាចចូលឃ្លាំង',
    currentPage: 'ទំព័របច្ចុប្បន្ន',
    totalPage: 'ជ្រើសទាំងអស់'
    },
  printPage: {
    goto: 'ទៅភ្លាមៗ',
    surplusSizeTittle: 'ការព្រមានទំហំសល់តូចពេក',
    surplusSizeErrTip: 'ទំហំសល់តូចពេក សូមទៅបន្ទាត់ផលិតកំណត់ទំហំអប្បបរមា',
    opacityTip: 'គាំទ្របច្ចេកទេសដោយ EZsort',
    opacityTip2: 'គណនីមិនទាន់ទិញ Smart Color Labels បើទិញរួច សូមភ្ជាប់គណនីទូនៅកម្មវិធី Color Label',
    loadFontTip: 'កំពុងផ្ទុកធនធានពុម្ពអក្សរ សូមរង់ចាំ',
    leftAlign: 'តម្រឹមឆ្វេង',
    rightAlign: 'តម្រឹមស្តាំ',
    topAlign: 'តម្រឹមលើ',
    bottomAlign: 'តម្រឹមក្រោម',
    horizontalAlign: 'តម្រឹមកណ្តាលផ្ដេក',
    verticalAlign: 'តម្រឹមកណ្តាលបញ្ឈរ',
    horizontalSplit: 'ចែកស្មើផ្ដេក',
    verticalSplit: 'ចែកស្មើបញ្ឈរ',
    norTag: 'ស្លាកធម្មតា',
    surTag: 'ស្លាកផ្ទាំងធំសល់',
    genTag: 'បង្កើតស្លាក',
    all: 'ជ្រើសរើសទាំងអស់',
    deleteWarning: 'ការរំលឹកដ៏កក់ក្តៅ',
    print: 'បោះពុម្ព',
    defaultTemplate: 'ពុម្ពដើម (60 x 40)',
    editTemplate: 'កែសម្រួលពុម្ព',
    deleteTip: 'ការលុបពុម្ពនេះមិនអាចស្តារឡើងវិញបានទេ។ តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    tagSetting: 'ការកំណត់ស្លាក',
    rememberSetting: 'ការកំណត់នឹងត្រូវបានចងចាំបន្ទាប់ពីកែប្រែ',
    genCutingTag: 'បង្កើតស្លាកផ្ទាំងកាត់',
    genSurplusTag: 'បង្កើតស្លាកសម្ភារៈសល់',
    genPlankTag: 'បង្កើតស្លាកផ្ទាំងធំ',
    genPartTag: 'បង្កើតស្លាកផ្ទាំងតូច',
    genNoCutTag: 'បង្កើតស្លាកផ្ទាំងមិនកាត់',
    tagPosition: 'ទីតាំងស្លាក',
    tagPositionTip: '(មានតែម៉ាស៊ីនដាក់ស្លាកប៉ុណ្ណោះដែលត្រូវបំពេញកូអរដោនេ X/Y ខាងក្រោម)',
    Xposition: 'កូអរដោនេ X',
    Yposition: 'កូអរដោនេ Y',
    genPlankSuffix: 'បច្ច័យឈ្មោះឯកសារសម្រាប់ស្លាកផ្ទាំងធំ',
    arrangeMirror: 'រូបភាពស្លាកឆ្លុះ',
    drillPlankBase: 'ស្តង់ដារដាក់ផ្ទាំងសម្រាប់រន្ធដោតប្រាំ ឬប្រាំមួយមុខ',
    drillPlankBaseTip: 'មិនអាចទាញយកទិន្នន័យមូលដ្ឋានសម្រាប់ដាក់ផ្ទាំងបានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!',
    suitAuto: 'ការរៀបចំស្លាកសម្របទៅនឹងការផ្ទុក/ចុះសម្ភារៈស្វ័យប្រវត្តិ៖',
    colorLabel: 'បង្កើតស្លាកពណ៌',
    colorRevert: 'បង្កើតស្លាកពណ៌បញ្ច្រាសសម្រាប់ផ្ទាំងតូច',
    displayEnAndZh: 'បង្ហាញឈ្មោះបន្ទប់/ទូ/ផ្ទាំងជាភាសាអង់គ្លេស និងចិន',
    displayEnAndZhTip: 'គាំទ្រតែឈ្មោះបន្ទប់/ទូ/ផ្ទាំងលំនាំដើមប៉ុណ្ណោះ។ បន្ទាប់ពីប្តូរទៅឈ្មោះផ្ទាល់ខ្លួន មុខងារនេះមិនដំណើរការទេ',
    up: 'ឡើងលើ',
    down: 'ចុះក្រោម',
    default: 'លំនាំដើម',
    printSetting: 'ការកំណត់បោះពុម្ព',
    oneToMore: 'ច្រើនទំព័រក្នុងមួយសន្លឹក',
    perPage: 'ក្នុងមួយ',
    coloumn: 'ជួរឈរ',
    tagMargin: 'គម្លាតស្លាក',
    coloumnMargin: 'គម្លាតជួរឈរ',
    specialMark: 'សញ្ញាពិសេស',
    opacity: 'ភាពថ្លា',
    opacityTip3: 'រូបភាពទ្រង់ទ្រាយ BMP ត្រូវជ្រើសពណ៌ពិតប្រាកដដើម្បីគាំទ្រភាពថ្លា',
    suite: 'សម្របខ្លួន',
    svgListTip: 'មិនបានបើកបង្កើតស្លាកផ្ទាំងតូចទេ សូមធីកខាងឆ្វេង',
    size: 'ទំហំ',
    lightSide: 'គែមឃើញពន្លឺ',
    locFrontSide: 'មុខខាងមុខរបស់ទូ',
    openSide: 'ទិសបើក',
    extraTip: ' កំណត់សម្គាល់៖ នៅពេលប្រើការបោះពុម្ពផ្ទាល់លើកដំបូង សូមបន្ថែមក្រដាសថ្មីក្នុងការកំណត់ម៉ាស៊ីនបោះពុម្ពដែលមានទំហំដូចគ្នាប៉ុន្តែប្តូរបណ្តោយ និងទទឹង រួចប្រើក្រដាសនោះដើម្បីបោះពុម្ព (ឧ. ដើម 60×40 ថ្មី 40×60)។',
    noMore: 'គ្មានទៀតហើយ',
    prepareData: 'កំពុងរៀបចំទិន្នន័យ...',
    genTagFile: 'កំពុងបង្កើតស្លាក សូមកុំប្តូរទំព័រ បង្រួមកម្មវិធីរុករក ឬរំកិលស្លាកឡើងចុះ!',
    waitGen: 'សូមរង់ចាំឱ្យស្លាកផ្ទុករួចរាល់មុនពេលទាញយក',
    tempLoading: 'កំពុងផ្ទុកពុម្ពស្លាក សូមរង់ចាំ',
    front: 'ខាងមុខ',
    open: 'បើក',
    toEdit: 'ទៅកែសម្រួល',
    simplifyOneCodeTip: 'ចំណាំ៖ លក្ខណៈបាកូដនៃពុម្ពស្លាកនេះមិនគាំទ្រមុខងារ «បាកូដសាមញ្ញ» ទេ សូមកែលក្ខណៈបាកូដ (ណែនាំ៖ CODE128)',
    plankTemp: 'ពុម្ពស្លាកផ្ទាំងតូច',
    surplusTemp: 'ពុម្ពស្លាកសម្ភារៈសល់',
    enableSubTag: 'បើកស្លាកបន្ទាប់',
    enableSubTagTip: 'អាចកំណត់នៅ ការកំណត់បន្ថែម > ការកំណត់ស្លាកបន្ទាប់ផ្ទាំងតូច > កំណត់ប្រភពទិន្នន័យដែលមានប្រសិទ្ធភាពសម្រាប់ការបង្កើតស្លាកបន្ទាប់។ បន្ទាប់ពីបើក ស្លាកបន្ទាប់នឹងត្រូវបានបង្កើតតែនៅពេលប្រភពទិន្នន័យដែលបានកំណត់មានតម្លៃនៅលើស្លាកបន្ទាប់ បើមិនដូច្នោះទេនឹងមិនបង្កើត។',
    goSet: 'ទៅកាន់ការកំណត់',
    mainTag: 'ស្លាកមេផ្ទាំងតូច',
    subTag: 'ស្លាកបន្ទាប់ផ្ទាំងតូច',
    downloadSubTagTip: 'ស្លាកដែលនាំចេញមានស្លាកបន្ទាប់។ ខ្សែសង្វាក់ផលិតកម្មបិទស្លាកស្វ័យប្រវត្តិបច្ចុប្បន្នមិនអាចបង្កើតស្លាកបន្ទាប់បានទេ។ តើអ្នកចង់បន្តនាំចេញទេ?',
    embeddedSubTagTip: 'ស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកសម្លាកមានសម្រួលរបស់អ៊ីនធឺណិតដើម្បីប្រើសម្រួលនេះ។',
    subTagPerSaveTip: 'ស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកស្លាកបន្ទាប់សម្រួលដើម្បីរក្សាទុកម្តងទុកទៀត។',
    subTagPerexportTip: 'ស្លាកដែលនាំចេញមានស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកស្លាកបន្ទាប់សម្រួលដើម្បីរក្សាទុកម្តងទុកទៀត។',
    tempNamePlaceHolder: 'សូមបញ្ចូលឈ្មោះពុម្ព',
    editTip: 'អ្នកអាចអូសប៊ូតុងខាងឆ្វេងទៅក្រដាសស្លាកខាងស្តាំតាមតម្រូវការដើម្បីកែពុម្ព',
    oneCode: 'បាកូដ',
    image: 'រូបភាព',
    arrow: 'ព្រួញ',
    editPage: {
      digitLimitation: 'កំណត់ចំនួនខ្ទង់',
      title: 'កែសម្រួលពុម្ពស្លាក',
      reset: 'ស្តារលំនាំដើម',
      exit: 'ចាកចេញពីការកែសម្រួល',
      tagInfo: 'ព័ត៌មានស្លាក',
      tagName: 'ឈ្មោះស្លាក',
      tagSize: 'ទំហំស្លាក',
      tagData: 'ទិន្នន័យស្លាក',
      dragTip: 'ចុចទុកប៊ូតុងខាងឆ្វេងនៃកណ្តុររួចអូសដើម្បីបង្កើតស្លាកទិន្នន័យ',
      dataTip: 'ជ្រើសរើសព័ត៌មានទិន្នន័យពីផ្ទាំងលក្ខណៈខាងស្តាំ',
      text: 'អត្ថបទ',
      dataSource: 'ប្រភពទិន្នន័យ',
      graph: 'ក្រាហ្វិក',
      typograpyPic: 'រូបរាងការរៀបចំ',
      barCode: 'បាកូដ',
      QRCode: 'កូដ QR',
      plankMark: 'សញ្ញាផ្ទាំង',
      holeSlotPic: 'រូបរណ្តៅ និងរណ្តៅ',
      edgeBandPic: 'រូបបំណុលគែម',
      visibleEdgePic: 'គែមដែលឃើញ',
      holeSlotPicZoom: 'ពង្រីករូបរណ្តៅ/រណ្តៅ',
      rotateDeg: 'មុំបង្វិល',
      colorDeep: 'ជម្រៅពណ៌',
      surplusMark: 'សញ្ញាសម្ភារៈសល់',
      surplusSizePic: 'រូបទំហំសម្ភារៈសល់',
      dataSize: 'ទំហំទិន្នន័យ',
      extraList: 'បញ្ជីបន្ថែម',
      QRCodeFormat: 'ទ្រង់ទ្រាយកូដ QR',
      formatQR: 'ទ្រង់ទ្រាយ QR',
      formatDM: 'ទ្រង់ទ្រាយ DM',
      locIndex: 'លេខលំដាប់ទូ',
      plankFrontSign: 'សញ្ញាបន្ទះ',
      genNCSuffix: 'បង្កើតបច្ច័យ NC',
      table: 'តារាង',
      inputPlaceholder: 'ចុចពីរដងដើម្បីបញ្ចូលអត្ថបទ',
      attribute: 'លក្ខណៈ',
      fontFamily: 'គ្រួសារពុម្ពអក្សរ',
      fontSize: 'ទំហំពុម្ពអក្សរ',
      fontWeight: 'កម្រាស់ពុម្ពអក្សរ',
      flipOverProcessing: 'ដំណើរការបញ្ច្រាស',
      showSideMachiningSequenceDiagramBorder: 'ដំណើរការបញ្ច្រាស និងដំណើរការបញ្ច្រាស ដូចគ្នា',
      showSideMachiningSequenceNumber: 'ដំណើរការបញ្ច្រាស និងដំណើរការបញ្ច្រាស ដូចគ្នា',
      autoRow: 'រុញអត្ថបទស្វ័យប្រវត្តិ',
      rowMargin: 'គម្លាតបន្ទាត់',
      autoFontSize: 'ពេលលើសកំណត់ទំហំពុម្ពអក្សរស្វ័យប្រវត្តិ',
      statisticsDimension: 'វិមាត្រស្ថិតិ',
      noLimit: 'គ្មានកំណត់',
      sameOrderNo: 'ការកម្មង់ដូចគ្នា',
      sameRoom: 'បន្ទប់ដូចគ្នា',
      sameWardrobe: 'ទូដូចគ្នា',
      alignWay: 'ការតម្រឹម',
      JustifyLeft: 'តម្រឹមឆ្វេង',
      JustifyRight: 'តម្រឹមស្តាំ',
      JustifyCenter: 'តម្រឹមកណ្តាល',
      otherOpration: 'ប្រតិបត្តិការផ្សេងទៀត',
      attributeReset: 'កំណត់លក្ខណៈឡើងវិញ',
      barCodeSize: 'ទំហំបាកូដ',
      installPic: 'រូបដំឡើង',
      plankCode2: 'បាកូដផ្ទាំង (noMark)',
      frontCode: 'បាកូដមុខ',
      backCode: 'បាកូដក្រោយ',
      orderRemark: 'កំណត់ចំណាំការកម្មង់',
      NCFileName: 'ឈ្មោះឯកសារកាត់',
      NCFileNameTip: 'ឈ្មោះឯកសារ NC មិនគួរមានអក្សរចិន និងមិនវែងជាង ១០ តួទេ',
      showOpenSide: 'បង្ហាញទិសបើកទ្វារ',
      limitFixed: 'កំណត់ចំនួនខ្ទង់ទសភាគ',
      showFrontHS: 'បង្ហាញរណ្តៅ/រណ្តៅមុខ',
      showBackHS: 'បង្ហាញរណ្តៅ/រណ្តៅក្រោយ',
      showPartEdge: 'បង្ហាញការបំណុលគែមផ្ទាំង',
      showPlankSize: 'បង្ហាញទំហំផ្ទាំង',
      tempNamePlaceholder: 'សូមបញ្ចូលឈ្មោះស្លាក',
      deleteAreaTip: 'សូមជ្រើសតំបន់ដែលត្រូវលុប',
      suitShunt: 'បង្ហាញការបំណុលគែមផ្ទាំង',
      suitShuntTip: 'បង្ហាញការបំណុលគែមផ្ទាំងដែលមិនមានការបំណុលគែមផ្ទាំងបន្ទាប់',
      noHoleSlot: 'បង្ហាញបាកូដទោះបីគ្មានរណ្តៅ/រណ្តៅ',
      rotate: 'បង្វិលបាកូដ',
      barcodeAtrribute: 'លក្ខណៈបាកូដ',
      imgSize: 'ទំហំរូបភាព',
      graphStyle: 'ស្តាយល់ក្រាហ្វិក',
      noEdgeDisplay: 'បំណុល ០ កុំបង្ហាញ',
      allEdgeNoDisplay: 'កុំបង្ហាញការបំណុលគែម',
      isShowDiffEdgeColor: 'បង្ហាញពណ៌បំណុលគែមរៀងរាល់',
      hideSameEdgeColorAsPlank: 'កុំបង្ហាញពណ៌បᆆណុលគែមរៀងរាល់ដែលសមាជិកជាមួយនឹងពណ៌បᆆណុលគែម',
      hideSameEdgeColorAsPlankTip: 'ការរៀបចំក្នុងពពកខ្ចប់មិនទាន់គាំទ្រទេ',
      imgRotate: 'បង្វិលរូបភាព',
      circleD: 'អង្កត់ផ្ចិតក្រុងរង្វង់',
      roomNo: 'លេខបន្ទប់',
      roomOrder: 'លំដាប់ទូ (តម្រៀបតាមបន្ទប់)',
      alphabetically: 'តម្រៀបតាមអក្សរ',
      numberOrder: 'តម្រៀបតាមលេខ',
      specialMarkup: 'និមិត្តសញ្ញាសម្គាល់ពិសេស',
      smallPlateMarking: 'សម្គាល់ផ្ទាំងតូច',
      arrow: 'ព្រួញ',
      triangle: 'សញ្ញាមុំត្រីកោណ',
      sixSideDrillPlankBase: 'មូលដ្ឋានដាក់ផ្ទាំងរន្ធដោតប្រាំមួយមុខ',
      boldSettingTip: 'ពុម្ពអក្សរទူ PDF មិនគាំទ្រ',
      frontEdge: 'បង្ហាញមុខទូ',
      visibleEdge: 'បង្ហាញគែមឃើញពន្លឺ',
      lineCount: 'ចំនួនតួអក្សរក្នុងមួយបន្ទាត់'
      },
    autoSaveToHistory: 'បានរក្សាទុកទៅប្រវត្តិស្វ័យប្រវត្តិ!',
    firstPrintTip: 'នៅពេលប្រើបោះពុម្ពផ្ទាល់លើកដំបូង សូមបន្ថែមក្រដាសថ្មីដែលប្តូរបណ្តោយ និងទទឹងក្នុងការកំណត់ម៉ាស៊ីនបោះពុម្ព រួចបោះពុម្ពដោយប្រើក្រដាសនោះ',
    tagDownloading: 'កំពុងទាញយកស្លាក...',
    cutLaveEnd: 'ស្លាកសម្ភារៈកាត់ត្រូវបានបង្កើតនៅពីក្រោយផ្ទាំងធំនីមួយៗ',
    deleteTemplate: 'លុបពុម្ពក្រុម',
    copyTemplateRenderUrl: 'ពុម្ព URL ដូចគ្នា',
    noPermission: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    moreOperation: 'ការដំណើរការច្រើនទៀត',
    importTemplate: 'ពុម្ពដូចគ្នាដូចគ្នា',
    importTemplateLink: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    importTemplateLinkPlaceholder: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    noDeleteTemplate: 'ពុម្ពដូចគ្នាមិនអាចលុបបាន',
    tip1: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    tip2: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    tip3: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    tip4: 'មិនអាចស្គាល់តំណពុម្ពដែលបាននាំចូលទេ សូមទាញយកឡើងវិញ ហើយនាំចូលម្តងទៀត។'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'ចាត់ថ្នាក់ទៅថតផ្សេងៗតាមសម្ភារៈ ពណ៌ កម្រាស់ និងទំហំផ្ទាំងធំ (រួមទាំងឯកសារស្លាក)',
    notOpeFolderPermission: 'ប្រតិបត្តិការគ្មានការអនុញ្ញាតលើថតនេះ',
    notFindFolder: 'មិនអាចរកឃើញថតនេះនៅលើកម្មវិធីអតិថិជនបច្ចុប្បន្ន',
    productLineUniversal: 'សម្រាប់បណ្តាខ្សែផលិតកម្មទាំងអស់',
    effectCondition: 'ការផ្លាស់ប្តូរការកំណត់នេះមានប្រសិទ្ធភាពតែបន្ទាប់ពីរៀបចំឡើងវិញប៉ុណ្ណោះ',
    addPath: 'បន្ថែមផ្លូវ',
    downloadPositionChangeByType: 'ទីតាំងទាញយកឯកសារដែលបានបង្កើតត្រូវបានប្តូរទៅ {type}',
    isDeleteFolder: 'តើអ្នកប្រាកដថាចង់លុបទីតាំងរក្សាទុកឯកសារដែលបានប្រើ?',
    netWorkIsNotSafe: 'បរិយាកាសបណ្តាញរបស់អ្នកមិនមានសុវត្ថិភាពទេ យើងមិនអាចបើកមុខងារនេះបានទេ អ្នកអាចផ្តល់មតិយើង',
    NotSupportBrowse: 'កម្មវិធីរុករករបស់អ្នកមិនគាំទ្រមុខងារនេះទេ។ សូមទាញយកកំណែចុងក្រោយនៃកម្មវិធីរុករក <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> ដើម្បីប្រើ។',
    notSupportDisk: 'មិនអាចជ្រើសថតកម្រិតប្រព័ន្ធដូចជា [ផ្ទៃតុ] និង [ថាស C] បានទេ',
    useFolderDownload: 'ឯកសារផលិតកម្មត្រូវបានទាញយកដោយគ្មានការបង្ហាប់',
    downloadPosition: 'ទីតាំងទាញយកឯកសារ',
    changeUseFolder: 'ប្តូរ',
    folderNameSetting: 'ការកំណត់ថត',
    mainFolder: 'ថតដំបូង',
    exportNameSetting: 'នាំចេញឯកសារដែលបានដំណើរការដោយដាក់ឈ្មោះតាមលេខការកម្មង់',
    fileMax: 'ឈ្មោះឯកសារអតិបរមា',
    char: 'តួអក្សរ',
    overTip: 'ផ្នែកលើសមិនបង្ហាញ (ឯកសារ zip រូបស្លាក និង json នឹងធ្វើតាមឈ្មោះថតដំបូង)',
    example: 'ឧទាហរណ៍',
    engravingFolder: 'ថតម៉ាស៊ីនចុកចាក់',
    electronicSawFolder: 'ថតម៉ាស៊ីនរណាអេឡិចត្រូនិក',
    labellingFolder: 'ថតម៉ាស៊ីនដាក់ស្លាក',
    sideHoleDrillFolder: 'ថតម៉ាស៊ីនរណ្តៅចំហៀង',
    fiveDrillFolder: 'ថតម៉ាស៊ីនរណ្តៅប្រាំមុខ',
    sixDrillFolder: 'ថតម៉ាស៊ីនរណ្តៅប្រាំមួយមុខ',
    PTPFolder: 'ថត PTP',
    labellingTagFolder: 'ថតរូបភាពស្លាក',
    surplusFolder: 'ការកំណត់ផ្ទាំងធំសម្រាប់ឯកសារសល់',
    surplusBigPlankSetting: 'ឯកសារកាត់ផ្ទាំងធំសល់ រូបស្លាក និងឯកសារស្លាកដាក់ដាច់ដោយឡែក',
    surplusBigPlankSettingTip: 'បន្ទាប់ពីបើក ឯកសារ NC សល់ រូបស្លាក និងឯកសារស្លាកនឹងដាក់ក្នុងថតដាច់ដោយឡែក',
    folderMergeSetting: 'ការកំណត់បញ្ចូលថត',
    folderMerge: 'ការបញ្ចូលថត',
    mergeName: 'ឈ្មោះបញ្ចូលគ្នា',
    subMergeFolder: 'បញ្ចូលទៅថតរងតាមសម្ភារៈ ពណ៌ និងកម្រាស់៖',
    subFolderName: 'ឈ្មោះថតរង',
    splitChar: 'សញ្ញាបំបែក',
    splitTip: '(មិនគាំទ្រតួអក្សរដូចជា / : ? < > | . " *)',
    folderAutoAdd: 'តម្លៃចាប់ផ្តើមដើម្បីបង្កើនចំនួនថតស្វ័យប្រវត្តិ',
    resetTip: '(រាល់ថ្ងៃម៉ោងសូន្យធ្វើឡើងវិញទៅតម្លៃចាប់ផ្តើម)',
    emptyErrTip: 'ព័ត៌មានមិនអាចទទេ',
    repeatErrTip: 'ឈ្មោះឯកសារស្ទួន',
    mergeDataTip: 'ត្រូវមានសម្ភារៈផ្ទាំង ពណ៌ កម្រាស់ បណ្តោយ/ទទឹង ឬការបង្កើនចំនួនឯកសារ ឬសម្ភារៈ-ពណ៌-កម្រាស់',
    engravingFileSetting: 'ការកំណត់ឯកសារម៉ាស៊ីនចុកចាក់',
    engravingSplitZF: 'រក្សាទុកឯកសារមុខ/ក្រោយរបស់ម៉ាស៊ីនចុកចាក់ក្នុងថតផ្សេងគ្នា',
    engravingSplitZFTip: 'សមស្របសម្រាប់ម៉ាស៊ីនស្លាកស្វ័យប្រវត្តិ ១២៣',
    engravingSplitWorkstation: 'ម៉ាស៊ីនចុកចាក់ក្នុងថតផ្សេងគ្នាតាមផាក្រិត',
    engravingSplitWorkstationTip: 'ម៉ាស៊ីនចុកចាក់ និង ម៉ាស៊ីនចុកចាក់បានជោគជ័យ',
    holeFileSetting: 'ការកំណត់ឯកសាររណ្តៅ',
    holeFileSingle: 'ឯកសាររណ្តៅដាក់ដាច់ដោយឡែកតាមការកម្មង់ផ្សេងៗ'
    },
  moreSettings: {
    generalSetting: 'ការកំណត់ទូទៅ',
    outSyncTip: 'បង្ហាញបង្អួចព្រមានពេលទិន្នន័យហ្វីលមូលដ្ឋានក្លោដរៀបចំមិនសមកាលជាមួយទូ',
    secondarySwitchShow: 'មាតិការងដែលគ្រប់គ្រងដោយប៊ូតុងក្នុងការកំណត់ចុកចាក់ នៅតែបង្ហាញបន្ទាប់ពីបិទ',
    isFrameDoorTip: 'បង្កើតបង្អួចព្រមានពេលបង្រួមទូរទូទាត់',
    exPaibanTip: 'បង្កើតបង្អួចព្រមានពេលប្រើការរៀបចំសម្ភារៈសល់/ខ្នាតមិនទៀងលាក់គ្នា',
    isDesMaterialNoCutTip: 'បង្ហាញព្រមានពេលផ្ទាំងតូចដែលមិនកាត់មានរណ្តៅ/រណ្តៅ/រូបរាងចាត់ទៅម៉ាស៊ីនចុកចាក់',
    surpTagThresholdTextHalf1: 'ពេលផ្ទៃសម្ភារៈសល់ (មិនមែនសល់កាត់) តូចជាង',
    surpTagThresholdTextHalf2: 'មិនបង្កើតស្លាកសម្ភារៈសល់',
    innerShapeToolMatch: 'ម៉ាស៊ីនចុកចាក់ជ្រើសឧបករណ៍សមស្របស្វ័យប្រវត្តិសម្រាប់រូបរាងមិនទៀងខាងក្នុង',
    innerShapeToolMatchTip: '(ពេលរូបរាងមិនទៀងខាងក្នុងតូចជាងអង្កត់ផ្ចិតមុខកាត់ ហើយមានកំហុសទំហំ/មិនអាចដំណើរការ អាចបើកមុខងារនេះ)',
    innerShapeToolMatchTip2: 'ចំណាំ៖ បន្ទាប់ពីបើកនឹងប្រើមុខកាត់រណ្តៅតូបតូចបំផុត សូមកំណត់ប្រវែងឧបករណ៍ និងជម្រៅដំណើរការអតិបរមាក្នុងមួយដងឱ្យសមរម្យ មានប្រសិទ្ធភាពតែក្នុងការរៀបចំក្លោដ',
    surNotLayout: 'កំណត់ផ្ទាំងធំសល់មិនរៀបផ្ទាំងដែលបានចង្អុលចោទ',
    surNotLayoutTip: 'បន្ទាប់ពីបើក៖ ១) ផ្ទាំងធំសល់មិនអាចរៀបផ្ទាំងតូចដែលមានឈ្មោះខាងក្រោម ២) ពេលរៀបចំអាចជ្រើសថាមុខងារនេះអនុវត្តសម្រាប់ដងនេះឬអត់',
    addPlank: 'បន្ថែមឈ្មោះផ្ទាំង',
    addPlankTip: 'បន្ថែមឈ្មោះផ្ទាំងតូចយ៉ាងហោចណាស់មួយ',
    thisInput: 'បញ្ចូលនៅទីនេះ',
    surNotLayoutMat: 'សម្ភារៈសល់មិនរៀបលើផ្ទាំងតូចដែលបានកំណត់',
    subTagSetting: 'ការកំណត់ស្លាកបន្ទាប់ផ្ទាំងតូច',
    subTagDataSource: 'កំណត់ប្រភពទិន្នន័យដែលមានប្រសិទ្ធភាពសម្រាប់ការបង្កើតស្លាកបន្ទាប់',
    subTagDataSourceTip: 'បន្ទាប់ពីបើក អ្នកអាចបន្ថែមប្រភពទិន្នន័យដែលគ្រប់គ្រងការបង្កើតស្លាកបន្ទាប់។ នៅពេលស្លាកបន្ទាប់មានប្រភពទិន្នន័យនោះ និងមានតម្លៃ ស្លាកបន្ទាប់នឹងត្រូវបានបង្កើត។',
    addSubTagDataSource: 'បន្ថែមប្រភពទិន្នន័យ',
    addSubTagDataSourceTip: 'មិនអនុញ្ញាតឱ្យបន្ថែមប្រភពទិន្នន័យស្ទួន',
    addSubTagDataSourceTip1: 'សូមបន្ថែមប្រភពទិន្នន័យយ៉ាងហោចណាស់មួយ',
    addSubTagDataSourceTip2: 'ប្រភពទិន្នន័យមិនអាចទទេបានទេ សូមជ្រើសរើស',
    reuseMatchingPlankName: 'ការផ្គូរផ្គងការប្រើឡើងវិញតាមឈ្មោះក្ដារ',
    reuseMatchingPlankNameTip1: 'នៅពេលបិទមុខងារនេះ ការប្រើឡើងវិញនៃប្លង់ផ្គូរផ្គងក្ដារដែលមានសម្ភារៈ ពណ៌ កម្រាស់ ទំហំ វាយនភាព និងលក្ខណៈស្ទន់ខ្ពស់ដូចគ្នា',
    reuseMatchingPlankNameTip2: 'នៅពេលបើកមុខងារនេះ លើសពីលក្ខខណ្ឌផ្គូរផ្គងខាងលើ ការផ្គូរផ្គងតាមឈ្មោះក្ដារក៏ត្រូវបានបន្ថែមផងដែរ'
    },
  lineManager: {
    add: 'បន្ថែមខ្សែផលិតកម្ម',
    engraving: 'ឧបករណ៍កាត់',
    holeSlotEquip: 'ឧបករណ៍ដំណើរការរណ្តៅ និងរណ្តៅ',
    workSetting: 'ការកំណត់ដំណើរការ',
    noUse: 'មិនបានបើក',
    warningTip: '* ចំណាំ៖ បន្ទាប់ពីកំណត់មុខងារខាងក្រោម កុំរក្សាទុកនៅទំព័រភ្ជាប់ឧបករណ៍កម្មវិធីអតិថិជនទូ ដើម្បីជៀសវាងការកំណត់ប៉ារ៉ាម៉ែត្រឡើងវិញ!',
    engravingSetting: 'ការកំណត់ម៉ាស៊ីនកាត់',
    workWay: 'វិធីដំណើរការ',
    cutedSpecial: 'រណ្តៅ និងរណ្តៅពិសេសសម្រាប់ដំណើរការ៖',
    noWork: 'ជម្រើសនេះមិនអនុវត្តលើពុម្ពលំនាំដើមរណ្តៅប្រាំ/ប្រាំមួយមុខទេ',
    onlyCut: 'តែកាត់ប៉ុណ្ណោះ',
    onlyFrontHoleSlot: 'ដំណើរការតែរណ្តៅ និងរណ្តៅមុខផ្ទាំង',
    onlyHoleSlot: 'ដំណើរការរណ្តៅ និងរណ្តៅមុខ និងក្រោយផ្ទាំង',
    sideHoleSetting: 'ការកំណត់ម៉ាស៊ីនរណ្តៅចំហៀង',
    cutHoleSlot: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការ',
    minSize: 'ទំហំគែមខ្លី',
    maxSize: 'ទំហំគែមវែង',
    minSize2: 'ទាំងអស់នៅលើផ្ទាំង mm',
    minSize3: 'និងផ្នែករូបរាងមិនទៀង',
    onlyFrontHoleSlotTip: 'ទំព័ររៀបចំមានតែផ្ទាំងតូចដែលមានរណ្តៅមុខ',
    onlyFrontHoleSlotTip2: 'មិនរួមបញ្ចូលរណ្តៅ និងរណ្តៅចំហៀង',
    holeAndSlot: 'រណ្តៅ និងរណ្តៅ',
    empty: 'ទទេ',
    singleHole: 'រណ្តៅតែមួយ',
    singleSlot: 'រណ្តៅតែមួយ',
    diameterRange: 'ជួរអង្កត់ផ្ចិតរណ្តៅ',
    hDeepRange: 'ជួរជម្រៅរណ្តៅ',
    widthRange: 'ជួរទទឹងរណ្តៅ',
    sDeepRange: 'ជួរជម្រៅរណ្តៅ',
    to: 'ដល់',
    specialHS: 'រណ្តៅ រណ្តៅ និងរូបរាងពិសេស',
    allowRoll: 'អនុញ្ញាតឱ្យម៉ាស៊ីនកាត់ដំណើរការរណ្តៅពិសេសដោយបង្វិលផ្ទាំង',
    engravingPath: 'ដំណើរការផ្នែករូបរាងមិនទៀងនៅលើម៉ាស៊ីនកាត់',
    curve_range: 'គែមវែងនៃផ្នែករូបរាងមិនទៀងធំជាង',
    curve_range2: 'ផ្នែករូបរាងមិនទៀងទាំងអស់នៃផ្ទាំង',
    curveArea: 'ផ្ទៃរូបរាងមិនទៀង',
    drillSetting: 'ការកំណត់រណ្តៅប្រាំ/ប្រាំមួយមុខ',
    engravingCuted: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការនៅម៉ាស៊ីនកាត់នៅលើរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    engravingCutedSpecial: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការនៅម៉ាស៊ីនកាត់នៅលើរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    genCuttingPath: 'បង្កើតទិន្នន័យកាត់',
    otherCuted: 'រណ្តៅ និងរណ្តៅដែលឧបករណ៍ផ្សេងដំណើរការនៅរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    noGen: 'កុំបង្កើត',
    genCut: 'បង្កើត និងដំណើរការ',
    genNoCut: 'បង្កើតប៉ុន្តែមិនដំណើរការ',
    cutTip: ' ចំណាំ៖ ជម្រើសនេះមានប្រសិទ្ធភាពតែសម្រាប់ឯកសាររណ្តៅប្រាំ/ប្រាំមួយមុខផ្ទាល់ខ្លួន',
    maxShortSize: 'ទំហំគែមខ្លីអតិបរមា',
    maxLongSize: 'ទំហំគែមវែងអតិបរមា',
    normalSlot: 'រណ្តៅធម្មតា',
    specialSlot: 'រណ្តៅពិសេស',
    combinSetting: 'ការកំណត់ឧបករណ៍រួមបញ្ចូល',
    allowShortSize: 'អនុញ្ញាតទំហំគែមខ្លី',
    equipment1: 'ឧបករណ៍ ១',
    equipment2: 'ឧបករណ៍ ២',
    noSameTip: 'ចំណាំ៖ ឧបករណ៍ពីរមិនអាចដូចគ្នាបានទេ',
    workRange: 'ជួរដំណើរការរណ្តៅ និងរណ្តៅសម្រាប់ឧបករណ៍ ១',
    rangeWarning: 'ចំណាំ៖ អាចកំណត់តែជួរដំណើរការឧបករណ៍ ១ ជួរក្រៅឧបករណ៍ ១ ទាំងអស់ដំណើរការនៅឧបករណ៍ ២ សូមប្រយ័ត្ន!',
    deleteWarning: 'លុបខ្សែផលិតកម្មនេះមិនអាចស្តារឡើងវិញ (ការកំណត់ទាំងអស់ក្រោមវាត្រូវលុប)។ តើអ្នកប្រាកដថាចង់លុប?',
    top: 'ខាងលើ',
    inputCheck: 'តម្លៃអប្បបរមា {msg} មិនអាចធំជាងតម្លៃអតិបរមា',
    lockTip: 'ខ្សែផលិតកម្មជាប់សោ ហាមដំណើរការ!',
    reNameTip: 'មិនអាចប្តូរឈ្មោះខ្សែផលិតកម្មលំនាំដើម',
    permissonTip: 'ព័ត៌មានអត្តសញ្ញាណផុតកំណត់ សូមបើកទំព័រនេះឡើងវិញពីទូ',
    permissonErr: 'មិនមានការអនុញ្ញាតនេះ សូមដំឡើងកំណែគណនី!',
    permissionOneMacErr: 'បច្ចុប្បន្នអ្នកអាចប្រើខ្សែផលិតកម្ម {idx} សម្រាប់ម៉ាស៊ីនរួមបញ្ចូល បង្កើនបន្ថែមសូមទាក់ទងលក់',
    permissionSawErr: 'គ្មានការអនុញ្ញាតប្រើម៉ាស៊ីនរណា/ចុកចាក់ ទាក់ទងលក់ដើម្បីទិញកញ្ចប់បន្ថែមកាត់អាលុយមីញ៉ូមពេញលេញ',
    getAuthError: 'មិនអាចទទួលបានការអនុញ្ញាតឧបករណ៍!',
    sawAddNumber: 'ខ្សែផលិតកម្មរណាអេឡិចត្រូនិកដែលអាចប្រើបានរបស់អ្នកអស់ហើយ បង្កើនសូមទាក់ទងលក់',
    newLine: 'ខ្សែផលិតកម្មថ្មី {idx}',
    deleteCheck: 'មិនអាចលុបទាំងអស់',
    deving: 'កំពុងអភិវឌ្ឍ',
    combinTip: 'សូមចុចការកំណត់ឧបករណ៍រួមបញ្ចូលខាងក្រោមដើម្បីកំណត់',
    noUseEquip: 'ឧបករណ៍ដំណើរការមិនបានបើក',
    equipmentSelectTip: 'ពេលជ្រើសម៉ាស៊ីនកាត់ក្នុងឧបករណ៍រួម ឧបករណ៍កាត់មិនអាចជារណាអេឡិចត្រូនិក',
    lineLoading: 'កំពុងផ្ទុកទិន្នន័យ',
    strenchType: 'ប្រភេទរណ្តៅឧបករណ៍ទាញផ្តិត',
    aioProcessTip: 'អ្នកបានបើកឧបករណ៍រួមបញ្ចូល របៀបដំណើរការលំនាំដើមគឺរណ្តៅ និងរណ្តៅមុខ និងក្រោយផ្ទាំង',
    aioProcessTip2: 'រណ្តៅ និងរណ្តៅពិសេសដែលដំណើរការនៅផ្នែកចុកចាក់បន្ទាប់ពីបើករួមបញ្ចូល',
    aioProcessTip3: 'ចំណាំ៖ មុខងារនេះមិនសមស្របនឹងម៉ាស៊ីនចុកចាក់ដែលបើកប្តូរអ័ក្ស XY ទេ សូមប្រយ័ត្ន',
    specialHoleTip: 'ចំណាំ៖ ពេលប្រើមុខងារដំណើរការរណ្តៅពិសេសខាងលើ សូមកំណត់វិធីរណ្តៅរន្ធដោត និងរណ្តៅឆ្លងជាការរណ្តៅមួយដង',
    specialHoleTip2: 'ចំណាំ៖ ពេលប្រើមុខងារខាងលើ សូមកំណត់នៅម៉ាស៊ីនចុកចាក់វិធីរណ្តៅរន្ធដោត និងរណ្តៅឆ្លងជារណ្តៅមួយដង',
    fiveSixNotTake: 'ជម្រើសនេះមិនអនុវត្តលើពុម្ពលំនាំដើមរណ្តៅប្រាំ/ប្រាំមួយមុខទេ',
    onlyFrontSide: 'ដំណើរការតែមុខ',
    onlyBackSide: 'ដំណើរការតែក្រោយ',
    less: 'តូចជាង',
    equal: 'ស្មើ',
    greater: 'ធំជាង',
    or: 'ឬ',
    and: 'និង',
    bothFrontBack: 'ដំណើរការទាំងមុខ និងក្រោយ',
    shareDataErrTip: 'ទិន្នន័យនេះអនុវត្តដោយ {operatorPhone}, IP៖ {actionIp}',
    restoreParams: 'ស្តារប៉ារ៉ាម៉ែត្រ',
    loadMore: 'ផ្ទុកបន្ថែម',
    currentCombinationEquipment: 'ពេលជ្រើសឧបករណ៍រួមបញ្ចូល ឧបករណ៍កាត់មិនអាចប្តូរទៅម៉ាស៊ីនកាត់កញ្ចក់',
    selectEquipmentType: 'សូមជ្រើសប្រភេទឧបករណ៍',
    ruleRemark: 'កំណត់ចំណាំច្បាប់',
    remarkPlaceholder: 'កំណត់ចំណាំសម្រាប់ច្បាប់នេះ អាចកត់ដំណើរការណាខ្លះ ដើម្បីកុំភ្លេច។ បំពេញរួចរក្សាទុកខ្សែផលិតកម្មទើបមានប្រសិទ្ធភាព',
    onlyNoSideHoleSlotSmallPlank: 'មានតែផ្ទាំងតូចគ្មានរណ្តៅ/រណ្តៅចំហៀង'
    },
  cuttingDock: {
    title: 'ការភ្ជាប់ម៉ាស៊ីនកាត់',
    autoStockCode: 'កូដផ្ទុក/ចុះសម្ភារៈស្វ័យប្រវត្តិ',
    stationStart: 'ការចាប់ផ្តើមកន្លែងធ្វើការ',
    stationStartCode1: 'កូដចាប់ផ្តើមកន្លែង ១',
    stationStartCode1Placeholder: 'បញ្ចូលកូដចាប់ផ្តើមកន្លែង ១',
    stationStartCode2: 'កូដចាប់ផ្តើមកន្លែង ២',
    stationStartCode2Placeholder: 'បញ្ចូលកូដចាប់ផ្តើមកន្លែង ២',
    stationEnd: 'ការបញ្ចប់កន្លែងធ្វើការ',
    stationEndCode1: 'កូដបញ្ចប់កន្លែង ១',
    stationEndCode1Placeholder: 'បញ្ចូលកូដបញ្ចប់កន្លែង ១',
    stationEndCode2: 'កូដបញ្ចប់កន្លែង ២',
    stationEndCode2Placeholder: 'បញ្ចូលកូដបញ្ចប់កន្លែង ២',
    frontBackStart: 'ចាប់ផ្តើមមុខ-ក្រោយ',
    frontBackEnd: 'បញ្ចប់មុខ-ក្រោយ',
    frontStartCode: 'កូដចាប់ផ្តើមមុខ',
    frontStartCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមមុខ',
    frontEndCode: 'កូដបញ្ចប់មុខ',
    frontEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់មុខ',
    backStartCode: 'កូដចាប់ផ្តើមក្រោយ',
    backStartCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមក្រោយ',
    backEndCode: 'កូដបញ្ចប់ក្រោយ',
    backEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់ក្រោយ',
    plankStart: 'ចាប់ផ្តើមបង្វិលផ្ទាំង',
    plankEnd: 'បញ្ចប់បង្វិលផ្ទាំង',
    plankRollCode1: 'កូដបង្វិលកន្លែង ១',
    plankRollCode1Placeholder: 'បញ្ចូលកូដបង្វិលកន្លែង ១',
    plankRollCode2: 'កូដបង្វិលកន្លែង ២',
    plankRollCode2Placeholder: 'បញ្ចូលកូដបង្វិលកន្លែង ២',
    autoBaitingCode: 'កូដចុះសម្ភារៈស្វ័យប្រវត្តិ',
    autoBaitingCode1: 'កូដចុះសម្ភារៈកន្លែង ១',
    autoBaitingCode1Placeholder: 'បញ្ចូលកូដចុះសម្ភារៈកន្លែង ១',
    autoBaitingCode2: 'កូដចុះសម្ភារៈកន្លែង ២',
    autoBaitingCode2Placeholder: 'បញ្ចូលកូដចុះសម្ភារៈកន្លែង ២',
    thickMarkPermission: 'អ្នកបច្ចុប្បន្នមិនមានសិទ្ធិសម្គាល់កម្រាស់បន្ទះធំទេ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញមុនពេលប្រើ',
    thickMark: 'ការជ្រើសយកកម្រិតចម្លើយរបស់កម្ពុជា',
    preStartEquipment: 'ឧបករណ៍ចាប់ផ្តើមមុន',
    firstKnifePreCode: 'កូដចាប់ផ្តើមមុននៃដាក់ដំបូងឱ្យមុន',
    secondKnifePreCode: 'កូដចាប់ផ្តើមមុននៃដាក់ទីពីរ និងបន្ទាប់ឱ្យមុន',
    rowInsert: 'បញ្ចូលជួរដេក',
    pumpPause: 'ផ្អាកប៉ំបូមសុញ្ញាកាស',
    pumpPauseTip: 'ចំណាំ៖ ឧបករណ៍កន្លែងតែមួយត្រូវបំពេញកន្លែង ១ និង ២ ដោយកូដផ្ទុកដោយស្វ័យប្រវត្តិ និងកូដកំណត់ចំណាំមុខដំណើរការពីរមុខដូចគ្នា',
    pumpPause2Tip: 'ចំណាំ៖ ឧបករណ៍កន្លែងតែមួយត្រូវបំពេញកន្លែង ១ និង ២ ដោយកូដផ្អាកប៉ំបូមសុញ្ញាកាសដូចគ្នា',
    pumpPauseCode1: 'កូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ១',
    pumpPauseCode1Placeholder: 'បំពេញកូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ១',
    pumpPauseCode2: 'កូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ២',
    pumpPauseCode2Placeholder: 'បំពេញកូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ២',
    annotationCode1: 'កូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ១',
    annotationCode1Tip: 'សមស្របសម្រាប់ឧបករណ៍ដែលមានពាក្យបញ្ជាខុសគ្នានៅមុខពេលផ្ទុកស្វ័យប្រវត្តិ',
    annotationCode1Placeholder: 'បញ្ចូលកូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ១',
    annotationCode2: 'កូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ២',
    annotationCode2Placeholder: 'បញ្ចូលកូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ២',
    upSpeedTip: 'សូមបំពេញល្បឿនបង្កើនល្បឿនគែមរួម',
    cutThickTip: 'សូមបំពេញកម្រាស់កាត់គែមរួម',
    sizeErrTip: 'សូមកំណត់ទំហំត្រឹមត្រូវនៃរូបរៀបចំដែលនាំចេញនៅក្នុងម៉ាស៊ីនស្លាក!',
    offEdgeKnifeDiameter: 'សូមបញ្ចូលអង្កត់ផ្ចិតមុខកាត់កែគែម',
    slowDownSpeedTip: 'កំហុសបញ្ចូលប៉ារ៉ាម៉ែត្រយឺតនៅមុំកាត់',
    permissionErr: 'កំណែឥតគិតថ្លៃ មិនអាចរក្សាទុក',
    labellingTempErr: 'សូមជ្រើសពុម្ពម៉ាស៊ីនស្លាក',
    autoRollInputTip: 'បើកការបង្វិលស្លាកស្វ័យប្រវត្តិត្រូវបញ្ចូលតម្លៃត្រឹមត្រូវ',
    offlineTempFormat: 'ទ្រង់ទ្រាយឯកសារម៉ាស៊ីនស្លាកបច្ចុប្បន្នបានផ្តាច់ សូមបញ្ជាក់',
    autoStockCode1: 'កូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ១',
    autoStockCode1PlaceHolder: 'បញ្ចូលកូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ១',
    autoStockCode2PlaceHolder: 'បញ្ចូលកូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ២',
    autoStockCode2: 'កូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ២',
    pauseCode: 'កូដផ្អាក',
    pauseCodePlaceHolder: 'បញ្ចូលកូដផ្អាក',
    cuttingToolMaxDepthTip: 'ក្នុងឃ្លាំងដាក់ឧបករណ៍កាត់ {errKey} ជម្រៅដំណើរការអតិបរមាក្នុងមួយដងមិនអាចធំជាងប្រវែងឧបករណ៍កាត់',
    cuttingParams: {
      title: 'ប៉ារ៉ាម៉ែត្រកាត់',
      stationWidth: 'កម្រិតកាត់កាត់',
      stationWidthTip: 'នៅពេលប្រើបន្ទះធំពីសម្ភារៈសល់ ទិសដៅទទឹងអាចរៀបចំបន្ទះតូចបានតែក្នុងជួរទំហំដែលបានកំណត់ប៉ុណ្ណោះ',
      holeSlotMainSide: 'ផ្ទៃប្រមូលរណ្តៅ និងរណ្តៅជង្ហុក',
      holeMainSide: 'ផ្ទៃប្រមូលរណ្តៅ',
      slotMainSide: 'ផ្ទៃប្រមូលរណ្តៅជង្ហុក',
      workPriority: '(អាទិភាពមុខងារ៖ កំណត់ផ្ទៃដំណើរការរណ្តៅពិសេសផ្ទាល់ខ្លួន > ផ្ទៃមានរណ្តៅរអិសដែលបានរណ្តៅធ្វើតាមរណ្តៅរអិសមិនទាន់រណ្តៅនៅផ្ទាំងតូច > រណ្តៅរអិសពិសេសក្នុងការបែងចែករណ្តៅរអិសត្រូវរៀបមុខផ្ទាំងធំជាមុនសិន > ផ្ទៃប្រមូលរណ្តៅរអិស > ផ្ទៃប្រមូលរណ្តៅ)',
      holeSlotSet: 'ការកំណត់ដំណើរការរណ្តៅដែលបានរណ្តៅ',
      hingeRollWork: 'រណ្តៅឧបករណ៍ទាញផ្តិត និងពែងចង្កឹះដំណើរការនៅផ្ទៃខាងក្រោយផ្ទាំងធំ',
      followWork: 'ផ្ទៃរណ្តៅដែលបានរណ្តៅធ្វើតាមរណ្តៅមិនទាន់រណ្តៅនៅផ្ទាំងតូចនោះ',
      autoMatchSide: 'ចែករណ្តៅមុខ និងក្រោយតាមសមាមាត្រ',
      backHSRate: 'សមាមាត្ររណ្តៅក្រោយ',
      matchTip: '(ការកំណត់នេះមិនដំណើរការសម្រាប់ផ្ទាំងរលកពន្លឺ, ផែនការរៀបចំដែលបើកគណនារូបរាងមិនធម្មតា, ឬការផ្គូផ្គងលំនាំ)',
      specIalHoleAndSlotSurface: 'កំណត់ផ្ទៃដំណើរការរណ្តៅ និងរណ្តៅជង្ហុកពិសេសផ្ទាល់ខ្លួន',
      specialRuleTip: 'សូមជ្រើសរណ្តៅ និងរណ្តៅជង្ហុកពិសេស',
      specialSlotsHoles: 'ប្រភេទរណ្តៅ និងរណ្តៅជង្ហុក',
      holeType: 'ប្រភេទរណ្តៅ',
      specialRules: 'ច្បាប់',
      normalHole: 'រណ្តៅធម្មតា',
      normalSlot: 'រណ្តៅជង្ហុកធម្មតា',
      holeDiam: 'អង្កត់ផ្ចិតរណ្តៅ',
      slotLongSide: 'ជង្ហុករណ្តៅវែង',
      slotShortSide: 'ជង្ហុករណ្តៅខ្លី',
      FixedmachSurface: 'ផ្ទៃដំណើរការថេរ',
      deleteRuleTip: 'លុបច្បាប់នេះឬ?',
      blankFront: 'មុខផ្ទាំងធំ',
      blankBack: 'ក្រោយផ្ទាំងធំ',
      addRules: 'បន្ថែមច្បាប់',
      addRulesTip: 'ពេលផ្ទាំងតូចតែមួយត្រូវនឹងច្បាប់ច្រើន ច្បាប់ដែលមានលេខលំដាប់ដំណើរការតូចបំផុតត្រូវបានអនុវត្ត អាចអូសជួរដើម្បីផ្លាស់ប្តូរលំដាប់ច្បាប់',
      highGlossSetting: 'ការកំណត់ផ្ទាំងរលកពន្លឺ',
      heighGlossFront: 'ពេលរៀបចំ ផ្ទៃរលកពន្លឺនៃផ្ទាំងតូចត្រូវដាក់នៅផ្ទាំងធំ',
      highGlossPlankNoRotate: 'ផ្ទាំងរលកពន្លឺមិនដាក់ជាមួយ',
      highGlossAutoRoll: 'ផ្ទាំងធំដែលមានរណ្តៅ/រណ្តៅជង្ហុកនៅក្រោយប៉ុណ្ណោះបង្វិលស្វ័យប្រវត្តិ',
      highGlossAutoRollTip: "<span class='color-o-4'>(បើករួច ផ្ទាំងធំដែលមានរណ្តៅ/រណ្តៅជង្ហុកនៅក្រោយប៉ុណ្ណោះនឹងបង្វិលស្វ័យប្រវត្តិពេលរៀបចំ ក្លាយជាផ្ទាំងមួយមុខ។ ប្រើរួមជាមួយទិន្នន័យឈ្មោះឯកសារផ្ទាល់ខ្លួន «បង្វិលផ្ទៃរលកពន្លឺដាក់ផ្ទាំង»)</span>",
      customHighGlossReverse: 'បង្វិលផ្ទៃរលកពន្លឺដាក់ផ្ទាំង',
      sideSlotPut: 'ដាក់រណ្តៅជង្ហុកផ្ទាំងជិតគែម',
      optimize: 'កំពុងបង្កើនប្រសិទ្ធភាពមុខងារ',
      sysDefault: 'លំនាំប្រព័ន្ធ',
      plankInSide: 'ខាងក្នុងផ្ទាំងធំ',
      plankOutSide: 'ខាងក្រៅផ្ទាំងធំ',
      specialNotWork: 'មុខងារនេះមិនអនុវត្តលើផ្ទាំងរូបរាងមិនធម្មតា',
      commonSide: 'កាត់គែមរួម',
      commonSetting: 'ការកំណត់គែមរួម',
      plankThickRange: 'កម្រាស់ផ្ទាំងតូចជាងឬស្មើ',
      useCommonSide: 'ប្រើកាត់គែមរួម',
      zeroTip: 'ចន្លោះរៀបចំត្រូវប្តូរដោយដៃទៅ ០ ពេលដំណើរការដល់គែមដែលបានកាត់រួច លើកឧបករណ៍កាត់រំលងគែមនោះ។ បើកមុខងារនេះហើយ មិនគាំទ្រការកាត់ចុះអាក្សត់!',
      useTip: 'បើកមុខងារនេះរួច មិនគាំទ្រការកាត់ចុះអាក្សត់ សូមចំណាំ!',
      commonSpeed: 'បង្កើនល្បឿនគែមរួម',
      highSpeed: 'ល្បឿនម៉ាស៊ីនកិនលឿនខ្ពស់',
      min: 'នាទី',
      notWorkTip: 'ពេលដំណើរការផ្ទាំងត្រូវនឹងការកាត់គែមរួម ការបង្កើនល្បឿនគែមរួមមិនមានប្រសិទ្ធភាព',
      changeStartPoint: 'ប្តូរចំណុចចាប់ផ្តើមពីរកន្លែង',
      changeStartPointTip: 'បើកការប្តូរចំណុចចាប់ផ្តើមពីរកន្លែងរួច មិនសមស្របនឹងការប្តូរ XY សូមប្រើប្រយ័ត្ន',
      flatOffset: 'ការរអិលផ្ទៃប៉ាន់ដីម៉ាស៊ីន',
      xRowChange: 'ប្តូរមូលដ្ឋានកូអរដោនេ X',
      bigplankPointChange: 'ប្តូរមូលដ្ឋានកូអរដោនេផ្ទៃក្រោយផ្ទាំងធំ',
      reverseXRowChange: 'ប្តូរកូអរដោនេ X',
      changebigplankPointTips: 'បើកមុខងារនេះរួច មិនសមស្របនឹង«ប្តូរ XY» និង«ប្តូរចំណុចចាប់ផ្តើមពីរកន្លែង» សូមប្រើប្រយ័ត្ន',
      reverseYRowChange: 'ប្តូរកូអរដោនេ Y',
      plankMirrorTip: 'ប្រើមុខងារនេះពេលច្រឹបផ្ទាំងដែលដំណើរការនៅម៉ាស៊ីនកាត់',
      notSameSize: 'តុពីរកន្លែងមានទំហំខុសគ្នា',
      maxSize1: 'ទំហំអតិបរមាកន្លែង ១',
      notSameSizeTip: 'បើកតុពីរកន្លែងទំហំខុសរួច មិនសមស្របនឹងការរួមឯកសារពីរកន្លែង សូមប្រើប្រយ័ត្ន',
      maxSize2: 'ទំហំអតិបរមាកន្លែង ២',
      autoSelectTip: 'ពេលឧបករណ៍ពីរកន្លែងមានតុពីរទំហំខុស មុខងារនេះនឹងជ្រើសកន្លែងសម្រាប់ដំណើរការផ្ទាំងធំស្វ័យប្រវត្តិ',
      bigFlatLimit: 'កន្លែងធំដំណើរការតែផ្ទាំងធំដែលកន្លែងតូចមិនអាចដំណើរការ៖',
      surplusSetting: 'ការកំណត់សម្ភារៈនៅសល់',
      surplusPosition: 'ទីតាំងដាក់សម្ភារៈនៅសល់',
      cutHoleWay: 'វិធីកាត់ និងរណ្តៅ',
      knifeFlat: 'ផ្ទៃយោងឧបករណ៍កាត់',
      flat: 'ផ្ទៃតុ',
      plankFlat: 'ផ្ទៃផ្ទាំងធំ',
      freeHeightZ: 'កម្ពស់ Z ពេលទំនេរ',
      relativeHeight: 'កម្ពស់ធៀបនឹងផ្ទៃលើផ្ទាំងធំ',
      cutDeepZ: 'ជម្រៅ Z កាត់ឆ្លង',
      cutDeepH: 'វិធីរណ្តៅឆ្លងរណ្តៅ',
      setDisableDoubleSidedThroughHole: 'កំណត់មិនឱ្យរណ្តៅឆ្លងពីរមុខដោយបង្វិលពីរដងមានប្រសិទ្ធភាព',
      addHolesToRulesDisableDoubleSided: 'បន្ថែមរន្ធឆ្លង (រន្ធដែលចូលទៅដល់) ដែលត្រូវគ្នាទៅច្បាប់ខាងក្រោមរួច ការរណ្តៅឆ្លងដោយបង្វិលពីរដងមិនអនុវត្ត',
      onceThrough: 'រណ្តៅឆ្លងមួយដង',
      rollThrough: 'រណ្តៅឆ្លងដោយបង្វិលពីរដង',
      cutDeepS: 'វិធីរណ្តៅជង្ហុកឆ្លង',
      plankCutDirection: 'ទិសកាត់ផ្ទាំងតូច',
      clockDirSwitch: 'ទិសរណ្តៅជង្ហុក/រណ្តៅ និងកាត់រូបរាងខាងក្នុងតាមបំណង',
      millHoleSlotDir: 'ទិសរណ្តៅរណ្តៅជង្ហុក',
      millInternalCurveDir: 'ទិសកាត់រូបរាងខាងក្នុង',
      sDirection: 'តាមទិសនាឡិកា',
      nDirection: 'ច្រាសទិសនាឡិកា',
      curveReplenish: 'កាត់ផ្ទាំងរូបចង្កូមដោយពាក្យបញ្ជាបញ្ចូលរង្វង់',
      curveReplenishTip: 'ពេលកាត់ផ្ទាំងរូបចង្កូមមានធ្មេញរមាស អាចប្រើមុខងារនេះ',
      noGen: 'មិនបង្កើតពាក្យបញ្ជាផ្ទៃ G17/G18/G19',
      arcInstruction: 'បុព្វបទពាក្យបញ្ជាដំណើរការរង្វង់',
      example: 'ឧទាហរណ៍',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'កាត់រង្វង់ប្រើ I និង J',
      coverRate: 'អត្រាស្ទូចស្រទាប់ពេលកិនរណ្តៅជង្ហុក៖',
      roughTip: 'ប្រើមុខងារនេះពេលកិនរណ្តៅជង្ហុកមានស្នាមក្នុងរណ្តៅ',
      clearCurve: 'ពេលកិនរណ្តៅជង្ហុក រណ្តៅមិនទាន់ឆ្លង សម្អាតមុំរង្វង់ស្វ័យប្រវត្តិ៖',
      curveUseTip: 'ពេលកិនរណ្តៅជង្ហុកត្រូវសម្អាតមុំរង្វង់ ជ្រើសមុខងារនេះ មិនអនុវត្តលើផ្នែកភ្ជាប់',
      slotCutWay: 'វិធីដំណើរឧបករណ៍កិនរណ្តៅជង្ហុក',
      outToIn: 'កិនរណ្តៅជង្ហុកពីក្រៅចូលក្នុង',
      inToOut: 'កិនរណ្តៅជង្ហុកពីក្នុងចេញក្រៅ',
      zShapProcess: 'កិនរណ្តៅជង្ហុកឆ្លងរូប Z លើក្រោម',
      zShapProcessTip: 'មានប្រសិទ្ធភាពតែសម្រាប់កិនរណ្តៅជង្ហុកឆ្លងដែលទាញពីមុខ-ក្រោយ អត្រាស្ទូចផ្លូវឧបករណ៍លំនាំដើមគឺកាំឧបករណ៍',
      zSlotCuttingOverlapRate: 'អត្រាស្ទូចកាត់រណ្តៅជង្ហុករូប Z',
      zSlotCuttingOverlapRateTip: 'អត្រាស្ទូចបច្ចុប្បន្នអាចធ្វើឱ្យល្បឿនដំណើរការយឺត សូមសាកល្បងម៉ាស៊ីនរួចរួចដំណើរការ',
      slotWorkLimit: '(មានប្រសិទ្ធភាពតែពេលចំនួនស្រទាប់ដំណើរកាត់រណ្តៅជង្ហុក > ១)',
      minKnifeChange: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      preventBreakage: 'ការពារការបាក់របាំងរណ្តៅជង្ហុកគែម',
      preventBreakageTip: 'ការកំណត់នេះមានប្រសិទ្ធភាពតែសម្រាប់រណ្តៅជង្ហុកនៅផ្ទៃខាងមុខពេលរៀបបន្ទះ ហើយអាចប្រើជាមួយមុខងារ "កំណត់ផ្ទៃដំណើរការរណ្តៅ និងរណ្តៅជង្ហុកពិសេសផ្ទាល់ខ្លួន"',
      preventBreakageTip1: 'អាចដោះស្រាយបញ្ហានៅពេលរណ្តៅជង្ហុកនៅជិតគែមបន្ទះពេក ហើយពេលកាត់ របារបំបែក (ផ្នែកតភ្ជាប់ដែលនៅសល់) នៅទីតាំងនោះងាយបែកដោយសារការប្រមូលផ្តុំសម្ពាធ',
      preventBreakageDistance: 'ចម្ងាយពីគែមបន្ទះ',
      preventBreakageLength: 'ប្រវែងផ្នែកជិតគែម',
      preventBreakageSlot: 'រណ្តៅជង្ហុក',
      preventBreakageCutDeep: 'ជម្រៅកាត់លើកដំបូង',
      workSpeedOp: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      obliqueCut: 'កាត់ចុះអាក្សត់ពេលកាត់',
      obliqueCutTip: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      obliqueThickLabel: 'កម្រាស់បន្ទះមានប្រសិទ្ធភាពនៃការកាត់ទ្រេតផ្ទាល់ខ្លួន',
      obliqueThick: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      backObliqueThick: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      effectiveThickness: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
      effectiveThicknessTip: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការមិនអាចជ្រើសរើសគ្នាទេ, សូមបញ្ចូល!',
      effectiveThicknessDuplicateTip: 'កម្រាស់មានប្រសិទ្ធមិនអាចស្ទួនគ្នា សូមកែប្រែ',
      obliqueCutData: 'ចម្ងាយចុះអាក្សត់',
      backOblique: 'កាត់ចុះអាក្សត់កែគែមផ្ទៃក្រោយ',
      obliqueSpeed: 'ល្បឿនចុះអាក្សត់',
      obliqueSpeedTip: 'ល្បឿនចុះអាក្សត់',
      arcSpeed: 'ល្បឿនដំណើរការខ្សែកោង',
      cuttingPreDistance: 'ចម្ងាយដាក់ឧបករណ៍កាត់មុនពេលកាត់',
      backKnife: 'យឺតពេលទាញឧបករណ៍កាត់ចេញពីការកាត់',
      openKnifeSpeed: 'ល្បឿនទាញឧបករណ៍កាត់',
      retractionCompensation: 'ការសងចម្ងាយទាញឧបករណ៍កាត់',
      retractionCompensationTip: 'តម្លៃអតិបរមា ២០',
      cutCornerSlow: 'យឺតនៅមុំកាត់',
      addRow: 'បន្ថែមជួរ',
      bettwenDistance: 'ចម្ងាយមុន និងក្រោយមុំ',
      cuttingSpeed: 'ល្បឿនកាត់',
      stepCutting: 'កាត់ជាស្រទាប់',
      splitSlot: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
      splitPlank: 'កាត់ផ្ទាំងតូចពីរដង',
      splitPlank2: 'កាត់ផ្ទាំងតូចពីរដង',
      minSafeThick: 'កម្រាស់ធំជាង',
      splitPlankTip: '(មុខងារនេះមិនអនុវត្តលើផ្ទាំងរូបរាងមិនធម្មតា)',
      splitPlankTip2: '(មិនត្រូវបានប្រើ: កាត់លើកលើកការផ្ទាល់ខ្ទង់)',
      cutPlankMethod: 'កាត់ផ្ទាំងតូចពីរដង',
      cutPlankMethodTip: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
      cutPlankMethodTip2: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
      specialShapCut: 'កាត់ផ្ទាំងរូបរាងមិនធម្មតាពីរដង',
      specialShapCutTip: '(បើករួច ផ្ទាំងរូបរាងមិនធម្មតាទាំងអស់នឹងកាត់ពីរដង)',
      bridgeRetention: 'វិធីសាស្ត្រស្ពានរក្សាចំណុច',
      bridgeRetentionTip: '(ចំណាំ: 1. មុខងារនេះបណ្ដោះអាសន្នមិនគាំទ្រផ្ទាំងរូបរាងមិនធម្មតាខាងក្រៅ។ 2. មិនគាំទ្រការកាត់ចុះអាក្សត់។ 3. ទំហំអប្បបរមានៃផ្ទាំងសម្រាប់បង្កើតស្ពានតភ្ជាប់គឺ 30mm។)',
      bridgeRetentionDesc: 'ជួយដោះស្រាយបញ្ហាផ្ទាំងញ័រ ឬរអិល នៅពេលមានតំបន់ប្រហោងច្រើនក្នុងផ្ទាំង ធ្វើឱ្យផ្លូវកាត់ខ្វះការទ្រទ្រង់។',
      bridgePunchArea: 'ផ្នែកដែលចោះឆ្លងលើសផ្ទៃសរុប',
      bridgeSize: 'ទំហំស្ពានតភ្ជាប់',
      bridgeGenMethod: 'វិធីបង្កើត',
      bridgeAddTip: 'បន្ថែមបានអតិបរមា 10 ទិន្នន័យ',
      bridgeCount: 'ចំនួនស្ពានតភ្ជាប់',
      bridgePlankLength: 'ប្រវែងផ្ទាំង (L)',
      maxWH: 'ប្រវែងឬទទឹងតូចជាង',
      areaLimit: 'និងក្រឡាតូចជាង',
      secondDeep: 'ជម្រៅកាត់លើកទីពីរ',
      splitPlankThickSetting: 'ការកំណត់កាត់ជាស្រទាប់ពេលកាត់វត្ថុធាតុ',
      saveCustomSpeedTip: 'ល្បឿនដំណើរការមិនអាចទទេ',
      saveLayeredCuttingTip: 'ផលបូកកាត់បីស្រទាប់ត្រូវស្មើកម្រាស់ផ្ទាំង',
      saveLayeredRepeatTip: 'មិនសូមណែនាំឱ្យកំណត់ទិន្នន័យស្រទាប់ខុសគ្នាសម្រាប់ទម្លាប់រលកពន្លឺនៃវត្ថុធាតុដូចគ្នា សូមលុបទិន្នន័យលើស!',
      splitPlankThick: 'កាត់ជាស្រទាប់តាមកម្រាស់ផ្ទាំងខុសគ្នា',
      movePlankSetting: 'ការកំណត់ការការពារផ្ទាំងរុញចេញ',
      newCutSequence: 'អាល់ហ្គូរីដ្ឋានកាត់ថ្មី',
      newCutSequenceText: 'លំនាំដើម កណ្តាលផ្ទាំងធំមានការច្របាក់សុញ្ញាកាសខ្លាំងបំផុត ផ្ទាំងតូចនៅតំបន់នេះកាត់ចុងក្រោយ',
      positionTip: 'ចុចតំបន់ដែលត្រូវគ្នាដើម្បីជ្រើស',
      suctionPosition: 'ទីតាំងច្របាក់សុញ្ញាកាសខ្លាំង',
      strongArea: 'តំបន់ច្របាក់ខ្លាំង',
      minSuctionPlank: 'ផ្ទាំងតូបរមាដែលច្របាក់បាន',
      safeWidth: 'ទទឹង',
      safeHeight: 'ប្រវែង',
      safeTip: 'ផ្ទាំងដែលច្របាក់មិនបាននឹងកាត់មុន',
      scattered_layout: 'រៀបចំផ្ទាំងតូចរាយ',
      lastCutPointEnable: 'កំណត់ផ្ទាល់ខ្លួនចំណុចកាត់ក្តារតូចកាត់ចុងក្រោយនៅលើក្តារធំ',
      lastCutPointEnableTip: 'ពេលបើក ចំណុចកាត់នៃក្តារតូចកាត់ចុងក្រោយលើក្តារធំនីមួយៗនឹងត្រូវបង្កើតឡើងតាមទីតាំងចំណុចដែលកំណត់',
      lastCutPoint: 'ទីតាំងចំណុចកាត់',
      lastCutPointTip: 'ពេលបើក ក្តារតូចកាត់ចុងក្រោយនៅលើក្តារធំនីមួយៗនឹងប្រើចំណុចកាត់នេះ',
      leftTop: 'ខាងឆ្វង់លើ',
      rightTop: 'ខាងស្តាំលើ',
      leftBottom: 'ខាងឆ្វង់ក្រោម',
      rightBottom: 'ខាងស្តាំក្រោម',
      specifyTheMaterial: 'កំណត់វត្ថុធាតុ',
      shapeSecondCutenable: 'កាត់លើកពីរសម្រាប់ផ្ទាំងរូបរាងមិនធម្មតា',
      addMaterial: 'បន្ថែមវត្ថុធាតុ',
      plankMaterial: 'វត្ថុធាតុផ្ទាំង',
      specifyTheMaterialTip: 'បើករួច ការកាត់លើកពីរមានប្រសិទ្ធភាពតែលើផ្ទាំងដែលត្រូវនឹងវត្ថុធាតុក្នុងតារាង',
      dispersePaibanTipOne: '១. បើករួច លើផ្ទាំងធំគ្រប់សន្លឹកមានយ៉ាងហោចណាស់មួយផ្ទាំងដែលត្រូវទំហំច្របាក់តូបរមា',
      dispersePaibanTipTwo: '២. ប្រើរួច ចំនួនផ្ទាំងធំអាចកើន សូមចំណាំ',
      totalThickLimit: 'ផលបូកកាត់បីស្រទាប់ត្រូវស្មើកម្រាស់ផ្ទាំង',
      offsetFollowStep: 'ការកែគែមក៏ធ្វើតាមការកាត់ជាស្រទាប់',
      longPlankTip1: '១. បើក/បិទមុខងារនេះរួច កំណត់ត្រារៀបចំដែលបានរក្សាទុកក្នុងប្រវត្តិ ត្រូវរៀបចំឡើងវិញនៅពេលទាញយក NC',
      longPlankTip2: '២. បើកមុខងារនេះរួច ត្រូវកំណត់កូដផ្អាកប៉ំបូមសុញ្ញាកាសនៅ [ការភ្ជាប់ម៉ាស៊ីនកាត់ - ផ្អាកប៉ំបូមសុញ្ញាកាស] បើមិនដូច្នោះទេ មិនអាចដោះស្រាយការបត់ផ្ទាំងវែងបាន',
      longPlankTip3: '៣. លក្ខខណ្ឌចម្រោះដែលបើកខាងក្រោមត្រូវផ្ទៀងផ្ទាត់តាមជាន់ជាលំដាប់ មានតែផ្ទាំងដែលបំពេញលក្ខខណ្ឌចម្រោះនៃជាន់មុនប៉ុណ្ណោះដែលអាចចូលទៅលក្ខខណ្ឌចម្រោះជាន់បន្ទាប់ដើម្បីវាយតម្លៃ។',
      secondCutting: 'គោលដៅកាត់លើកទីពីរ',
      normalPlank: 'ផ្ទាំងធម្មតា',
      normalPlankTip: 'ផ្ទាំងធម្មតា៖ ផ្ទាំងដូចជាបន្ទាត់ផ្តេក/បញ្ឈរក្នុងទូ និងផ្ទាំងដែលបន្ថែមដោយផ្ទាល់ទៅបញ្ជីកាត់ មិនរួមបញ្ចូលទ្វារទូ',
      designatedTarget: 'វត្ថុដែលបានកំណត់',
      filterLevel1Label: 'តម្រង់កម្រិត១',
      filterLevel1Category: 'ប្រភេទផ្ទាំង',
      filterLevel2Label: 'តម្រង់កម្រិត២',
      filterLevel2Category: 'កំណត់ទំហំ',
      filterLevel3Label: 'តម្រង់កម្រិត៣',
      filterLevel3Category: 'ផ្សេងៗ',
      specifiedBoardForceEnable: 'មិនអើពើទំហំ/តម្រង់ផ្សេង បង្ខំបើក',
      curveMaterialFilterTip: '(បន្ទាប់ពីជ្រើស «ផ្ទាំងរាងមិនធម្មតា» ត្រូវជាផ្ទាំងរាងមិនធម្មតាមុនតម្រង់សម្ភារ)',
      cuttingSettings: 'ការកំណត់កាត់',
      plankSizeLimitSuffix: ' ផ្ទាំង',
      specifiedBoard: 'កាត់តាមឈ្មោះផ្ទាំង',
      specifiedBoardTip: 'បើករួច ពេលឈ្មោះផ្ទាំងមានឈ្មោះដែលបន្ថែមខាងក្រោម ការកាត់លើកពីរមានប្រសិទ្ធភាព',
      addPlankName: 'បន្ថែមឈ្មោះផ្ទាំង',
      plankNameEmpty: 'ឈ្មោះផ្ទាំងមិនអាចទទេ សូមបញ្ចូល',
      plankNameRequired: 'សូមបន្ថែមយ៉ាងហោចណាស់មួយឈ្មោះផ្ទាំង',
      plankLongLimit: 'ពេលគែមវែងនៃផ្ទាំងវែងលើស',
      plankShortLimit: 'ពេលគែមខ្លីលើស',
      cuttingSplit: 'កាត់ពីរដំណាក់កាល',
      longExpand: 'ការបញ្ចេញលើកទីមួយ៖ បញ្ចេញគែមវែង',
      firstExpand: 'ការបញ្ចេញលើកទីមួយ',
      longExpandTip: 'ការបញ្ចេញគែមវែង',
      longLimit: 'ពេលគែមវែងលើស',
      cuttingSplitTip: 'លក្ខខណ្ឌកាត់ផ្ទាំងវែងពីរដំណាក់កាល',
      shortExpand: 'ការបញ្ចេញគែមខ្លី',
      expandTip: 'ទំហំគែមវែង/ខ្លីបង្កើនរៀងគ្នា X mm សម្រាប់ផ្ទាំងវែងរូបរាងមិនធម្មតា បញ្ចេញគែមខ្លី និងវែងគឺតម្លៃបញ្ចេញគែមវែង',
      pumpOffWay: 'វិធីបិទសុញ្ញាកាស',
      afterOnePlank: 'បន្ទាប់ពីកាត់ផ្ទាំងវែងមួយសន្លឹក',
      afterAllPlank: 'បន្ទាប់ពីកាត់ផ្ទាំងធំទាំងមួយសន្លឹក',
      numberFixed: 'ចំនួនខ្ទង់ទសភាគ',
      bufferCode: 'ការកំណត់ពាក្យបញ្ជាប៊ឺហ្វរពេលចុះឧបករណ៍កាត់',
      layoutGap: 'ការកំណត់ចន្លោះរៀបចំ',
      layoutGapTip: 'ចំណាំ៖ កំណត់ចន្លោះរៀបចំជា ០ អាចធ្វើឱ្យរៀបចំស្ទូចគ្នា',
      wasteCutting: 'កាត់សម្ភារៈចោលស្វ័យប្រវត្តិ',
      zkPointCustomize: 'កំណត់ចំណុចយោងបង្វិលដំណើរការរណ្តៅអាក្សត់ Z ផ្ទាល់ខ្លួន',
      sawSetting: 'ការកំណត់កាត់រណា',
      cuttingLimit: 'ទំហំកាត់ធំជាង',
      waste: 'សម្ភារៈចោល',
      wasteSizeLimit: 'ទំហំតូបរមាមិនអាចតូចជាង ១០០ mm',
      topLeft: 'ឆ្វេង លើ',
      topLeftD: 'មុំឆ្វេងលើ',
      bottomLeft: 'ឆ្វេង ក្រោម',
      bottomLeftD: 'មុំឆ្វេងក្រោម',
      topRight: 'ស្តាំ លើ',
      topRightD: 'មុំស្តាំលើ',
      bottomRight: 'ស្តាំ ក្រោម',
      bottomRightD: 'មុំស្តាំក្រោម',
      firstTime: 'លើកទីមួយ',
      secondTime: 'លើកទីពីរ',
      thirdTime: 'លើកទីបី',
      startCutting: 'ការកាត់ចាប់ផ្តើម',
      thickRange: 'កម្រាស់ ≥',
      longCut: 'ដំណើរការផ្ទាំងវែង',
      edgeSetting: 'ការកំណត់កែគែម',
      cuttingOrder: 'លំដាប់កាត់៖',
      cuttingOrderTip: 'វិធីនេះមានហានិភ័យផ្ទាំងរុញ សូមប្រើប្រយ័ត្ន',
      plankFirst: 'កាត់ផ្ទាំងតូចមុន',
      wasteFirst: 'កាត់សម្ភារៈចោលមុន',
      offTip: 'ពេលបិទនឹងធ្វើតាមការកំណត់កែគែមក្នុងប៉ារ៉ាម៉ែត្រកាត់',
      edgeCutDirection: 'ទិសកែគែម',
      lGapTip: 'ទីតាំងដាក់ចន្លោះនៅផ្ទាំងធំសម្ភារៅនៅសល់រូប L កែស្វ័យប្រវត្តិតាមទិសទ្រេតនៃស៊ីលីនដែរកំណត់ទីតាំង លើកលែងផ្ទាំងធំសម្ភារៅនៅសល់រលកពន្លឺ មិនសមស្របនឹងការប្តូរ xy',
      cylinderDir: 'ទិសស៊ីលីនដែរកំណត់ទីតាំង',
      onlyLong: 'កែតែគែមវែង',
      backCutOrder: 'លំដាប់កែគែមផ្ទៃក្រោយ',
      backFirst: 'កែផ្ទៃក្រោយមុន',
      backSecond: 'កែគែមបន្ទាប់ពីដំណើរការរណ្តៅ/រណ្តៅជង្ហុកក្រោយ',
      frontReCut: 'កែផ្ទៃមុខម្តងទៀត',
      frontReCutTip: 'ដើម្បីធ្វើគែមស៊ីលីនដែរកំណត់ទីតាំងឱ្យរលូន និងការពារស្នាម',
      useNewCut: 'ប្រើច្បាប់កែគែមថ្មី',
      newCutTip: 'ប្រើមុខងារនេះពេលដំណើរការផ្ទាំងធំពីរមុខត្រូវការកែគែមបន្ថែមនៅមុខ',
      fixedTip: 'ចំណាំ៖ រក្សាខ្ទង់ទសភាគ ០ ឬ ១ អាចធ្វើឱ្យរៀបចំស្ទូចគ្នា',
      cuttingSlow: 'បម្រុងនៅលើផ្ទៃនៃផ្នែកកាត់',
      holeSlow: 'បម្រុងនៅលើផ្ទៃនៃផ្នែកដែលមានរន្ធ',
      slotSlow: 'បម្រុងនៅលើផ្ទៃនៃផ្នែករណ្តៅ / កាត់រណ្តៅ / កាត់រណ្តៅ',
      slowCode: 'ការប្រើប្រាស់ពាក្យបញ្ជាបម្រុង',
      code: 'ពាក្យបញ្ជា',
      bufferOffset: 'ការផ្លាស់ទីកម្ពស់បម្រុងនៅលើផ្ទៃផ្នែក',
      zkRotatePoint: 'ចំណុចយោងបង្វិល',
      zkRotateDir: 'ទិសដៅកើននៃមុំបង្វិល',
      restSizeLimit: 'ទំហំដែលនៅសល់តូចជាង',
      useSaw: 'ប្រើកាំបិទរណ្តៅ',
      unGenSawPath: 'កុំបង្កើតផ្លូវកាត់រណ្តៅតាមបណ្តោយ',
      suitMachine: 'សមស្របសម្រាប់ការដំណើរការផ្ទាំងអាលុយមីញ៉ូមដែលផ្សារពេញលេញ',
      plankBack: 'ខាងក្រោយនៃផ្ទាំងធំ',
      plankLeft: 'ខាងឆ្វេងនៃផ្ទាំងធំ',
      plankRight: 'ខាងស្តាំនៃផ្ទាំងធំ',
      plankFront: 'ខាងមុខនៃផ្ទាំងធំ',
      frontSide: 'ខាងមុខ',
      backSide: 'ខាងក្រោយ',
      rightSide: 'ខាងស្តាំ',
      leftSide: 'ខាងឆ្វេង',
      singleMachineLimit: 'បង្កើតផ្លូវកែសម្រួលគែមនៅមុខផ្ទាំងដែលដំណើរការមួយផ្ទៃ ហើយកែសម្រួលគែមមុនគេ',
      singleMachineLimitTip: 'មុខងារនេះមិនអនុវត្តសម្រាប់ម៉ាស៊ីនរួម ឬការកាត់ដោយកាំបិទរណ្តៅទេ',
      setBatchPositionWaring: 'ព័ត៌មានជំនួយ៖ ប្រសិនបើអ្នកត្រូវការលុបចោលម៉ូដកែប្រែចំណុចកាត់រហ័ស សូមដកសម្គាល់ប៊ូតុង «កែប្រែចំណុចកាត់» ខាងស្តាំ',
      setBatchPosition: 'កែប្រែចំណុចកាត់ជាក្រុម',
      setBatchPositionAs: 'កែប្រែទិសដៅកាត់ទៅជា៖',
      activeBatchPosition: 'បានជ្រើសរើសផ្ទាំងតូច {activePartCount} សន្លឹក',
      specialFrontSide: 'រណ្តៅពិសេសដែលកំណត់ក្នុងការបំបែករណ្តៅ ត្រូវបានដាក់អាទិភាពនៅមុខផ្ទាំងធំ',
      rollCountTip: 'បន្ទាប់ពីបើកការបំបែករណ្តៅ គណនាចំនួនដងបត់តាមរណ្តៅខាងក្រោយដែលដំណើរការពិតលើម៉ាស៊ីនចុកចាក់',
      specialFrontSideTip: 'បណ្តាញផលិតកម្មបច្ចុប្បន្នមិនគាំទ្រការប្តូរបណ្តាញទេ ដោយសារបានបើកមុខងារដាក់រណ្តៅពិសេសនៅមុខផ្ទាំងធំក្នុងការបំបែករណ្តៅ ឬគណនាចំនួនបត់តាមរណ្តៅខាងក្រោយពិតនៅលើម៉ាស៊ីនចុកចាក់បន្ទាប់ពីបើកការបំបែករណ្តៅ',
      doubleTrim: 'ការកែសម្រួលគែមផ្ទាំងពីរផ្ទៃ',
      trim: 'ការកែសម្រួលគែម',
      trimTwoSide: 'កែសម្រួលពីរគែម',
      trimFourSide: 'កែសម្រួលបួនគែម',
      rightInmShow: 'ដូចបានបង្ហាញនៅក្នុងរូបខាងស្តាំ',
      currentTrimDir: 'សម្រាប់ទិសដៅកែសម្រួលគែមដែលបានជ្រើសរើសបច្ចុប្បន្ន',
      cylinderTip: 'ដើម្បីកំណត់ទីតាំងស៊ីលីនឌ័រ',
      onlyShort: 'កែសម្រួលតែគែមខ្លី',
      singleTrim: 'បង្កើតផ្លូវកែសម្រួលគែមសម្រាប់ផ្ទាំងតែមួយ',
      hierarchyCutTwice: 'ការកាត់ជាស្រទាប់សម្រាប់រណ្តៅដែលច្រឹករណ្តៅ',
      knifeDia: 'អង្កត់ផ្ចិតកាំបិទតូចជាងឬស្មើ',
      slotDeep: 'ហើយជម្រៅរណ្តៅធំជាងឬស្មើ',
      cutTwiceSlot: 'នៅពេលធ្វើការកាត់រណ្តៅជាស្រទាប់',
      twiceSlotDeep: 'ជម្រៅការកាត់ស្រទាប់ទីពីរ',
      cutTwiceCondition: 'លក្ខខណ្ឌកាត់',
      zkPointCustomizeTip: 'ការបើកប្តូរអ័ក្ស XY នឹងធ្វើឱ្យទិសដៅដំណើរការ និងចំណុចយោងផ្ទុយគ្នា',
      zkPointCustomizeTip1: 'មុខងារនេះមិនដំណើរការលើឧបករណ៍ដែលបើកការប្តូរអ័ក្ស XY ទេ',
      isCustom: 'បើកការកំណត់ផ្ទាល់ខ្លួន',
      useCutCon: 'ប្រើលក្ខខណ្ឌកាត់រណ្តៅ',
      singleSetPlankSizeSpeed: 'កំណត់ល្បឿនដំណើរការសម្រាប់ជួរទំហំផ្ទាំងជាក់លាក់',
      singleSetPlankSizeSpeedTip: '(១. ផ្ទាំងតូចដែលត្រូវទំហំខាងក្រោមនឹងត្រូវដំណើរការតាមល្បឿនដែលបានកំណត់។ ២. ប្រសិនបើផ្ទាំងតូចត្រូវនឹងច្បាប់ច្រើនក្នុងពេលតែមួយ ច្បាប់ដែលមានលេខលំដាប់មុនគេមានប្រសិទ្ធភាព។ ៣. មុខងារនេះមិនអនុវត្តសម្រាប់ការកាត់ដោយកាំបិទរណ្តៅទេ។)',
      addSpeedRules: 'បន្ថែមច្បាប់',
      speedRules: 'ច្បាប់',
      shortSideSize: 'ទំហំគែមខ្លី',
      lessThanEqual: 'តូចជាងឬស្មើ',
      and: 'និង',
      longSideSize: 'ទំហំគែមវែង',
      processingSpeed: 'ល្បឿនដំណើរការ',
      trimLenCompensation: 'ការសងសឹងប្រវែងកែសម្រួលគែម៖',
      trimGenerateAPath: 'តម្លៃកែសម្រួលគែម ០ មិនបង្កើតផ្លូវទេ៖',
      cuttingMethod: 'វិធីកាត់',
      horizontalCutting: 'កាត់ផ្តេក',
      verticalCutting: 'កាត់បញ្ឈរ',
      openKnifeDistance: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច'
      },
    labelingSettings: {
      title: 'ការកំណត់ស្លាក',
      output: 'នាំចេញឯកសារស្លាកស្វ័យប្រវត្តិ',
      specification: 'ទ្រង់ទ្រាយឯកសារស្លាក',
      codeFrontGenerate: 'បង្កើតកូដបំពេញស្វ័យប្រវត្តិមុនកូដស្លាក',
      templateOffline: 'គំរូដែលប្រើមិនមានលើបណ្តាញ!',
      templateNotSupport: 'គំរូនេះមិនគាំទ្រទេ សូមជ្រើសឡើងវិញ!',
      rollLabelling: 'ការកំណត់ស្លាកបត់',
      flipSetting: {
        title: 'ការកំណត់បត់',
        engravingFlipProcess: 'បើកម៉ូដស្លាកដំណើរការបត់លើម៉ាស៊ីនចុកចាក់',
        flipTip: 'បើកមុខងារនេះនៅពេលម៉ាស៊ីនចុកចាក់ត្រូវការបត់សម្រាប់ដំណើរការ'
        },
      rotateSetting: {
        title: 'ការកំណត់បង្វិលស្លាក',
        rotateTip: 'នៅពេលទំហំផ្ទាំងតូចជាងតម្លៃដែលបានកំណត់សម្រាប់ទទឹងឬកម្ពស់ ស្លាកនឹងបង្វិល ៩០°តាមទិសនាឡិកា',
        horizontal: 'គែមផ្តេកនៃផ្ទាំង',
        vertical: 'គែមបញ្ឈរនៃផ្ទាំង',
        either: 'ទទឹងឬកម្ពស់នៃផ្ទាំង'
        },
      countertopSetting: {
        title: 'ការកំណត់តុការងារ',
        startPoint: 'ចំណុចចាប់ផ្តើមស្ថានីយ៖',
        upLeft: 'ខាងលើឆ្វេង',
        upRight: 'ខាងលើស្តាំ',
        downLeft: 'ខាងក្រោមឆ្វេង',
        downRight: 'ខាងក្រោមស្តាំ',
        baseExchange: 'ការប្តូរមូលដ្ឋានកូអរដោនេ៖',
        exchangeX: 'ប្តូរអ័ក្ស X',
        exchangeY: 'ប្តូរអ័ក្ស Y'
        },
      offset: 'ការផ្លាស់ទីកូអរដោនេស្លាក',
      offsetTip: 'ជាទូទៅកូអរដោនេស្លាកនៅកណ្តាលផ្ទាំងតូច ឧបករណ៍មួយចំនួនត្រូវការកែតម្រូវ',
      label_rotate_offset: 'ការផ្លាស់ទីកូអរដោនេស្លាកបន្ទាប់ពីបង្វិល',
      label_rotate_offset_tip: 'កែតម្រូវនៅពេលទីតាំងផ្លាស់ទីមុននិងបន្ទាប់ពីបង្វិលខុសគ្នាច្រើន',
      label_rotate_offset_err_tip: 'បន្ទាប់ពីបើកការផ្លាស់ទីកូអរដោនេបន្ទាប់ពីបង្វិលស្លាក ត្រូវបំពេញការផ្លាស់ទីអ័ក្ស X និង Y',
      imgSetting: {
        title: 'ការកំណត់រូបភាពស្លាក',
        suffix: 'បច្ច័យរូបភាពស្លាក៖',
        code: 'វិធីសាស្ត្រកូដរូបភាព៖',
        codeTip: 'png និង jpeg កែទ្រង់ទ្រាយកូដរូបចងក្រងរួមគ្នា ការចងក្រងក្នុងពពកខ្ចប់មិនគាំទ្រមុខងារនេះទេ',
        imgRatio: 'គុណភាពរូបភាពស្លាក៖',
        slowDown: 'បន្ថយប្រសិទ្ធភាពនាំចេញរូបភាពស្លាក',
        color: 'ពណ៌ពិត',
        bit: 'ខ្មៅស',
        resolution: 'គុណភាពរូបភាពស្លាក',
        resolutionPlaceholder: 'គុណភាព',
        labelPool: 'អាងស្លាកទិន្នន័យ',
        showKey: 'បង្ហាញវាល',
        dragTip: 'អ្នកអាចអូសទម្លាក់ស្លាកនៅក្នុងអាងស្លាក',
        labelImgName: 'ឈ្មោះរូបភាពស្លាក',
        labelImgNameErrTip: 'ឈ្មោះរូបភាពស្លាកមិនអាចទទេ',
        labelTip1: 'ពេលកំណត់ផ្ទាល់ខ្លួន ត្រូវប្រើ [បាកូដផ្ទាំង] ឬ [លេខលំដាប់ស្លាក] មួយក្នុងពីរ បើមិនដូចនោះទេ រូបភាពអាចជាប់គ្នា',
        labelTip3: '【លេខលំដាប់ស្លាក】 គឺជាលេខលំដាប់ស្លាកពីលើទៅកាន់ខាងក្រោមនៃការផែងផែង និងស្លាកតាមរយៈការបង្កើតផ្ទាល់ខ្លួនមិនមានទិន្ទន៍នេះ',
        labelTip2: '3. មុខងារនេះមិនអនុវត្តសម្រាប់គំរូប្រព័ន្ធម៉ាស៊ីនស្លាកទេ',
        delimiter: 'សញ្ញាបំបែក៖',
        inputTip: 'មិនគាំទ្រការវាយបញ្ចូលតួអក្សរដូចជា / : ? < > | . ” *',
        numStart: 'តម្លៃចាប់ផ្តើមលេខលំដាប់ស្លាក',
        example: 'ឈ្មោះរូបភាពស្លាកផ្ទាល់ខ្លួន (ឧទាហរណ៍)',
        stockNumOffset: 'ចំនួនខ្ទង់សងសឹងលេខស៊េរីផ្ទាំងធំដល់',
        divideFolders: 'បំបែករូបភាពស្លាកទៅថតផ្សេងៗតាមផ្ទាំងធំ',
        foldersTip1: 'សម្គាល់៖ ១. មិនអាចប្រើមុខងារនេះរួមជាមួយមុខងាររួមឯកសារម៉ាស៊ីនកាត់វត្ថុធាតុ',
        foldersTip2: '២. មុខងារនេះមិនទាន់មានប្រសិទ្ធភាពសម្រាប់ការចងក្រងក្នុងពពកខ្ចប់ទេ',
        stickIntoFolders: 'បញ្ចូលឯកសារស្លាកទៅថតរូបភាពស្លាករបស់ផ្ទាំងធំដែលត្រូវគ្នា៖',
        stickTip1: 'សម្គាល់៖ ១. មុខងារនេះត្រូវប្រើរួមជាមួយមុខងារទាញយក NC និងនាំចេញស្លាក',
        stickTip2: '២. មុខងារនេះមានប្រសិទ្ធភាពតែនៅពេលគំរូស្លាកដែលប្រើជ្រើសច្បាប់បង្កើតឯកសារជា «បង្កើតឯកសារតែមួយ»',
        stickTip3: '៣. មុខងារនេះមិនទាន់មានប្រសិទ្ធភាពសម្រាប់ការចងក្រងក្នុងពពកខ្ចប់ទេ'
        },
      paibanImgSetting: {
        title: 'ការកំណត់រូបភាពចងក្រង',
        tip: 'បើកនាំចេញរូបចងក្រងផ្ទាល់ខ្លួន គំរូថេរខាងក្រោមមិនអាចនាំចេញ។ បើត្រូវការនាំចេញ បិទនាំចេញរូបចងក្រងផ្ទាល់ខ្លួននៅក្នុងការកំណត់បន្ថែមនៃទំព័រចងក្រង',
        reparation: 'ការសងសឹងស្វ័យប្រវត្តិលេខលំដាប់រូបចងក្រងដល់',
        figure: 'ខ្ទង់',
        inputTip: 'សូមបញ្ចូលលេខពី ១ ដល់ ៩៩',
        paibanImg: {
          export: 'នាំចេញរូបភាពចងក្រង',
          prefix: 'បុព្វបទឈ្មោះរូបភាពចងក្រង',
          size: 'ទំហំរូបភាពចងក្រង',
          format: 'ទ្រង់ទ្រាយរូបភាពចងក្រង',
          directional: 'ទិសដៅចងក្រង',
          vertical: 'បញ្ឈរ',
          horizontal: 'ផ្តេក'
          }
        },
      autolabel: 'ការកំណត់លំដាប់ស្លាកស្វ័យប្រវត្តិ',
      customTemp: 'មានប្រសិទ្ធភាពសម្រាប់តែគំរូផ្ទាល់ខ្លួន',
      cuttingLabelOder: 'ស្លាកតាមលំដាប់កាត់',
      labelToUp: 'ស្លាកពីក្រោមឡើងលើតាមលទ្ធផលចងក្រង',
      labelToDown: 'ស្លាកពីលើចុះក្រោមតាមលទ្ធផលចងក្រង',
      labelDodge: 'ការរួចផុតស្លាកស្វ័យប្រវត្តិ',
      nolabelForsurplus: 'មិនបង្កើតឯកសារស្លាកសម្រាប់ផ្ទាំងសម្ភារៈនៅសល់',
      settingValue: 'ជ្រើសតម្លៃកំណត់',
      enabelTip: 'បើបើក នៅពេលផ្ទាំងតូចត្រូវតាមតម្លៃខាងក្រោម ស្លាកនឹងបង្វិល',
      fixedHori: 'ជ្រើសគែមផ្តេកនៃស្លាកស្របនឹងគែមថេរនៃផ្ទាំងតូច',
      fixedHoriTip: 'មានប្រសិទ្ធភាពសម្រាប់តែផ្ទាំងតូចគ្មានវណ្ឌៈ។ បើបើក ពេលស្លាក ស្លាកនឹងបង្វិលឱ្យគែមផ្តេកស្របគែមថេរនៃផ្ទាំងតូច',
      tagHori: 'គែមផ្តេកនៃស្លាក',
      effectiveTarget: 'គោលដៅនៃប្រសិទ្ធភាព',
      allPlank: 'ផ្ទាំងតូចទាំងអស់',
      notcarePlank: 'តែផ្ទាំងគ្មានវណ្ឌៈ'
      },
    drillSettings: {
      title: 'ការកំណត់ម៉ាស៊ីនដោតជួរ',
      enable: 'បើកកញ្ចប់ដោតជួរ',
      toolTable: {
        use: 'បើក',
        number2: 'លេខដោតជួរស្ថានីយ៍ ២',
        number: 'លេខម៉ាស៊ីនដោតជួរ',
        diameter: 'អង្កត់ផ្ចិតគ្រាប់ដោត',
        xOffset: 'ការផ្លាស់ទី X',
        yOffset: 'ការផ្លាស់ទី Y',
        moveZF: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស Z',
        feedRate: 'ល្បឿនដំណើរការអ័ក្ស Z',
        moveF: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស XY',
        benchmarkDrill: 'ដោតយោង',
        addKnife: 'បន្ថែមឧបករណ៍កាត់',
        deleteKnife: 'លុបឧបករណ៍កាត់'
        },
      prefix: 'បុព្វបទដោតជួរ',
      suffix: 'បច្ច័យដោតជួរ',
      startCode: 'កូដចាប់ផ្តើមដោតជួរ',
      endCode: 'កូដបញ្ចប់ដោតជួរ',
      combineKnife: 'ការកាត់ដោតជួររួមបញ្ចូល',
      combineTable: {
        prefix: 'បុព្វបទលេខដោតជួរ',
        suffix: 'បច្ច័យលេខដោតជួរ',
        mainHole: 'រន្ធមេ',
        extraHole: 'រន្ធបន្ថែម',
        notes: 'កំណត់ចំណាំរួម',
        firstUseNotes: 'កំណត់ចំណាំប្រើលើកដំបូង',
        addExtraHole: 'បន្ថែមរន្ធបន្ថែម',
        deleteExtraHole: 'លុបរន្ធបន្ថែម',
        example: 'ឧទាហរណ៍'
        },
      tagPool: {
        drillRowNumber: 'លេខជួរដោត'
        },
      processSetting: {
        title: 'ការកំណត់ដំណើរការ',
        mode: 'ម៉ូដដំណើរការដោតជួរ',
        processTip: 'មុខងារកាត់ដោតជួររួមមិនមានប្រសិទ្ធភាពនៅពេលជ្រើសម៉ូដនេះ',
        recentHole: 'ដោតរន្ធក្បែរ (ប្តូរឧបករណ៍រហ័ស)',
        groupHole: 'ដោតតាមប្រភេទ (ប្តូរឧបករណ៍បន្ទាប់ពីបញ្ចប់មួយប្រភេទ)',
        drill_benchmark: 'យោងការកាត់រួមបញ្ចូល',
        drill_benchmark_Tip: '(សម្គាល់៖ បន្ទាប់ពីជ្រើសវិធីនេះ មុខងារកាត់ដោតជួររួមមិនមានប្រសិទ្ធភាពទេ)',
        mainHole: 'រន្ធមេ',
        secondaryHole: 'រន្ធបន្ថែម (រន្ធកន្ទុយ)'
        },
      changeBenchDrillTip: 'សូមបញ្ចូលលេខម៉ាស៊ីនដោតជួរមុនពេលធ្វើការជ្រើសនេះ'
      },
    NCExportSettings: {
      jumpSkipTip2: 'ចាត់ថតផ្សេងៗតាមពណ៌ កម្រាស់ និងសម្ភារៈផ្ទាំងធំ (រួមឯកសារស្លាក) ហើយដាក់ឯកសារកាត់ផ្ទាំងធំទំហំដូចគ្នានៅក្នុងថតដូចគ្នា',
      title: 'ការកំណត់នាំចេញ NC',
      tab1: 'ការកំណត់ឈ្មោះឯកសារម៉ាស៊ីនកាត់',
      tab2: 'ការរួមឈ្មោះឯកសារម៉ាស៊ីនកាត់',
      tab3: 'កំណត់ចំណាំក្នុងឯកសារម៉ាស៊ីនកាត់',
      tab4: 'ប្រភេទក្នុងឯកសារម៉ាស៊ីនកាត់',
      tab5: 'ថតឯកសារម៉ាស៊ីនកាត់',
      tab6: 'ការកំណត់ពាក្យបញ្ជាដំណើរការ',
      tab7: 'ការកំណត់ទ្រង់ទ្រាយឯកសារ',
      fileNameSettings: {
        twoStationAutoSort: 'ការតម្រៀបស្វ័យប្រវត្តិសម្រាប់ពីរស្ថានីយ៍',
        reparation: 'ការសងសឹងចំនួនខ្ទង់លេខស៊េរីផ្ទាំងដល់',
        figure: 'ខ្ទង់',
        labelerBegin: 'បុព្វបទម៉ាស៊ីនស្លាក',
        machineCenter: 'បុព្វបទមជ្ឈមណ្ឌលដំណើរការ',
        front: 'ខាងមុខ៖',
        back: 'ខាងក្រោយ៖',
        customizeName: 'ឈ្មោះឯកសារផ្ទាល់ខ្លួន (ទ្រង់ទ្រាយ)៖',
        example: 'ឈ្មោះឯកសារផ្ទាល់ខ្លួន (ឧទាហរណ៍)៖',
        emptyTip: 'សម្គាល់ឯកសារខាងមុខ និងខាងក្រោមមិនអាចទទេពេលតែមួយ',
        labelPool: 'អាងស្លាកទិន្នន័យ',
        dragTip: 'អូសឬចុចចម្លងស្លាកពីអាងស្លាកទៅប្រអប់បញ្ចូល'
        },
      fileMerge: {
        engravingMerge: 'រួមឯកសារម៉ាស៊ីនកាត់',
        zfMerge: 'រួមខាងមុខ និងខាងក្រោម',
        singleMerge: 'រួមស្ថានីយ៍តែមួយ',
        doubleMerge: 'រួមស្ថានីយ៍ពីរ',
        fEndCode: 'កូដបញ្ចប់ខាងក្រោម',
        zBeginCode: 'កូដចាប់ផ្តើមខាងមុខ',
        displayfbInfo: 'បង្ហាញព័ត៌មានខាងមុខ និងខាងក្រោមនៅក្នុងឈ្មោះឯកសារ',
        fBeginCode: 'កូដចាប់ផ្តើមខាងក្រោម',
        zEndCode: 'កូដបញ្ចប់ខាងមុខ'
        },
      marginalNotes: {
        addPlankInfo: 'បន្ថែមព័ត៌មានផ្ទាំងធំបច្ចុប្បន្ននៅដើមឯកសារកាត់៖',
        plankInfo: 'ព័ត៌មានផ្ទាំង៖',
        addStationCodeFirst: 'បន្ថែមកូដស្ថានីយ៍នៅដើមឯកសារកាត់៖',
        addStationCodeSecond: 'បន្ថែមកូដស្ថានីយ៍មុនប្តូរឧបករណ៍ក្នុងឯកសារកាត់៖'
        },
      fileType: {
        zAddtion: 'ការបន្ថែមអ័ក្ស Z៖',
        addSemicolon: 'បន្ថែមសញ្ញាចុចក្បៀសនៅចុងបន្ទាត់ NC នីមួយៗ៖',
        semicolonTip: 'បើធីក ក៏មានប្រសិទ្ធភាពសម្រាប់ឯកសារដំណើរការដៃចង្កឹះរណ្តៅ',
        fileName: 'ឈ្មោះឯកសារ',
        defaultName: 'ឈ្មោះឯកសារលំនាំដើម',
        dedicatedName: 'ឈ្មោះឯកសារសម្រាប់ឧបករណ៍ Xinghui',
        xhNotes: 'កំណត់ចំណាំ Xinghui E2-9',
        format: 'ទ្រង់ទ្រាយឯកសារទិន្នផលម៉ាស៊ីនចុកចាក់',
        example: 'ឧទាហរណ៍ឯកសារ៖ ឯកសារ NC',
        stillGenerate: 'បង្កើតឯកសារ NC ខាងក្រោមដែលមានកូដបញ្ចប់ខាងក្រោម ទោះបីខាងក្រោមមិនដំណើរការ',
        generateTip: 'មុខងារនេះមិនគាំទ្ររួមជាមួយការរួមឯកសារ',
        fileNameErrTip: 'ឈ្មោះឯកសារមិនអាចមានតួអក្សរណាមួយនេះ៖ / : * ? "'
        },
      categorize: 'ចាត់ថតផ្សេងៗតាមពណ៌ សម្ភារៈ និងកម្រាស់ផ្ទាំង (រួមឯកសារស្លាក)៖',
      simplifyG: 'សរសេរខ្លីពាក្យបញ្ជា G',
      ZToW: 'ប្តូរកូដពីអ័ក្ស Z ទៅអ័ក្ស W',
      knives: 'ឧបករណ៍ដោតជួរ',
      lineBreakSetting: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី',
      codeFormatSetting: 'ការកំណត់ទ្រង់ទ្រាយកូដឯកសារ',
      utf8bom: 'UTF-8 ជាមួយ BOM',
      oneCodeSetting: 'ការកំណត់បាកូដផ្ទាំង',
      simplifyOneCode: 'បង្កើតបាកូដស្លាកទ្រង់ទ្រាយសាមញ្ញ',
      codeLocation: 'ការកំណត់ទីតាំងកូដ',
      generateLocation: 'បង្កើតកូដបញ្ចប់ស្ថានីយ៍មុនកូដបញ្ចប់ខាងក្រោម',
      emergencySetting: 'ការកំណត់សង្គ្រោះ',
      show: 'បង្ហាញការកំណត់សង្គ្រោះ',
      emergencyCode: 'កូដសង្គ្រោះ',
      params: 'ប៉ារ៉ាម៉ែត្រ',
      emergencyTip: 'អាចអនុវត្តមុខងារពិសេសខ្លះជាបណ្តោះអាសន្នជាមួយការសហការពីបុគ្គលិកបន្ទាប់ពីលក់',
      holeSetting: 'ការកំណត់ឯកសារដោតរន្ធ',
      holeFileCategorize: 'ដាក់ឯកសារដោតតាមការបញ្ជាទិញផ្សេងៗនៅថតដាច់ដោយឡែក',
      holeTip: 'មិនមានប្រសិទ្ធភាពលើការចងក្រងក្នុងពពកសម្រាប់កម្មវិធីខ្ចប់ទូរស័ព្ទ',
      specialCodeErr: 'មិនគាំទ្រការវាយបញ្ចូលតួអក្សរពិសេស!',
      copySuccess: 'ចម្លងជោគជ័យ!',
      copyErr: 'ចម្លងបរាជ័យ សាកល្បងអូសស្លាក!',
      lengthLimit: 'គាំទ្រតែការវាយបញ្ចូល ១៥ តួ!',
      plankInfo: 'ព័ត៌មានផ្ទាំង',
      otherInfo: 'ព័ត៌មានផ្សេងៗ',
      uniqueBarCode: 'បាកូដមួយគត់សម្រាប់ផ្ទាំង',
      uniqueBarCodeForPack: 'បាកូដមួយគត់សម្រាប់ផ្ទាំង (សម្រាប់តែការខ្ចប់)',
      machineOrder: 'បង្កើតលេខលំដាប់ដំណើរការពីឈ្មោះឯកសារកាត់',
      folderSetting: 'ដាក់ឯកសារកាត់ផ្ទាំងធំទំហំដូចគ្នានៅថតដូចគ្នា',
      labelImageINCFolder: 'ដាក់រូបភាពស្លាកជាមួយឯកសារស្លាកនៅថត NC',
      custom: 'ការកំណត់ផ្ទាល់ខ្លួន',
      folderSettingTip: 'សម្គាល់៖ ការចងក្រងខ្ចប់មិនទាន់គាំទ្រមុខងារនេះទេ',
      settingMoveTip: 'មុខងារ "{func}" ដើមត្រូវបានផ្លាស់ទីទៅទំព័រ "{module}"!',
      fileManagerFunction: 'ដាក់ឯកសារដោតតាមឯកសារបញ្ជាទិញផ្សេងៗនៅថតដាច់ដោយឡែក',
      gotoSetting: 'ទៅកាន់ការកំណត់',
      singleFileTitle: 'ការកំណត់ដំណើរការឯកសារតែមួយ',
      slectSingleProcess: 'ជ្រើសរើសដំណើរការនាំចេញតែមួយ',
      slectSingleProcessTip: 'នៅតែមានដំណើរការកែច្នៃបន្ទាប់បង់ប្រាក់ សូមលុបហើយរក្សាទុកម្តងទៀត',
      setSingleRegularSize: 'កំណត់ទំហំរន្ធ/រនាំងធម្មតាសម្រាប់នាំចេញតែមួយ',
      holeRange: 'ជួរមានប្រសិទ្ធភាពនៃរន្ធ',
      slotRange: 'ជួរមានប្រសិទ្ធភាពនៃរនាំង',
      holeRangeTip: 'ជួរមានប្រសិទ្ធភាពនៃរន្ធមិនអាចទទេបានទេ សូមបំពេញ!',
      slotRangeTip: 'ជួរមានប្រសិទ្ធភាពនៃរនាំងមិនអាចទទេបានទេ សូមបំពេញ!',
      yhzc: 'រនាំងត្រង់នៅផ្នែកពត់រាងធ្នូ',
      xbgy: 'មុំ Haitang ទ្រេត និងដៃចង្កឹះទ្រេត',
      nbyx: 'រាងមិនប្រក្រតីខាងក្នុង',
      secondaryProcessingMerge: 'បញ្ចូលឯកសារដំណើរការបន្ទាប់',
      secondaryProcessingMergeName: 'ឈ្មោះឯកសារបញ្ចូល',
      secondaryProcessingMergeTip: 'នៅពេលបើក ប្រសិនបើផ្ទាំងនាំចេញមានដំណើរការបន្ទាប់ច្រើន នឹងត្រូវបញ្ចូលទៅក្នុងឯកសារដំណើរការតែមួយ',
      singleFileSetting: 'ទិន្នផលដំណើរការឯកសារតែមួយសម្រាប់គែមទ្រេត មុំបេកូនៀ និងដៃចង្កឹះទ្រេត',
      straightArcSlot: 'ទិន្នផលដំណើរការឯកសារតែមួយសម្រាប់រណ្តៅផ្ទាត់នៅផ្នែកបត់រង្វង់'
      },
    aioMachineSetting: {
      openFunction: 'ត្រូវបើកមុខងារខាងក្រោមសម្រាប់ការភ្ជាប់',
      openCarving: 'បើកម៉ាស៊ីនចុកចាក់',
      xyReverseFunction: 'មុខងារប្តូរអ័ក្ស XY',
      carvingStartSet: 'កំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ម៉ាស៊ីនចុកចាក់ទៅជា៖',
      rightTop: 'ខាងលើស្តាំ',
      carvingEdgeSet: 'កែតម្រូវតម្លៃកែសម្រួលគែមខាងមុខម៉ាស៊ីនចុកចាក់ទៅជា៖',
      finalEdgeSame: 'ដូចគ្នានឹងតម្លៃកែសម្រួលគែមសរុប',
      beginCode: 'កូដចាប់ផ្តើមកម្មវិធី',
      endCode: 'កូដបញ្ចប់កម្មវិធី',
      drillHole: 'ដោតរន្ធ',
      pullTrough: 'រណ្តៅទាញ',
      showDataTemp: 'បង្ហាញគំរូទិន្នន័យ',
      dataTemp: 'គំរូទិន្នន័យ',
      title: 'ការកំណត់ម៉ាស៊ីនរួមមួយ',
      outputFile: 'នាំចេញឯកសារដំណើរការម៉ាស៊ីនរួមមួយ',
      outputFileTips: 'ម៉ាស៊ីនរួមមួយមួយចំនួនមិនសមស្របជាមួយប្តូរ XY រួមឯកសារ និងមិនដោតរន្ធមិនធម្មតា សូមប្រើប្រយ័ត្ន',
      fileType: 'ទ្រង់ទ្រាយឯកសារ',
      select: 'សូមជ្រើស',
      diameter: 'អង្កត់ផ្ចិតឧបករណ៍កែសម្រួលគែម',
      jidongTip: 'បើប្រើម៉ាស៊ីនរួម Jidong សូមកំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ចុកចាក់ទៅជ្រុងខាងលើស្តាំ និងបើកមុខងារ A',
      skill: 'មុខងារ',
      clampHandLength: 'ប្រវែងដៃច្របាច់(L)',
      clampHandWidth: 'ទទឹងដៃច្របាច់(W)',
      clampHandMargin1: 'ចម្ងាយដៃច្របាច់១ពីគែម(H1)',
      clampHandMargin2: 'ចម្ងាយដៃច្របាច់២ពីគែម(H2)',
      duchClampHand: 'រណ្តៅរួចផុតទីតាំងដៃច្របាច់',
      clampHandDirection: 'ទិសដៅដៃច្របាច់',
      left: 'ឆ្វេង',
      right: 'ស្តាំ',
      top: 'លើ',
      bottom: 'ក្រោម'
      },
    oneDragTwo: {
      title: 'ម៉ាស៊ីនចុកចាក់មួយទាញពីរ',
      outputMachineFile: 'នាំចេញឯកសារដំណើរការម៉ាស៊ីនចុកចាក់មួយទាញពីរ',
      outputMachineFileTips: 'បន្ទាប់ពីបើកម៉ាស៊ីនចុកចាក់មួយទាញពីរ មិនសមស្របជាមួយការរួមឯកសារម៉ាស៊ីនកាត់ សូមប្រើប្រយ័ត្ន',
      fileType: 'ទ្រង់ទ្រាយឯកសារ',
      select: 'សូមជ្រើស',
      machineStart: 'ចំណុចចាប់ផ្តើមស្ថានីយ៍',
      positionClose: 'បិទពេលតាមការកំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ក្នុងប៉ារ៉ាម៉ែត្រកាត់',
      engravingPlus: 'ម៉ាស៊ីនចុកចាក់លឿន'
      },
    sawEngraving: {
      title: 'ម៉ាស៊ីនកាត់ និងចុកចាក់',
      preLayNav: 'ការកំណត់ម៉ាស៊ីនកាត់ និងចុកចាក់',
      preLayKnifeInput: 'អង្កត់ផ្ចិតកាត់ឆ្លាស់នៃកាំបិទរណ្តៅ',
      enableSaw: 'បើកម៉ាស៊ីនកាត់ និងចុកចាក់',
      sawAioTip: 'គ្មានសិទ្ធិនាំចេញម៉ាស៊ីន AIO ផ្ទាំងផ្សារ សូមទាក់ទងផ្នែកលក់ដើម្បីបើកប្រើ',
      cutSet: 'ការកំណត់កាត់ផ្ទាំងផ្សារ',
      weldingPlank: 'ផ្ទាំងផ្សារ',
      doorFrame: 'ផ្ទាំងផ្សារ',
      doorFrameTip1: 'ការប្រើកាᆔនជាតិរណ្តៅ',
      doorFrameTip2: '2.ការប្រើកាំបិទរណ្តៅ 3.ការប្រើកាំបិទរណ្តៅ',
      sawUsing: 'ការប្រើកាំបិទរណ្តៅ',
      trim: 'ការកែសម្រួលគែម',
      cutBlank: 'ការកាត់ និងដក',
      backTrimOblique: 'ការកែសម្រួលគែមខាងក្រោយ',
      holeSlotOblique: 'ការកែសម្រួលគែមខាងក្រោយ',
      plankThicknessUnit: 'ការផ្គូរផ្គងការបន្ថែម',
      sawUseCond: 'លក្ខខណ្ឌប្រើកាំបិទរណ្តៅ',
      exportPartData: 'នាំចេញឯកសារទិន្នន័យផ្ទាំងតូច (ban, mpr, xml ជាដើម)',
      sawAioTip2: 'សមស្របសម្រាប់ម៉ាស៊ីនរួមកាត់រណ្តៅដោយមិនបត់',
      hasUsing: 'ប្រើប្រសិនបើមានផ្លូវ',
      onlyUse: 'ប្រើតែនៅពេលចាំបាច់',
      cutMethod: 'វិធីសាស្ត្រកាត់',
      oneKnifePull: 'កាត់ផ្ទាំងធំឆ្លាស់ក្នុងការកាត់តែមួយ',
      onlyOneKnifePull: 'ទើបកាត់ឆ្លាស់ផ្ទាល់ជាមួយការកាត់តែមួយ',
      enableSawThick: 'បើកការចងក្រងតាមកម្រាស់កាំបិទរណ្តៅ',
      edgedDir: 'គែមផ្ទាំងធំដែលបានបិញ និងមិនកាត់ទៀត',
      sameWidthPart: 'នៅលើផ្ទាំងធំនីមួយៗដាក់តែផ្ទាំងតូចទទឹងដូចគ្នា',
      emptyPath: 'កំឡុងពេលកាត់កុំបង្កើតផ្លូវដើរទទេ',
      sawUsePlank: 'ផ្ទាំងផ្សារដំណើរការដោយកាំបិទរណ្តៅតែប៉ុណ្ណោះ',
      paibanGap: 'គម្លាតចងក្រងផ្ទាំងផ្សារ',
      minSurplusWidthDiff: 'ភាពខុសគ្នានៃទទឹងផ្គូផ្គងសំណល់អប្បបរមា',
      minSurplusWidthDiffTip: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
      sawReplaceEnable: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
      minSawLength: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
      keepDistance: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
      keepDistanceTip: 'មានការពិន្ទុចំពោះការបកប្រែបន្ទាប់មកការបកប្រែបន្ទាប់មកការបកប្រែ',
      sortByLength: 'តម្រៀបតាមប្រវែងផ្ទាំង',
      sortByLengthTip: 'ទិសកាត់ពីក្រោមឡើងលើ ចងក្រងទទឹងមុន បន្ទាប់មកប្រវែង',
      plankAtTop: 'ផ្ទាំងតូចនៅលើ',
      plankAtBottom: 'ផ្ទាំងតូចនៅក្រោម',
      useSawTipOne: 'បើបើក តែផ្ទាំងតូចដែលមានលក្ខណៈផ្ទាំងផ្សារក្នុងទូទើបប្រើកាំបិទរណ្តៅ ផ្ទាំងមិនផ្សារកាត់ដោយដាវផ្ទាត់',
      useSawTipTwo: 'បើប្រើលំដាប់ផ្ទាំងធំផ្ទាល់ខ្លួន ផ្ទាំងផ្សារមិនចងក្រងជាមួយផ្ទាំងធំស្តង់ដារ; ចងលាយ សូមបន្ថែមទិន្នន័យផ្ទាំងផ្សារ និងផ្ទាំងឃ្លុបនៅផ្ទាំងធំពិសេស',
      useSaiTipThree: 'បន្ទាប់ពីបើកមុខងារនេះ ដំណោះស្រាយចងក្រងត្រូវប្រើការចងក្រងកាត់រណ្តៅ',
      surplusStoreAndLabeling: 'សំណល់បន្ទាប់ពីកាត់អាចចូលឃ្លាំង និងបោះពុម្ពស្លាក',
      surplusMinLength: 'ប្រវែងប្រើបានអប្បបរមានៃសំណល់',
      surplusMinSize: 'កម្រិតប្រើបានអប្បបរមានៃសំណល់',
      crossCutOnlyMinSurplusSize: 'តាមពិតនឹងបង្កើតផ្លូវកាត់ឆ្លងតែបើសំណល់មានទំហំអប្បបរមាដែលអាចប្រើបានត្រូវបំពេញ',
      surplusStoreAndLabelingTip: '១. តំបន់សំណល់ពណ៌ខៀវបង្កើតនៅលើឬក្រោមផ្ទាំងធំ អាចចូលឃ្លាំង និងបោះពុម្ពស្លាកបានធម្មតា',
      surplusStoreAndLabelingTip2: '២. មុខងារកាត់សំណល់ស្វ័យប្រវត្តិមិនអនុវត្តសម្រាប់ផ្ទាំងផ្សារ',
      surplusStoreAndLabelingTip3: '（បន្ទាប់ពីបើកដំណើរការ',
      backCutSurplus: 'កាត់សំណល់ពីខាងក្រោម',
      cutSurplusTip: 'បន្ទាប់ពីបើក កំណត់លំដាប់កែសម្រួលគែមខាងក្រោមជា «កែសម្រួលបន្ទាប់ពីដំណើរការរណ្តៅខាងក្រោម»',
      top: 'លើ',
      bottom: 'ក្រោម',
      left: 'ឆ្វេង',
      right: 'ស្តាំ',
      dockTip: 'ដំណើរការផ្ទាំងផ្សារបត់ទាមទារការបិទបួនគែមផ្ទាំងចតុកោណ និងស្រដៀងការកែសម្រួលគែមសរុប និងចងក្រងជាជួរតែមួយដោយដៃ',
      sawToLayoutTip: 'បើបើកមុខងារនេះ រវាងផ្ទាំងតូចក្នុងចងក្រងមានតែគម្លាតកាត់ស្មើកម្រាស់កាំបិទរណ្តៅ',
      sawToLayoutTip2: 'ការចងក្រងកាត់រណ្តៅមិនទាន់គាំទ្រកាំបិទដកដែលបានកំណត់',
      tempPaiabanTip: 'បន្ទាប់ពីបើកការកាត់រណ្តៅ មិនអាចបន្ថែមផ្ទាំងរាងពិសេសដោយផ្ទាល់ក្នុងចងក្រង; បន្ថែមនៅបញ្ជីកាត់',
      generateCutSurplusPath: 'បង្កើតផ្លូវកាត់ឆ្លាស់កាត់សំណល់មុន',
      curSurplusPathTip: 'បន្ទាប់ពីបើក កំណត់លំដាប់កែសម្រួលខាងក្រោមជា «កែបន្ទាប់ពីដំណើរការរន្ធ/រណ្តៅខាងក្រោម»'
      },
    robotArmDocking: {
      autoLine: 'ការភ្ជាប់ផ្លូវចលនា',
      autoLineTip: 'មានការអនុញ្ញាតិចូលរួមផ្លូវចលនា ឬ ចំនួនផ្លូវចលនាដែលអ្នកអាចបើកបានគឺមិនកើតឡើងទេ',
      title: 'ការភ្ជាប់ដៃរបស់រូបយន្ត',
      enable: 'បើកការភ្ជាប់ដៃរបស់រូបយន្ត',
      enableTip: 'បើបើក ពេលនាំចេញឯកសារផលិតកម្ម ឯកសារភ្ជាប់ដៃរបស់រូបយន្តក៏ត្រូវបាននាំចេញ'
      },
    laserCuttingMachine: {
      title: 'ម៉ាស៊ីនកាត់ឡាស៊ែររួមមួយ',
      enable: 'បើកម៉ាស៊ីនកាត់ឡាស៊ែររួមមួយ',
      backSafeHeight: 'កម្ពស់ Z នៅពេលខាងក្រោមទំនេរ (H)',
      laserDistance: 'ចម្ងាយពីដាវឡាស៊ែរទៅផ្ទៃផ្ទាំងពេលកាត់ខាងមុខ/ក្រោម',
      coordinateAxis: 'អ័ក្សកូអរដោនេ',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'ការកំណត់កាត់',
      backKnifeStore: 'ឃ្លាំងដាវខាងក្រោម',
      noSupportOriginalMaterialKnife: 'មិនទាន់គាំទ្រការជ្រើសដាវកាត់សម្ភារៈដើម',
      laserKnifeTip: 'កាត់បើក៖ សម្រាប់រាងពិសេសខាងក្នុងដែលមិនទាន់ដោតទិស',
      laserKnifeTip2: 'ដាវឡាស៊ែរ៖ រន្ធដោត/រណ្តៅ រាងខាងក្នុង កាត់គែមខាងក្រៅ',
      laserKnifeTip3: 'សម្គាល់៖ អ័ក្ស Z ខាងក្រោមលំនាំដើមប្រើកូអរដោនេធៀបនឹងចម្ងាយទៅផ្ទៃតុ',
      laserKnifeTip4: 'ចំនួនដាវមិនអាចតិជាង ១',
      laserKnifeTip5: 'មិនអាចលុបដាវកាត់បើក',
      laserKnifeTip6: 'មិនមានដាវជ្រើសសម្រាប់កាត់បើក សូមជ្រើសយ៉ាងហោចណាស់មួយ',
      laserKnifeTip7: 'ដាវឡាស៊ែរមិនអាចដំណើរការរាងពិសេសខាងក្នុងដែលមិនទាន់កាត់ឆ្លង ការជ្រើស «កាត់បើក» ត្រូវបានដកដោយស្វ័យប្រវត្តិ',
      laserKnifeTip8: 'នៅឃ្លាំងដាវ សូមជ្រើសដាវដែលមានជម្រើស «កាត់បើក» បើមិនដូចនោះមិនអាចដំណើរការរាងខាងក្នុងដែលមិនទាន់កាត់ឆ្លង',
      laserKnifeTip9: 'អង្កត់ផ្ចិតដាវឡាស៊ែរនៅឃ្លាំងកាត់បើក និងម៉ាស៊ីនឡាស៊ែររួមមួយមិនដូចគ្នា សូមពិនិត្យ',
      laserKnifeTip10: 'អង្កត់ផ្ចិតដាវដកនៅឃ្លាំងកាត់បើក និងម៉ាស៊ីនឡាស៊ែររួមមួយមិនដូចគ្នា សូមពិនិត្យ',
      laserKnifeTip11: 'ប៉ារ៉ាម៉ែត្រភ្ជាប់ឧបករណ៍ត្រូវបានកែ សូមចងក្រងឡើងវិញ',
      noLaserPermission: 'គ្មានសិទ្ធិប្រើម៉ាស៊ីនឡាស៊ែររួមមួយ សូមទាក់ទងលក់ដើម្បីទិញសិទ្ធិ',
      laserOpenCode: 'កូដបើកឡាស៊ែរ',
      laserCloseCode: 'កូដបិទឡាស៊ែរ',
      laserToolSettings: 'ការកំណត់ដាវឡាស៊ែរខាងមុខ/ក្រោម'
      },
    firstSave: 'រកឃើញថានេះជាលើកដំបូងដែលប្រើចងក្រងក្នុងពពក ក្រោយរក្សាទុកសូមពិនិត្យទិសកែសម្រួលគែមក្នុងឯកសារឱ្យសមស្រប',
    knives: {
      xOffset1: 'ការផ្លាស់ទីកូអរដោនេ X',
      yOffset1: 'ការផ្លាស់ទីកូអរដោនេ Y',
      zOffset1: 'ការផ្លាស់ទីកូអរដោនេ Z',
      insert: 'បន្ថែមជួរ',
      delete: 'លុបជួរ',
      tip: '(សម្គាល់៖ បន្ទាប់ពីកែព័ត៌មានឃ្លាំងដាវ ឬការកំណត់ អ្នកប្រើដែលផលិតចងក្រងទូត្រូវចាប់ផ្តើមកម្មវិធីទូឡើងវិញដើម្បីអនុវត្តការផ្លាស់ប្តូរ)',
      number: 'លេខ',
      name: 'ឈ្មោះ',
      diameter: 'អង្កត់ផ្ចិតដាវ Φ',
      sawDiameter: 'កម្រាស់កាំបិទរណ្តៅ Φ',
      cutting: 'ការកាត់សម្ភារៈ',
      use: 'គោលបំណង',
      moveZF: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស Z',
      axis_offset: 'ការផ្លាស់ទីអ័ក្ស',
      arc_radius: 'ការកំណត់កាំរង្វង់',
      cutZF: 'ល្បឿនដំណើរការអ័ក្ស Z',
      moveF: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស XY',
      cutF: 'ល្បឿនដំណើរការអ័ក្ស XY',
      startCode: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់',
      stopCode: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់',
      startCode2: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់ ស្ថានីយ៍ ២',
      stopCode2: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់ ស្ថានីយ៍ ២',
      knifeLength: 'ប្រវែងដាវ',
      maximum_single_depth: 'ជម្រៅដំណើរការអតិបរមាក្នុងមួយលើក',
      specialShapeKnifeTip: 'មានប្រសិទ្ធភាពតែសម្រាប់រូបរាងមិនទៀងខាងក្នុង',
      preStartCode: 'កូដចាប់ផ្តើមមុន',
      punchHoles: 'រន្ធដោត',
      pullSlots: 'ទាញរណ្តៅ',
      millHoles: 'រន្ធហ្វ្រីស',
      millSlots: 'រណ្តៅហ្វ្រីស',
      sawBlade: 'កាំបិទរណ្តៅ',
      doubleSaw: 'បើកកូដចាប់ផ្តើមដូរឧបករណ៍ខុសគ្នាសម្រាប់ស្ថានីយ៍ពីរ',
      singleStation: 'ស្ថានីយ៍តែមួយ',
      doubleStation: 'ស្ថានីយ៍ពីរ',
      sawBladeTip: 'មុខងារនេះមិនអនុវត្តសម្រាប់ម៉ាស៊ីនចុកចាក់ប៉េរេពីរ និងម៉ាស៊ីនរួមមួយ',
      serialNum: 'លេខសម្គាល់',
      sawWidth: 'ទទឹងដាវ',
      sawType: 'ប្រភេទកាំបិទរណ្តៅ',
      cutDirection: 'ទិសកាត់',
      moveSpeed: 'ល្បឿនគ្មានការកាត់',
      cutSpeed: 'ល្បឿនដំណើរការ',
      endCode: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់',
      sawDownCode: 'កូដចុះដាវ',
      sawUpCode: 'កូដដកដាវ',
      abscissa: 'បុព្វបទអាប់ស៊ីស',
      ordinate: 'បុព្វបទកូអរដោនេបញ្ឈរ',
      sawHor: 'កាំបិទរណ្តៅកាត់ឆ្លាស់',
      sawVer: 'កាំបិទរណ្តៅកាត់បញ្ឈរ',
      towardsZero: 'កាត់ទៅរកកូអរដោនេចំណុច ០',
      awayFromZero: 'កាត់ឱ្យឆ្ងាយពីកូអរដោនេ ០',
      diameterDesc: 'អង្កត់ផ្ចិតដាវ Φ',
      xOffset: 'ការផ្លាស់ទីកូអរដោនេផ្ដេក',
      yOffset: 'ការផ្លាស់ទីកូអរដោនេបញ្ឈរ',
      zOffset: 'ការផ្លាស់ទីកូអរដោនេឡើងចុះ',
      offsetX: 'ផ្លាស់ទី X',
      offsetY: 'ផ្លាស់ទី Y',
      offsetZ: 'ផ្លាស់ទី Z',
      offsetNo: 'លេខផ្លាស់ទី',
      knifeWidth: 'ទទឹងដាវ',
      drill: 'ចុះដាវ',
      cut: 'ដំណើរការ',
      speed: 'ល្បឿនវិល',
      type: 'ប្រភេទ',
      millHoleSlot: 'រន្ធ/រណ្តៅហ្វ្រីស',
      rapidFeedSpeed: 'ល្បឿនមុខទៅលឿន',
      typeOption1: 'ក្បួនដោត',
      typeOption2: 'ដាវហ្វ្រីស',
      typeOption3: 'ដាវបង់រូប',
      typeTip: 'បន្ទាប់ពីកំណត់ប្រភេទឧបករណ៍ រន្ធនិងរណ្តៅត្រូវដំណើរការដោយឧបករណ៍ត្រូវប្រភេទ'
      },
    other: {
      title: 'ផ្សេងៗ',
      tip: '(សម្គាល់៖ ឧបករណ៍ស្ថានីយ៍តែមួយត្រូវបញ្ចូលកូដបំពេញស្វ័យប្រវត្តិដូចគ្នាសម្រាប់ស្ថានីយ៍ ១ និង ២)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'ការកំណត់បន្ថែម',
    sideStartCode: 'ដំណើរការខាងមុខបង្កើតកូដប្តូរមុខ',
    useArcCode: 'កាត់រង្វង់ដោយបញ្ជារមស់រង្វង់',
    coordSwitch: 'ប្តូរយោងកូអរដោនេ',
    updownCoordSwitch: 'ប្តូរយោងកូអរដោនេឡើងចុះ',
    xCoordSwitch: 'ប្តូរយោងកូអរដោនេផ្ដេក',
    yCoordSwitch: 'ប្តូរយោងកូអរដោនេបញ្ឈរ',
    knifes: {
      number: 'លេខ',
      diameter: 'ទទឹងដាវ',
      type: 'ប្រភេទ',
      moveSpeed: 'ល្បឿនមុខទៅលឿន',
      doSpeed: 'ល្បឿនដំណើរការ',
      startCode: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់',
      endCode: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់'
      },
    ymSetting: 'ការកំណត់តភ្ជាប់ Yimu',
    flanking: 'ដំណើរការចំហៀង',
    frontProcess: 'ដំណើរការខាងមុខ',
    oldSetting: 'ការកំណត់កំណែចាស់',
    equipParamsSetting: 'ការកំណត់ប៉ារ៉ាម៉ែត្រឧបករណ៍',
    holeSetting: 'ការកំណត់រន្ធ',
    raminoSetting: 'ការកំណត់តភ្ជាប់ Ramino',
    mortiseTenonSetting: 'ការកំណត់តភ្ជាប់ mortise និង tenon',
    straight: 'ប្រភេទត្រង់',
    eccentric: 'ប្រភេទអ៊ិចសង់ត្រិក',
    pbSize: 'ទំហំផ្ទាំងបំបែកលើ និងក្រោម',
    slotOverlapRate: 'អត្រាស្ទូចគ្នានៃរណ្តៅហ្វ្រីស',
    breakingBoardDirection: 'ទិសផ្ទាំងបំបែកលើ និងក្រោម',
    coordinateValue: 'តម្លៃកូអរដោនេ',
    codeFormat: 'ទ្រង់ទ្រាយកូដឯកសារ',
    suffixSetting: 'ការកំណត់បន្ទាប់ឯកសារ',
    insertRow: 'បន្ថែមជួរ',
    deleteRow: 'លុបជួរ',
    equipmentParams: {
      equipPauseCode: 'កូដផ្អាកឧបករណ៍',
      wiggleCode: 'កូដរមួល',
      equipStartCode: 'កូដចាប់ផ្តើមឧបករណ៍៖',
      flipPauseCode: 'កូដផ្អាកពេលបត់មុខ',
      equipEndCode: 'កូដបញ្ចប់ឧបករណ៍៖',
      equipStartCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមឧបករណ៍',
      retractingCode: 'កូដបញ្ជាដកដាវ',
      retractingCodePlaceholder: 'បញ្ចូលកូដបញ្ជាដកដាវ',
      flipPauseCodePlaceholder: 'បញ្ចូលកូដផ្អាកពេលបត់មុខ',
      equipEndCodeTip: 'បញ្ចូលកូដបញ្ចប់ឧបករណ៍',
      sideChangeSetting: 'ការកំណត់ប្តូរមុខចំហៀង',
      workTip: 'លំនាំដើមចាប់ពីឆ្វេង ① ដំណើរការតាមទិសច្រាសនាឡិកា',
      frontTurnCode: 'កូដចាប់ផ្តើមមុខលើ៖',
      frontTurnEndCode: 'កូដបញ្ចប់មុខលើ',
      frontTurnCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមមុខលើ',
      frontTurnEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់មុខលើ',
      leftTurnCode: 'កូដចាប់ផ្តើមមុខឆ្វេង៖',
      leftTurnEndCode: 'កូដបញ្ចប់មុខឆ្វេង៖',
      leftTurnCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមមុខឆ្វេង',
      leftTurnEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់មុខឆ្វេង',
      downTurnCode: 'កូដចាប់ផ្តើមមុខក្រោម៖',
      downTurnEndCode: 'កូដបញ្ចប់មុខក្រោម៖',
      downTurnCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមមុខក្រោម',
      downTurnEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់មុខក្រោម',
      rightTurnCode: 'កូដចាប់ផ្តើមមុខស្តាំ៖',
      rightTurnEndCode: 'កូដបញ្ចប់មុខស្តាំ៖',
      rightTurnCodePlaceholder: 'បញ្ចូលកូដចាប់ផ្តើមមុខស្តាំ',
      rightTurnEndCodePlaceholder: 'បញ្ចូលកូដបញ្ចប់មុខស្តាំ',
      topFlipCode: 'កូដបត់មុខ - លើ',
      downFlipCode: 'កូដបត់មុខ - ក្រោម',
      leftFlipCode: 'កូដបត់មុខ - ឆ្វេង',
      rightFlipCode: 'កូដបត់មុខ - ស្តាំ',
      cylinderOutCode: 'កូដរុញស៊ីលីនដែរចេញ',
      cylinderbackCode: 'កូដដកស៊ីលីនដែរត្រឡប់',
      cylinderbackDirective: 'បញ្ជាដកស៊ីលីនដែរត្រឡប់',
      moveDirective: 'បញ្ជាផ្លាស់ទី',
      moveAxisCode: 'ចលនាអ័ក្ស',
      pushAxisCode: 'អ័ក្សរុញស៊ីលីនដែរ',
      swingAxisCode: 'អ័ក្សរមួល',
      moveCode: 'កូដផ្លាស់ទី',
      punchCode: 'កូដដំណើរការ',
      free: 'ដើរទទេ',
      punchPart: 'ផ្នែកដំណើរការ',
      cutFaceCode: 'កូដប្លង់ដំណើរការ',
      horVerCutFace: 'ប្លង់ផ្ដេក និងបញ្ឈរ',
      horCutFace: 'ប្លង់ផ្ដេក និងឡើងចុះ',
      verCutFace: 'ប្លង់បញ្ឈរ និងឡើងចុះ',
      specifySmallBoardMaterialNoCut: 'សម្ភារៈផ្ទាំងតូចដែលបានកំណត់មិនកាត់',
      specifySmallBoardMaterialNoCutTip: 'ផ្ទាំងដែលមានពាក្យគន្លឹះត្រូវនៅក្នុងសម្ភារៈ បង្កើតតែឯកសាររន្ធ/រណ្តៅដោយដ្រូល ៥/៦ មុខ គ្មានការកាត់',
      addMaterialKeyword: 'បន្ថែមពាក្យគន្លឹះសម្ភារៈ',
      keyword: 'ពាក្យគន្លឹះ'
      },
    tagPool: 'អាងស្លាកទិន្នន័យ',
    dragTip: 'អាចអូសស្លាកក្នុងអាងស្លាក',
    knives: 'ឧបករណ៍ដំណើរការ៖',
    directives: 'បញ្ជាដំណើរការ៖',
    slot: 'ដំណើរការរណ្តៅត្រង់',
    cirWork: 'ដំណើរការរង្វង់',
    cirInter: 'រមស់រង្វង់',
    cirOption1: 'តាមនាឡិកា៖ G03 ច្រាសនាឡិកា៖ G02',
    cirOption2: 'តាមនាឡិកា៖ G02 ច្រាសនាឡិកា៖ G03',
    coordinate: {
      xPointSymbol: 'កូអរដោនេ X៖',
      yPointSymbol: 'កូអរដោនេ Y៖',
      zPointSymbol: 'កូអរដោនេ Z៖',
      upright: 'តម្លៃវិជ្ជមាន',
      negative: 'តម្លៃអវិជ្ជមាន'
      },
    encodeFormat: {
      format: 'ទ្រង់ទ្រាយកូដឯកសារ៖',
      wrap: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី៖',
      formatOption1: 'ទ្រង់ទ្រាយ UTF-8',
      formatOption2: 'ទ្រង់ទ្រាយ ANSI'
      },
    suffix: 'ការកំណត់បន្ទាប់ឯកសារ៖',
    enableFP: 'បើកដំណើរការខាងមុខ',
    slotSetting: 'ការកំណត់ទាញរណ្តៅ',
    slotMillSetting: 'ការកំណត់ទាញរណ្តៅ/រន្ធ និងរណ្តៅហ្វ្រីស',
    millSlot: 'គាំទ្ររន្ធ និងរណ្តៅហ្វ្រីស',
    millingSlotOverlapRate: 'អត្រាស្ទូចគ្នានៃរណ្តៅហ្វ្រីស',
    millingHoleSlotOverlapRate: 'អត្រាស្ទូចគ្នារន្ធ និងរណ្តៅហ្វ្រីស',
    takeUpDirective: 'បញ្ជាដកដាវ',
    workSeparately: 'ដំណើរការរណ្តៅឆ្លងខាងមុខ/ក្រោមជាពីរដំណាក់កាល',
    secondSlotLong: 'ប្រវែងរណ្តៅផ្នែកទីពីរ',
    enableOld: 'បើកការកំណត់ម៉ាស៊ីនរន្ធចំហៀងកំណែចាស់',
    default: 'ការកំណត់លំនាំដើម',
    customizable1: 'ប្ដូរតាមបំណង ១',
    customizable2: 'ប្ដូរតាមបំណង ២',
    customizable3: 'ប្ដូរតាមបំណង ៣',
    customizable4: 'ប្ដូរតាមបំណង ៤',
    knifeSetting: 'ការកំណត់ឧបករណ៍កាត់',
    soltTip: '(រួមទាំងរន្ធ/រណ្តៅហ្វ្រីស)',
    specialSetting: 'ការកំណត់ពិសេស',
    ramino: 'Ramino',
    sun: 'Mortise និង tenon',
    please: 'សូមរង់ចាំ',
    designatedKnives: 'ឧបករណ៍ដែលបានកំណត់',
    designated: 'បានកំណត់',
    workOrder: 'បញ្ជាដំណើរការ',
    other: 'ផ្សេងៗ',
    nameSetting: 'ការកំណត់ឈ្មោះបន្ទាប់',
    repeatErr: 'លេខស្ទួន សូមកំណត់ឡើងវិញ'
    },
  electronicSaw: {
    importMaterial: 'នាំចូលបញ្ជីសម្ភារៈដើម',
    formSetting: 'ការកំណត់ទម្រង់រណ្តៅអេឡិចត្រូនិច',
    fileFormat: 'ទ្រង់ទ្រាយឯកសារបញ្ជីកាត់ចេញ៖',
    isSmallFile: 'នាំចេញឯកសាររូបភាពផ្ទាំងតូច៖',
    fileGroupRule: 'បំបែកឯកសាររណ្តៅអេឡិចត្រូនិចជាតារាងខុសគ្នាតាមពណ៌ សម្ភារៈ និងកម្រាស់ផ្ទាំង៖',
    roomsByCategory: 'បំបែកឯកសាររណ្តៅអេឡិចត្រូនិចជាតារាងខុសគ្នាតាមបន្ទប់៖',
    delimiter: 'តួខ្សែញែក៖',
    fileName: 'ឈ្មោះឯកសារបញ្ជីកាត់៖',
    fineNameTip: 'ឈ្មោះឯកសារបញ្ជីកាត់មិនអាចទទេ!',
    fileNamePlaceholder: 'បញ្ជីកាត់តាមបំណង',
    outputFileEncoding: 'ទ្រង់ទ្រាយកូដបញ្ជីចេញ៖',
    utf8: 'UTF-8 មាន BOM',
    cellTab: 'បង្កើតថេបក្រឡា៖',
    texture: 'ការបង្ហាញវាល៖',
    special: 'ការបង្ហាញរូបរាងពិសេស៖',
    notSpecial: 'មិនមែនរូបរាងពិសេស',
    genSimpleLabelBarcode: 'បង្កើតបារកូដស្លាកទ្រង់ទ្រាយសាមញ្ញ',
    uniqueBarCode: 'បារកូដតែមួយសម្រាប់ផ្ទាំង',
    uniqueBarCodeTip: 'បន្ទាប់ពីបើក មុខងារបង្កើតបារកូដស្លាកទ្រង់ទ្រាយសាមញ្ញមិនដំណើរការ',
    roboticArmDocking: 'ការភ្ជាប់ដៃរបស់រូបយន្ត',
    customeForm: 'ទម្រង់តាមបំណង',
    tagPool: 'អាងស្លាកទិន្នន័យ',
    tagPoolTips: 'អូសឬចុចដើម្បីចម្លងស្លាកពីអាងស្លាក',
    displayHead: 'មិនបង្ហាញក្បាលតារាង',
    addTableHead: 'បន្ថែមក្បាលតារាង',
    deleteTableHead: 'លុបក្បាលតារាង',
    generateExample: 'បង្កើតគំរូទម្រង់ចេញ',
    importExample: 'នាំចូលគំរូទម្រង់',
    importExampleTip: 'គំរូទម្រង់ដែលនាំចូលសម្រាប់យោងតែប៉ុណ្ណោះពេលកំណត់រណ្តៅអេឡិចត្រូនិច',
    importExampleErrTip: 'មិនទាន់នាំចូលបញ្ជីសម្ភារៈដើម សូមនាំចូលមុន',
    outputExample: 'គំរូទម្រង់ចេញ',
    outputExampleTip: 'គំរូចេញនៃទម្រង់តាមបំណង',
    outputExampleErrTip: 'មិនទាន់បង្កើតគំរូទម្រង់ចេញ សូមបង្កើត',
    defaultTableHead: 'ក្បាលតារាងលំនាំដើម',
    deleteHeadErrTip: 'គ្មានក្បាលតារាងដើម្បីលុប!',
    genNonString: 'បង្កើតប្រភេទទិន្នន័យមិនមែនអត្ថបទ',
    genNonStringTip: 'សាកល្បងបើកនៅពេលទិន្នន័យតារាងដែលបានបង្កើតមិនត្រូវបានរណ្តៅអេឡិចត្រូនិចស្គាល់',
    revertWidth: 'ប្តូរប្រវែង និងទទឹងផ្ទាំងក្បាលររង់'
    },
  lockModal: {
    passwordInput: 'បញ្ចូលពាក្យសម្ងាត់',
    lockPassword: 'ពាក្យសម្ងាត់ចាក់សោ',
    lockPasswordInput: 'បញ្ចូលពាក្យសម្ងាត់បើកសោ',
    passwordInputPlaceholder: 'បញ្ចូលពាក្យសម្ងាត់ ៤ ខ្ទង់',
    editPassword: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់',
    confirmPassword: 'បញ្ជាក់ពាក្យសម្ងាត់',
    setLockPwd: 'កំណត់ពាក្យសម្ងាត់បើកសោ',
    pwdFormatErr: 'ទ្រង់ទ្រាយពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
    sendMessageTo: 'កូដផ្ទៀងផ្ទាត់ SMS នឹងត្រូវបានផ្ញើទៅ',
    captchaPlaceholder: 'បញ្ចូលកូដផ្ទៀងផ្ទាត់',
    sendCaptcha: 'ផ្ញើកូដផ្ទៀងផ្ទាត់',
    sendSeccess: 'ផ្ញើ SMS ដោយជោគជ័យ',
    sendFail: 'ផ្ញើ SMS បរាជ័យ សូមព្យាយាមម្តងទៀតក្រោយមក',
    updateSeccess: 'កំណត់ពាក្យសម្ងាត់ដោយជោគជ័យ',
    editSuccess: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់ដោយជោគជ័យ',
    lockSeccess: 'បើកសោដោយជោគជ័យ',
    lock: 'បើកសោ',
    lockSeccessTip: 'ចាក់សោដោយជោគជ័យ',
    inputErrLimit: 'ចំនួនកំហុសដល់ដែនកំណត់ សូមកំណត់ពាក្យសម្ងាត់បើកសោឡើងវិញ!'
    },
  dock56Drill: {
    equipType: 'ប្រភេទឧបករណ៍',
    equipment: 'ឧបករណ៍',
    fiveDock: 'ដ្រូល ៥ មុខ',
    sixDock: 'ដ្រូល ៦ មុខ',
    fileType: 'ប្រភេទឯកសារដែលបានបង្កើត',
    templateOffline: 'គំរូដែលប្រើត្រូវបានផ្អាក!',
    showExample: 'បង្ហាញគំរូទិន្នន័យ',
    conNoticeTip: 'កំណត់ចំណាំភ្ជាប់៖',
    conNoticeTip1: '១) ម៉ាស៊ីនចុកចាក់ដႇលក្រូវបានបើក “ប្តូរអ័ក្ស XY” នោះគឺត្រូវបានបើកកម្មវិធី “ការកំណត់ស្ថានភាពសិក្សាប្រសិទ្ធភាពការលង់គ្រូតែងគ្រូបន្ថែមបានការលង់គ្រូតែងគ្រូ” នៅក្នុងម៉ាស៊ីនចុកចាក់',
    conNoticeTip2: '២) ដើម្បីបង្ហាញ/ដំណើរការផ្នែករូបរាងពិសេសនៅលើដ្រូល ៥/៦ មុខ ត្រូវកំណត់រចនាទិន្នន័យរូបរាងពិសេសក្នុងគំរូ',
    conNoticeTip3: '៣) បន្ទាប់ពីប្រើដ្រូល ៥/៦ មុខលើកដំបូង ឬផ្លាស់គំរូ សូម <span style="color:#f00">ធ្វើការផលិតសាកល្បងទូ</span> ហើយបន្ទាប់ពីផ្ទៀងផ្ទាត់គ្មានកំហុស ទើបផលិតកម្មធម្មតា',
    conNoticeTip4: '៤) កំឡុងផលិតសាកល្បង ពិនិត្យទំហំ ជម្រៅ មុខ និងទីតាំងរន្ធ/រណ្តៅខាងមុខ និងក្រោមឱ្យបានល្អិត ដើម្បីជៀសវាង <span style="color:#f00">បញ្ហាបញ្ចាំងទូ</span>',
    example: 'គំរូទិន្នន័យ',
    commonSetting: 'ការកំណត់ប៉ារ៉ាម៉ែត្រទូទៅ',
    throughHoleSetting: 'រន្ធឆ្លងដោតពីរមុខ',
    throughSlotSetting: 'រណ្តៅឆ្លងដោតពីរមុខ',
    nonHolesNotFiles: 'ផ្ទាំងចតុកោណគ្មានរន្ធ/រណ្តៅមិនមានឯកសារចេញ៖',
    frontFileIdentifier: 'សម្គាល់ឯកសារមុខមុខ៖',
    oppositeFileIdentifier: 'សម្គាល់ឯកសារមុខក្រោម៖',
    oppositeFileIdentifierTips: 'របៀបបង្កើត៖ កូដផ្ទាំង ១៣ ខ្ទង់ដើម + តួអក្សរសម្គាល់',
    arcDescription: 'វិធីពិពណ៌នារង្វង់',
    linePoints: 'ពិពណ៌នាការបង្កើតជួរកំណត់',
    arcCommand: 'ពិពណ៌នាបញ្ជារង្វង់',
    slotWidthSplit: 'បំបែករណ្តៅទទឹងជារណ្តៅចង្អៀតច្រើនសម្រាប់ដំណើរការ៖',
    slotSplitWidth: 'ទទឹងរណ្តៅតែមួយបន្ទាប់ពីបំបែក៖',
    mm: 'សម្គាល់៖ គោលដៅបំបែកគឺរណ្តៅចតុកោណធម្មតា',
    isNotMergeSlot: 'បញ្ចូលរណ្តៅជាប់គ្នាដែលមានទទឹង និងជម្រៅដូចគ្នា៖',
    slotPunchTip: 'មុខងារនេះមានប្រសិទ្ធភាពតែសម្រាប់រណ្តៅផ្ទាំងខាងក្រោយ និងរណ្តៅផ្ទាំងបាតរដេកដែលប្រើគំរូតាមបំណង',
    sizeRange: 'ទំហំជាប់គ្នា ≤',
    enableWorningTip: 'មិនអាចបើកមុខងារនេះជាមួយទិសដាក់គែមមុខក្នុងពេលតែមួយ',
    longDirection: 'ទិសដាក់គែមវែងរបស់ផ្ទាំង',
    horizontal: 'ផ្ដេក',
    vertical: 'បញ្ឈរ',
    slotDirection: 'ទិសដាក់រណ្តៅដ្រូល ៥/៦ មុខ ឬរូបរាងពិសេស',
    default: 'លំនាំដើមប្រព័ន្ធ',
    frontLeft: 'មុខ និងឆ្វេង',
    frontRight: 'មុខ និងស្តាំ',
    backLeft: 'ខាងក្រោយ និងឆ្វេង',
    backRight: 'ខាងក្រោយ និងស្តាំ',
    frontDirection: 'ទិសដាក់គែមមុខ',
    enableTip: 'សម្គាល់៖ មានប្រសិទ្ធភាពតែសម្រាប់ការចងក្រងក្នុងពពក',
    fixedOn: 'រឹងមាំនៅ៖',
    front: 'មុខ',
    back: 'ខាងក្រោយ',
    left: 'ឆ្វេង',
    right: 'ស្តាំ',
    coordinateValue: 'ចំនួនខ្ទង់ទសភាគនៃតម្លៃកូអរដោនេ៖',
    decimalPlaces: 'ខ្ទង់ទសភាគ',
    slotLengthCompensation: 'ការសងវិញប្រវែងរណ្តៅ',
    curveholesLengthCompensation: 'ការសម្អាតមុមរូបរាងពិសេសខាងក្នុង',
    slotCompensationEqualZero: 'ការសងវិញគែមរណ្តៅនៅពេលចម្ងាយទៅគែមគឺ ០',
    slotCompensationNotEqualZero: 'ការសងវិញគែមរណ្តៅនៅពេលចម្ងាយទៅគែមមិនមែន ០',
    slotCompensationTip: 'ប្រើនៅពេលមានមុមរង្វង់តូចមិនទាន់កាត់ស្អាត ឬប្រវែងមិនគ្រប់',
    curveholesCompensationEqualZero: 'ការសងវិញគែមរូបរាងពិសេសខាងក្នុងនៅពេលចម្ងាយ ០',
    curveholesCompensationTip: 'បញ្ចូលដែលបានស្នើ៖ កាំឧបករណ៍ហ្វ្រីសរូបរាងពិសេសខាងក្នុង',
    curveholesCompensationTip2: 'ប្រើនៅពេលរូបរាងពិសេសខាងក្នុងតាមគែមចតុកោណខាងក្រៅនៃផ្ទាំងមានមុមរង្វង់តូចមិនទាន់កាត់ស្អាត',
    specialParameter: 'ការកំណត់ប៉ារ៉ាម៉ែត្រពិសេស',
    output5FDrillSlotKnifeCode: 'លេខឧបករណ៍រណ្តៅហ្វ្រីស XML2',
    output5FDrillShapeKnifeCode: 'លេខឧបករណ៍ហ្វ្រីសរូបរាង XML2',
    plankTexture: 'វាលផ្ទាំង XML2',
    offset: 'ការកែសម្រួលឧបករណ៍កាត់រាង XML2',
    mprConHoleDir: 'ផ្ទៃយោង Z សម្រាប់រន្ធចិញ្ចឹមនៅក្នុងឯកសារ MPR ម៉ាស៊ីនខ្នាត 5/6 ផ្នែក',
    plankTop: 'ផ្ទៃខាងលើនៃផ្ទាំង',
    plankBottom: 'ផ្ទៃខាងក្រោមនៃផ្ទាំង',
    codeInfo: 'ឯកសារទ្រង់ទ្រាយ ban មានព័ត៌មាន Code៖',
    bomFile: 'បញ្ចេញឯកសារទ្រង់ទ្រាយ bom៖',
    plankHeight: 'ការពិពណ៌នាកម្ពស់ផ្ទាំង៖',
    plankNum: 'ការពិពណ៌នាលេខផ្ទាំង៖',
    backZpoint: 'កូអរដោនេ Z របស់រយៈស្នឹងខាងក្រោយ៖',
    plankThick: 'កម្រាស់ផ្ទាំង',
    slotDeep: 'ជម្រៅរយៈស្នឹង',
    outputMprFile: 'ប្រភេទឯកសារ',
    oldMPR: 'MPR ចាស់',
    newMPR: 'MPR ថ្មី',
    mprFileZside: 'ផ្ទៃយោង Z សម្រាប់រន្ធចិញ្ចឹមនៅក្នុងឯកសារ MPR ម៉ាស៊ីន 5/6 ផ្នែក',
    fileTypeOffline: 'ប្រភេទឯកសារម៉ាស៊ីនខ្នាត 5/6 ដែលបានជ្រើសត្រូវបានផ្ដាច់ចេញ សូមផ្ទៀងផ្ទាត់!',
    permissionErr: 'ព័ត៌មានអត្តសញ្ញាណបាត់ សូមបើកទំព័រនេះឡើងវិញពី Guigui!',
    banFileSetting: 'ការកំណត់ឯកសារទ្រង់ទ្រាយ ban',
    banFileCodeInfo: 'ឯកសារទ្រង់ទ្រាយ ban រួមមានព័ត៌មាន Code៖',
    huahuaLine: 'ខ្សែសង្វាក់ស្វ័យប្រវត្តិ Huahua',
    huahuaLineTip: '(មិនត្រូវបានប្រើ: កាត់លើកលើកការផ្ទាល់ខ្ទង់)',
    huahuaPartFlag: {
      longSide: 'ជ្រុងវែង <',
      shortSide: 'ឬជ្រុងខ្លី <',
      partFlag: 'បង្កើតសម្គាល់ផ្ទាំងតូចសម្រាប់ផ្ទាំង',
      tip: '（ដើម្បីបង្ហាញលើស្លាក ត្រូវបន្ថែមទិន្នន័យ «សម្គាល់ផ្ទាំង-សម្គាល់ផ្ទាំងតូច» ហើយក្នុងឯកសារខ្សែសង្វាក់ស្វ័យប្រវត្តិ Huahua ទិន្នន័យដែលពាក់ព័ន្ធនឹងត្រូវបានបន្ថែមដោយស្វ័យប្រវត្តិ）'
      },
    plankPutWay: 'របៀបដាក់ផ្ទាំង',
    plankPutWayTip: 'បើការវិភាគផ្ទាំងសង្វាក់នៅខាងស្តាំមានប្រសិទ្ធភាពសម្រាប់ការផ្ទាំងផ្ទាំងបានបង្ហាញ',
    autoHandle: 'ការជៀសវាងឧបករណ៍ចាប់ដោយស្វ័យប្រវត្តិ',
    manualHandle: 'ការកំណត់ការជៀសវាងដោយដៃ',
    fixedFront: 'ការរុំគែមខាងមុខជាប់ថេរ',
    plankNamePlacement: 'ដាក់ផ្ទាំងតាមឈ្មោះផ្ទាំង',
    plankNamePlacementTip1: '1. បន្ទាប់ពីកំណត់ នៅពេលឈ្មោះផ្ទាំងមានវាលដែលបានកំណត់ គែមផ្ទាំងដែលពាក់ព័ន្ធនឹងត្រូវបានជាប់ថេរនៅផ្នែកដែលបានបញ្ជាក់នៃឧបករណ៍តាមការកំណត់',
    plankNamePlacementTip2: '2. អាទិភាពនៃការកំណត់នេះខ្ពស់ជាងការកំណត់របៀបដាក់ផ្ទាំងខាងលើ',
    plankNamePlacementTip3: '3. មុខងារនេះមានប្រសិទ្ធភាពសម្រាប់តែការរៀបចំលើក្លោដប៉ុណ្ណោះ ប្រសិនបើខ្សែសង្វាក់ផលិតបច្ចុប្បន្នបើកខ្សែស្វ័យប្រវត្តិ Huahua នឹងមិនគាំទ្រការកំណត់របៀបដាក់ផ្ទាំងដាច់ដោយឡែកទេ',
    addRow: 'បន្ថែមជួរ',
    plankNameTip: 'សូមបញ្ចូលឈ្មោះផ្ទាំង',
    plankSide: 'គែមផ្ទាំង',
    deviceSide: 'ជាប់ថេរនៅលើឧបករណ៍',
    weldingPlatePlacementEnable: 'ការរុំគែមខាងមុខជាប់ថេរ',
    onlyBluen: 'មានប្រសិទ្ធភាពតែសម្រាប់ការរៀបចំក្នុងពពក',
    fixedEdge: 'ការរុំគែមខាងមុខជាប់ថេរ',
    fixedEdgeRule: 'គ្រប់គ្រង: បង្ហាញការរៀបចំផ្ទាំងងាយ',
    fixedEdgeRuleItem1: 'ការរុំគែមខាងមុខជាប់ថេរ',
    fixedEdgeRuleItem2: 'ការរុំគែមខាងមុខជាប់ថេរ',
    fixedEdgeRuleItem3: 'ការរុំគែមខាងមុខជាប់ថេរ',
    fixedEdgeRuleItem4: 'ការរុំគែមខាងមុខជាប់ថេរ',
    satisfiedCondition: 'ការរុំគែមខាងមុខជាប់ថេរ',
    handDirection: 'ទិសដៅនៃឧបករណ៍ចាប់',
    handleMachineTip: 'តាមរយៈការបង្វិល រយៈស្នឹងនិងរាងពិសេសជៀសវាងឧបករណ៍ចាប់ដោយស្វ័យប្រវត្តិ ធ្វើឱ្យការដំណើរការផ្ទាំងងាយស្រួល',
    handleWidth: 'ទទឹងឧបករណ៍ចាប់',
    handleLength: 'បណ្ដោយឧបករណ៍ចាប់',
    handleMaxWidth: 'ទទឹងអតិបរមាដែលអាចដំណើរការបាន',
    usefulRange: 'ជួរដែលមានប្រសិទ្ធភាព',
    plankLongSide: 'ជ្រុងវែងនៃផ្ទាំង',
    usefulRangeTip: 'នៅពេលបើកការដាក់តាមជ្រុងវែង និងជ្រុងវែងនៃផ្ទាំងស្ថិតក្នុងជួរនេះ ទីតាំងរយៈស្នឹងនិងរាងពិសេសនឹងត្រូវបានផ្តល់អាទិភាព',
    moveTip: 'មុខងារសម្គាល់ឯកសារខាងមុខ/ខាងក្រោយត្រូវបានផ្លាស់ទីទៅ',
    millingOuter: 'កាត់រាងពិសេសខាងក្រៅ',
    millingInner: 'កាត់រាងពិសេសខាងក្នុង',
    drilling: 'ការដំណើរការរន្ធ',
    slotting: 'ការដំណើរការរយៈស្នឹង',
    knivesTip1: '១. បន្ទាប់ពីកំណត់មុខកាត់រាងពិសេស ផ្លូវកាត់នឹងកែសម្រួលតាមកាំរបស់មុខកាត់',
    knivesTip2: '២. ការកាត់រាងពិសេសបច្ចុប្បន្នមិនគាំទ្រម៉ាស៊ីនចាក់រូបដែលប្តូរអ័ក្ស XY ទេ',
    internalCutting: 'ការកាត់រាងពិសេសខាងក្នុង ការចុះនិងដកមុខកាត់សុទ្ធតែនៅខាងក្នុងផ្ទាំង',
    externalCutting: 'ការកាត់រាងពិសេសខាងក្រៅ ការចុះនិងដកមុខកាត់សុទ្ធតែនៅខាងក្រៅផ្ទាំង',
    externalCuttingDirection: 'នៅពេលកាត់រាងពិសេសខាងក្រៅ គែមទាំងមូលរួមទាំងរាងពិសេសនឹងត្រូវកាត់ព្រមគ្នា',
    allExternalCutting: 'រាងពិសេសខាងក្រៅទាំងអស់',
    onlyArcExternalCutting: 'មានតែរាងពិសេសខាងក្រៅជារង្វង់'
    },
  doorWallCabinet: {
    tempErrTip: 'បានរកឃើញថាអ្នកមិនទាន់បន្ថែមគំរូដែលប្រើសម្រាប់ម៉ាស៊ីនបញ្ចូលទ្វារ-ជញ្ជាំង-ទូទេ ដូច្នេះមិនអាចនាំចេញឯកសារដំណើរការបានទេ។ ចំណាំ៖ បន្ទាប់ពីបន្ថែមរួច ត្រូវរៀបប្លង់ឡើងវិញ។',
    title: 'ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ',
    guifang: 'ការធ្វើឱ្យជាមុំកែង',
    processingTechnology: 'ការធ្វើឱ្យជាមុំកែង',
    longPlateSecondarySquaring: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    slotOnDoorPlate: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    setting: 'ការកំណត់ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'ទ្រង់ទ្រាយឯកសារបញ្ចេញ',
    outputDefaultFileFormat: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    outputMPRFormat: 'បញ្ចេញឯកសារទ្រង់ទ្រាយ MPR',
    fileFormatSettings: 'ការកំណត់ទ្រង់ទ្រាយឯកសារ',
    wrapSettings: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី៖',
    enCodeSettings: 'ការកំណត់ទ្រង់ទ្រាយកូដឯកសារ៖',
    utf8bom: 'UTF-8 ជាមួយ BOM',
    partCoordinate: 'កូអរដោនេផ្ទាំងតូច',
    xPointSymbol: 'កូអរដោនេ X (ផ្ដេក)៖',
    yPointSymbol: 'កូអរដោនេ Y (បញ្ឈរ)៖',
    zPointSymbol: 'កូអរដោនេ Z (លើក/ចុះ)៖',
    upRight: 'តម្លៃវិជ្ជមាន',
    negative: 'តម្លៃអវិជ្ជមាន',
    plankMirroring: 'ការបញ្ចាំងផ្ទាំង',
    plankMirrorSetting: 'ការកំណត់ការបញ្ចាំងផ្ទាំង៖',
    xAxis: 'ការបញ្ចាំងតាមអ័ក្ស X',
    yAxis: 'ការបញ្ចាំងតាមអ័ក្ស Y',
    mirrorTip: '（ប្រើមុខងារនេះនៅពេលបញ្ចាំងផ្ទាំង）',
    knifeTable: {
      type: 'ប្រភេទ',
      diameter: 'អង្កត់ផ្ចិត Φ',
      offsetX: 'អុហ្វសិត X',
      offsetY: 'អុហ្វសិត Y',
      offsetZ: 'អុហ្វសិត Z',
      offsetNo: 'លេខអុហ្វសិត',
      drillVelocity: 'ល្បឿនចុះមុខកាត់ [F] mm/នាទី',
      cutVelocity: 'ល្បឿនដំណើរការ [F] mm/នាទី',
      rotationSeep: 'ល្បឿនបង្វិល [S] ជុំ/នាទី',
      insertRow: 'បញ្ចូលជួរដេក',
      deleteRow: 'លុបជួរដេក'
      },
    labelPool: 'អាងស្លាកទិន្នន័យ',
    dragTip: 'អូសឬចុចដើម្បីចម្លងស្លាកពីអាងស្លាកទៅប្រអប់បញ្ចូល',
    procedure: 'កម្មវិធី',
    beginCode: 'កូដចាប់ផ្តើមកម្មវិធី៖',
    endCode: 'កូដបញ្ចប់កម្មវិធី៖',
    zzdKnifeBeginCode: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ស្ពីនឌែល៖',
    spindleCutter: 'មុខកាត់ស្ពីនឌែល',
    zzdKnifeEndCode: 'កូដបញ្ចប់ប្តូរមុខកាត់ស្ពីនឌែល៖',
    verticalDrill: 'ម៉ាស៊ីនខ្នាតបញ្ឈរ',
    czzBeginCode: 'កូដចាប់ផ្តើមម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    czzEndCode: 'កូដបិទម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    czzKnifeBeginCode: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    czzKnifeEndCode: 'កូដបញ្ចប់ប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    sidetrack: 'ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    czBeginCode: 'កូដចាប់ផ្តើមម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    czEndCode: 'កូដបិទម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    czKnifeBeginCode: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    czKnifeEndCode: 'កូដបញ្ចប់ប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    pauseCode: 'កូដផ្អាក៖',
    zSafeHeight: 'ចម្ងាយសុវត្ថិភាព',
    spindleKnife: 'កម្ពស់សុវត្ថិភាពអ័ក្ស Z របស់មុខកាត់ស្ពីនឌែលនិងម៉ាស៊ីនខ្នាតបញ្ឈរ',
    sideDrillZ: 'កម្ពស់សុវត្ថិភាពអ័ក្ស Z របស់ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    sideDrillXY: 'ចម្ងាយសុវត្ថិភាពអ័ក្ស X/Y របស់ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    auxiliaryFunction: 'មុខងារជំនួយ',
    xhDedicatedInfo: 'បង្កើតព័ត៌មានពិសេសសម្រាប់ឧបករណ៍ Xinghui',
    xhCheckBox: 'ទិន្នន័យ៖',
    outputSettings: 'ការកំណត់បញ្ចេញ៖',
    partExegesis: 'បង្កើតកំណត់ចំណាំទំហំផ្ទាំងតូចក្នុងឯកសារ',
    knifeNo: 'លេខមុខកាត់',
    specailKnifeNo: 'លេខមុខកាត់សម្រាប់ដំណើរការរាងពិសេស៖',
    slotKnifeNo: 'លេខមុខកាត់កាត់រយៈស្នឹង៖',
    fileNamePlaceholder: 'បញ្ជីកាត់តាមតម្រូវការ',
    slotDrill: 'មុខកាត់ឧបករណ៍រួចស្រដិត'
    },
  glassEquip: {
    title: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    fileType: 'ប្រភេទឯកសារដំណើរការ៖',
    sizeReparation: 'ការកែសម្រួលទំហំផ្ទាំង៖',
    cutPreSpace: 'គម្លាតធានាសម្រាប់ការកាត់ផ្ទាំង៖',
    divideIntoFolders: 'ចាត់ថ្នាក់ឯកសារទៅថតផ្សេងៗតាមពណ៌ សម្ភារៈ និងកម្រាស់កញ្ចក់៖'
    },
  translate: {
    search: 'សូមបញ្ចូលភាសាចិនឬការបកប្រែផ្លូវការដើម្បីស្វែងរកធាតុ',
    en: 'ភាសាអង់គ្លេស',
    es: 'ភាសាអេស្ប៉ាញ',
    ar: 'ភាសាអារ៉ាប់',
    kz: 'ភាសាកាសាក់',
    vi: 'ភាសាវៀតណាម',
    th: 'ភាសាថៃ',
    id: 'ភាសាឥណ្ឌូនេស៊ី',
    ug: 'ភាសាអ៊ូយ៉ឺរ',
    customTranslate: 'ចុចដើម្បីបន្ថែមការបកប្រែតាមតម្រូវការ',
    customText: 'ការបកប្រែតាមតម្រូវការ',
    text: 'ភាសាចិន',
    targetLang: 'ការបកប្រែផ្លូវការ',
    zh_hant: 'ភាសាចិនបុរាណ'
    },
  preLayoutSetting: {
    title: 'ការកំណត់រៀបចំជាមុន',
    titleTip: 'អ្នកអាចកំណត់ប៉ារ៉ាម៉ែត្ររៀបចំជាមុន រៀបចំជាមុន រួចជ្រើសខ្សែផលិតកម្ម',
    settingTip: 'ប៉ារ៉ាម៉ែត្រដែលកំណត់ក្នុងខ្សែផលិតកម្មត្រូវស្របនឹងប៉ារ៉ាម៉ែត្ររៀបចំជាមុនខាងក្រោមដើម្បីបញ្ចេញឯកសារផលិតកម្ម មានប្រសិទ្ធិតែសម្រាប់ម៉ាស៊ីនកាត់',
    emptyKnife: 'មិនបានបំពេញមុខកាត់',
    noModify: 'គ្មានការផ្លាស់ប្តូរក្នុងការកំណត់ មិនចាំបាច់រក្សាទុក',
    reSet: 'កំណត់ឡើងវិញ',
    gayPosition: 'ការ៉េប្រផេះអាចប្តូរទីតាំងដាក់សម្ភារៈលើស',
    surplusPosition: 'ទីតាំងដាក់សម្ភារៈលើសបច្ចុប្បន្ន',
    click: 'ចុច',
    grayStart: 'ការ៉េប្រផេះអាចប្តូរចំណុចចាប់ផ្តើមកន្លែងធ្វើការ',
    currentStart: 'ចំណុចចាប់ផ្តើមកន្លែងធ្វើការបច្ចុប្បន្ន',
    holeSlotSetting: 'ការកំណត់ដំណើរការរន្ធនិងរយៈស្នឹង',
    knifeDiameter: 'អង្កត់ផ្ចិតមុខកាត់',
    currentVersion: 'កំណែបច្ចុប្បន្ន',
    on: 'បើក',
    off: 'បិទ',
    firstShort: 'ការកាត់ដំបូង - កម្រាលជ្រុងខ្លី',
    firstLong: 'ការកាត់ដំបូង - កម្រាលជ្រុងវែង',
    cuttingSplitLong: 'កាត់ផ្ទាំងវែងពីរដង - ជ្រុងវែងលើស',
    cuttingSplitShort: 'កាត់ផ្ទាំងវែងពីរដង - ជ្រុងខ្លីលើស',
    plankThick: 'កម្រាស់ផ្ទាំងធម្មតា ≥ ',
    singleDoorThick: 'កម្រាស់បន្ទះទ្វារ ≥ ',
    normalPlank: 'ផ្ទាំងធម្មតា',
    confilictTip: 'មានប៉ារ៉ាម៉ែត្រប៉ះទង្គិច៖ {confilictTotal} ធាតុ',
    selectLine: 'ជ្រើសខ្សែផលិតកម្ម',
    selectLinePlaceholder: 'សូមជ្រើសខ្សែផលិតកម្ម',
    lineConfilictTip: 'ខ្សែផលិតកម្មដែលបានជ្រើសប៉ះទង្គិចនឹង {line}',
    preWay: 'របៀបរៀបចំជាមុន',
    paibanErrTip: 'ការផ្លាស់ប្តូរ [កម្រាលជ្រុងវែងនិងខ្លី] សម្រាប់ដំណើរការផ្ទាំងវែងអាចបរាជ័យក្នុងការរៀបចំ',
    paibanTip: 'ដោយសារមានការកំណត់មុខកាត់សម្រាប់សម្ភារៈផ្ទាំងធំ ត្រូវការរៀបចំឡើងវិញ',
    reLayout: 'រៀបចំឡើងវិញជាមួយខ្សែផលិតកម្មបច្ចុប្បន្ន',
    fetchErr: 'មិនអាចទាញយកការកំណត់រៀបចំជាមុនបានទេ',
    resetSuccess: 'កំណត់ឡើងវិញជោគជ័យ',
    resetConfirm: 'តើអ្នកប្រាកដជាចង់ត្រឡប់ទៅកំណែប្រវត្តិវិញ?',
    prolineName: 'ឈ្មោះខ្សែផលិតកម្ម',
    layoutGap: 'គម្លាតរៀបចំ',
    generalThickness: 'វត្ថុកាត់ដើម្បីទីពីរ - កម្រាស់ផ្ទាំងធម្មតា',
    cutGeneralPlank: 'វត្ថុកាត់ដើម្បីទីពីរ - ផ្ទាំងធម្មតា',
    cutSingleDoor: 'វត្ថុកាត់ដើម្បីទីពីរ - បន្ទះទ្វារ',
    secondary_cutting_board_list: 'បញ្ជីឈ្មោះផ្ទាំងដែលកំណត់និងឈ្មោះផ្ទាំងកាត់',
    changeProline: 'ប្តូរខ្សែផលិតកម្ម',
    backTip: 'សូមត្រឡប់ទៅការរៀបចំទូទៅដើម្បីជ្រើសខ្សែផលិតកម្ម',
    preLayout: 'រៀបចំតាមរបៀបរៀបចំជាមុន',
    preWayEmpty: '(ទទេ) របៀបរៀបចំជាមុន',
    specialConfilictTip: 'ដំណើរការកាត់បាតរង្វង់ប៉ះពាល់លទ្ធផលរៀបចំ ត្រូវការរៀបចំឡើងវិញ'
    },
  lunbo: {
    tips: 'គន្លឹះប្រតិបត្តិការ',
    introduction: 'សេចក្តីណែនាំមុខងារ',
    qtDownloadText: 'សូមរំលឹក៖ ប្រសិនបើឯកសារទាញយកមិនគ្រប់គ្រាន់ សូមទៅកាន់គេហទំព័ររៀបចំក្នុងពពកដើម្បីទាញយក!'
    },
  sendModal: {
    paibanImgType: 'ប្រភេទទ្រង់ទ្រាយឯកសាររៀបចំ'
    },
  authenticationModal: {
    title: 'ស្កេនកូដ QR ដើម្បីផ្ទៀងផ្ទាត់',
    tip: 'សូមកុំបិទប្រអប់មុនពេលផ្ទៀងផ្ទាត់ជោគជ័យ!',
    countdownTip: 'ផុតកំណត់បន្ទាប់ពី {countdown}',
    refreshTip: 'ធ្វើឱ្យកូដ QR ឡើងវិញ',
    qrcodeTip: 'សូមស្កេនកូដ QR ជាមួយ WeChat ដើម្បីបញ្ចប់ប្រតិបត្តិការ',
    qrcodeTip2: 'ប្រសិនបើស្កេនរក្សាទុកមិនបានជោគជ័យ សូមផ្តល់សិទ្ធិកែប្រែប្រព័ន្ធក្នុងការកំណត់ទូទៅ Guigui - ការកំណត់អនុញ្ញាតអ្នកប្រើ។',
    waiting: 'កំពុងរង់ចាំការស្កេន',
    scanning: 'បានស្កេនរួច កំពុងរង់ចាំការផ្ទៀងផ្ទាត់',
    success: 'ផ្ទៀងផ្ទាត់ជោគជ័យ',
    error: 'ផ្ទៀងផ្ទាត់បរាជ័យ',
    expired: 'កូដ QR ផុតកំណត់ហើយ',
    tip2: 'ដើម្បីសុវត្ថិភាពទិន្នន័យគណនី សូមផ្ទៀងផ្ទាត់ព័ត៌មានអ្នកប្រតិបត្តិបច្ចុប្បន្ន'
    },
  printTag: {
    partName: 'ឈ្មោះផ្ទាំង'
    },
  userAccessToken: {
    createTime: 'ពេលវេលាបង្កើត',
    lastUsedTime: 'ពេលវេលាប្រើប្រាស់ចុងក្រោយ',
    expireTime: 'ពេលវេលាផុតកំណត់',
    status: 'ស្ថានភាព',
    tokenNamePlaceholder: 'សូមបញ្ចូលឈ្មោះថូខឹន',
    expireTimeSelectPlaceholder: 'សូមជ្រើសរើសពេលវេលាផុតកំណត់',
    securityBannerTip: 'កុំចែករំលែកថូខឹនចូលប្រើផ្ទាល់ខ្លួនរបស់អ្នកជាមួយអ្នកដទៃ ឬបង្ហាញនៅក្នុងកម្មវិធីរុករក ឬកូដអតិថិជនផ្សេងទៀត។ ដើម្បីការពារគណនី ថូខឹនដែលរលយដោយចៃដន្យអាចត្រូវបានបិទដោយស្វ័យប្រវត្តិ។',
    expired: 'ផុតកំណត់',
    valid: 'មានសុពលភាព',
    remove: 'យកចេញ',
    previewOnceWarning: 'ថូខឹននេះបង្ហាញតែម្តងប៉ុណ្ណោះ។ រក្សាទុករក្សាសម្ងាត់នេះនៅកន្លែងសុវត្ថិភាព និងអាចចូលប្រើបាន។ កុំចែករំលែកជាមួយអ្នកដទៃ ឬបង្ហាញនៅក្នុងកម្មវិធីរុករក ឬកូដអតិថិជនផ្សេងទៀត។',
    token: 'ថូខឹន',
    deleteConfirm: 'តើអ្នកប្រាកដថាចង់លុបថូខឹននេះមែនទេ?',
    userAccessToken: 'ថូខឹនចូលប្រើរបស់អ្នកប្រើ',
    dayUnit: 'ថ្ងៃ',
    custom: 'តាមបំណង',
    previewModalTitle: 'ថូខឹនចូលប្រើផ្ទាល់ខ្លួនថ្មី',
    addModalTitle: 'បន្ថែមថូខឹនចូលប្រើផ្ទាល់ខ្លួនថ្មី'
    },
  bujianStore: {
    inputPlaceholder: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    noData: 'មិនមានទិន្នន័យ',
    loadingErr: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    bujianStore: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    awaitStore: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    noDrag: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    outOfCanvas: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច'
    },
  alginTexture: {
    tip: 'ប្រតិបត្តិការនេះនឹងលុបព័ត៌មានការតំរឹមលំនាំវាយនភាពរបស់បន្ទះ។ សូមបញ្ជាក់ថាតើចង់បន្តឬទេ?',
    tip2: 'ប្រតិបត្តិការនេះនឹងប្រាកដិតិចម្ងាយរវាងបន្ទះ ដែលបង្ហាញលាខណៈសម្រាប់ការលើកឡើង។ សូមបញ្ជាក់ថាតើចង់បន្តឬទេ?',
    group: 'ក្រុមសិក្សារភាព',
    groupTemp: 'ក្រុមសិក្សារភាពមួយ',
    textureAlignmentPlank: 'មិនអាចផ្លាស់ទីស្បែកតម្រឹមបានទេ'
    },
  customizeFolder: {
    customizeFolder: 'ការកែសម្រួលថត',
    customizeFolderTip: 'ចំណាំ៖ បន្ទាប់ពីបើកការកែសម្រួលថត តម្រូវការបែងចែកថតដែលបានកំណត់ពីមុននឹងមិនមានប្រសិទ្ធិភាពទៀតទេ',
    processingFilesTitle: 'ដំណើរការទិន្នន័យឯកសារ',
    dragToFolderTip: 'អាចអូសទៅថតខាងឆ្វេងជាថតរង ឬឯកសារ',
    folderNameEmpty: 'ឈ្មោះថតមិនអាចទទេ为空',
    folderNameExists: 'មានថតដែលមានឈ្មោះដូចគ្នា',
    fileNotFound: 'មិនអាចទទួលបានឯកសារត្រឹមត្រូវ',
    fileCannotBeClassified: 'ប្រភេទឯកសារនេះមិនអាចដាក់ក្រោមថតចំណាត់ថ្នាក់ណាមួយ',
    cannotAddAtThisPosition: 'មិនអាចបន្ថែមនៅទីតាំងនេះ',
    fileAlreadyExists: '【{name}】មានស្រាប់នៅក្នុងថតនេះ',
    confirmDeleteFolder: 'តើអ្នកប្រាកដថាចង់លុបថតនេះទេ?',
    confirmDeleteItem: 'តើអ្នកប្រាកដថាចង់លុប【{name}】ទេ?',
    confirmDeleteFolderWithChildren: 'មានថត/ឯកសារផ្សេងទៀតនៅក្រោមថតនេះ តើអ្នកប្រាកដថាចង់លុបវាទេ?',
    deleteFile: 'លុបឯកសារ',
    addSubFolder: 'បន្ថែមថតរង',
    editFolder: 'កែសម្រួលថត',
    deleteFolder: 'លុបថត',
    rootCannotDelete: 'ថតအမြစ်မអាចលុបបាន',
    newFolder: 'ថតថ្មី',
    fileUsedCanDrag: 'បានប្រើប្រាស់ - អាចអូសច្រើនដង',
    fileDraggable: 'អាចអូស',
    addFileToFolder: 'បន្ថែម 【{fileName}】 ទៅ {folderName}',
    addFolderTitle: 'បន្ថែមថត',
    editFolderTitle: 'កែសម្រួលថត',
    folderNameLabel: 'ឈ្មោះថត',
    folderNamePlaceholder: 'សូមបញ្ចូលឈ្មោះថត',
    sequenceStartLabel: 'តម្លៃចាប់ផ្តើមលំដាប់បង្កើន',
    classifyMethodLabel: 'វិធីសាស្ត្រចំណាត់ថ្នាក់',
    nameLengthLimitLabel: 'កម្រិតកំណត់ប្រវែងអក្សរ',
    tagInsertTip: 'ចុចស្លាក ដើម្បីបញ្ចូលទៅក្នុងឈ្មោះថត',
    classifyTagInsertTip: 'ចុចស្លាក ដើម្បីបញ្ចូលទៅក្នុងឈ្មោះថត ឯកសារនឹងត្រូវបានចំណាត់ថ្នាក់តាមស្លាកដែលបានកំណត់',
    engraving_front: 'ឯកសារមុខម៉ាស៊ីនការឆ្លាក់',
    engraving_opposite: 'ឯកសារខាងក្រោយម៉ាស៊ីនការឆ្លាក់',
    engraving_merge: 'ឯកសារបញ្ចូលគ្នានៃម៉ាស៊ីនការឆ្លាក់',
    engraving_mill: 'ការគេង槽ស៊ីសេងដំណើរការទីពីរ',
    engraving_haitang: 'ឯកសារមុំ Haitang bevelled ដំណើរការទីពីរ',
    engraving_arc_slot: 'Slot arc ថ្មីដំណើរការទីពីរ',
    engraving_line_slot: 'ដំណើរការទីពីរផ្លូវឧបករណ៍ផ្ទាល់ខ្លួន',
    engraving_straight_arc_slot: 'ដំណើរការទីពីរផ្នែកពត៌មានផ្លូវឈរ',
    engraving_frame_door: 'ឯកសារកាត់កញ្ចក់ពួកជ្រុង',
    engraving_inner_shape: 'ដំណើរការទីពីរផ្នែកក្នុងសំបុត្រ',
    engraving_hole: 'ដំណើរការទីពីរផ្នែកឈរ',
    engraving_slot: 'ដំណើរការទីពីរផ្នែកឈរ',
    engraving_single_file_merge: 'ដំណើរការទីពីរផ្នែកកាត់កញ្ចក់',
    electronic_saw: 'ឯកសារកាន់អេឡិចត្រូនិច',
    glass: 'ឯកសារម៉ាស៊ីនកាត់កញ្ចក់',
    glass_machine: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    side_machine: 'ឯកសារម៉ាស៊ីនរន្ធជ្រុង',
    side_machine_xml3: 'ឯកសារ XML3 ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    side_machine_txt: 'ឯកសារ TXT ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    side_machine_nc: 'ឯកសារ NC ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    dock56F: 'ឯកសារខួងប្រាំ/ប្រាំមួយភាគ',
    ptp: 'ឯកសារ PTP',
    aio: 'ឯកសារម៉ាស៊ីនអាល់-ইন-វ៉ាន់',
    aio_anc: 'ឯកសារ ANC ផ្នែកខាងមុខម៉ាស៊ីនរួមមុខងារ',
    labeling_1: 'ឯកសារម៉ាស៊ីនបិទស្លាក 1',
    labeling_2: 'ឯកសារម៉ាស៊ីនបិទស្លាក 2',
    labeling_3: 'ឯកសារម៉ាស៊ីនបិទស្លាក 3',
    robotic_arm: 'ឯកសារដៃមនុស្សយន្ត',
    label_image: 'ឯកសាររូបភាពស្លាក',
    label_pdf: 'ឯកសារ PDF ស្លាក',
    paiban_image: 'ឯកសាររូបភាពរៀបចំបោះពុម្ព',
    paiban_pdf: 'ឯកសារ PDF រូបភាពរៀបចំបោះពុម្ព',
    engraving: 'ម៉ាស៊ីនឆ្លាក់',
    electronic: 'កាន់អេឡិចត្រូនិច',
    side_hole: 'ម៉ាស៊ីនរន្ធជ្រុង',
    drilling: 'ខួងប្រាំ/ប្រាំមួយភាគ',
    labeling: 'ម៉ាស៊ីនបិទស្លាក',
    robotic: 'ដៃមនុស្សយន្ត',
    label: 'ស្លាក',
    warningTip: 'សូមចំណាំ៖ ស្រោមគ្រាប់ 【{}】 និងខ្លឹមសាររបស់ពួកគេត្រូវតែរក្សាឱ្យបានពេញលេញ កុំលុប ឬបន្ថែមដោយដៃ!',
    fileClassifyError: 'ឯកសារនេះមិនអាចចាត់ថ្នាក់តាម {classifyNames}',
    folderClassifyByTextureColorThickSize: 'ចាត់ថ្នាក់ទៅថតផ្សេងៗទៀតតាមពណ៌ សម្ភារៈ កម្រាស់ និងទំហំបន្ទះធំ (ឯកសារស្លាកមួយគ្នា)',
    unnamed: 'មិនមានឈ្មោះ',
    specialText: 'ពិសេស',
    surplusText: 'សម្ភារៈលើស',
    normalText: 'ធម្មតា',
    plankText1: 'បន្ទះ',
    resetTemplate: 'ធម្មតា',
    resetTemplateConfirm: 'តើអ្នកប្រាកដថាចង់កំណត់គំរូឡើងវិញទេ?',
    clearTemplate: 'សម្អាតគំរូ',
    clearTemplateConfirm: 'តើអ្នកប្រាកដថាចង់សម្អាតគំរូទេ?',
    legendFixedFolder: 'ថតថេរ',
    legendClassifyFolder: 'ថតដែលបានចំណាត់ថ្នាក់',
    legendFixedTag: 'ទិន្នន័យថេរ',
    legendNormalTag: 'ទិន្នន័យថមថយ',
    legendClassifyTag: 'ទិន្នន័យថមថយដែលបានចំណាត់ថ្នាក់',
    door_wall_aio: 'ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ',
    noPermission: 'បច្ចុប្បន្នអ្នកមិនមានសិទ្ធិប្រើថតផ្ទាល់ខ្លួនទេ។ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញមុនពេលប្រើ។',
    enableCustomFolder: 'ថតផ្ទាល់ខ្លួនទៅសាកល្បង',
    exporttagTip: 'នៅពេលនាំចេញស្លាក PDF និងរូបភាពក្នុងពេលតែមួយ PDF ត្រូវបានផ្ញើតាមលំនាំដើម'
    },
  paibanTask: {
    pausedTip: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    deleteTip: 'តើអ្នកប្រាកដថាចង់លុបភារកិច្ច «{taskBatch}» ទេ? បន្ទាប់ពីលុបហើយ មិនអាចស្ដារឡើងវិញបានទេ។',
    continueTip: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    completed: 'បានសិក្សាសិទ្ធ',
    failed: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    paused: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    pending: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    running: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    extraTip: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    taskStatus: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    createTaskTip: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    taskBatchTitle: 'ករណីការងារ',
    relatedOrderNosTitle: 'លេខបញ្ជាទាក់ទង',
    progressTitle: 'ដំណើរការប្លង់',
    boardCountTitle: 'ការប្រើប្រាស់ក្តារធំជាក់លាក់',
    optimizedAreaTitle: 'ការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    productionLineTitle: 'ខ្សែសង្វាក់ផលិត',
    operationTitle: 'ប្រតិបត្តិការ',
    optimizeRateTitle: 'បង្កើនប្រសិទ្ធភាពក្តារធំការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    optimizeRateTip: 'អត្រាបង្កើនប្រសិទ្ធភាពក្តារធំគឺមិនត្រូវបានគូរបាន។',
    optimizeRateTip2: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    boardCountTip: 'បរិមាណប្រើប្រាស់ក្តារធំជាក់លាក់គឺផ្អែកលើទំព័រប្លង់',
    optimizedAreaTip: 'ផ្ទៃដែលបានបង្កើនប្រសិទ្ធភាពក្តារធំការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    paibanSettingTip: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    dataException: 'ការបង្ហាញទិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។'
    },
  paibanSetting: {
    advancedSetting: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    advancedFeature: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    surplusCutSpeedUp: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    surplusCutSpeedUpTip4: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    surplusCutSpeedUpTip: 'ចន្លោះប្លង់សម្ភារៈសល់ត្រូវបានកំណត់ជា 0 ដោយស្វ័យប្រវត្តិ',
    surplusCutSpeedUpTip2: 'ការកាត់សម្ភារៈសល់នឹងរំលងផ្លូវដែលបានកាត់ និងផ្លូវច្នៃគែមដោយស្វ័យប្រវត្តិ ដើម្បីបង្កើនប្រសិទ្ធភាព',
    surplusCutSpeedUpTip3: 'មុខងារនេះបច្ចុប្បន្នមិនគាំទ្រការប្រើជាមួយម៉ាស៊ីនឡាស៊ែររួមមួយ ម៉ាស៊ីនកាត់និងចុកចាក់ ការកាត់គែមរួម និងការបង្កើនល្បឿនគែមរួមទេ',
    surplusCutSpeedUpTip5: 'មុខងារនេះបច្ចុប្បន្នមិនគាំទ្រការប្រើជាមួយម៉ាស៊ីនឡាស៊ែររួមមួយ ម៉ាស៊ីនកាត់និងចុកចាក់ ការកាត់គែមរួម និងការបង្កើនល្បឿនគែមរួមទេ',
    featureDisplay: 'ការបង្ហាញមុខងារ',
    featureDisplayTip: 'ទំព័រនេះគ្រប់គ្រងតែការបង្ហាញច្រកចូលមុខងារប៉ុណ្ណោះ ហើយមិនផ្លាស់ប្តូរស្ថានភាពបើកដំណើរការ និងការកំណត់ប៉ារ៉ាម៉ែត្ររបស់មុខងារខ្លួនឯងទេ'
    },
  alignedPlan: {
    deepSearch: 'ការស្វែងរកចម្បង',
    deepSearchTip: 'មុខងារផ្តាច់មុខ៖ បង្កើនជម្រៅគណនាតាមរយៈការរៀបចំឡើងវិញដើម្បីទទួលបានលទ្ធផលល្អជាង',
    deepSearchTip2: 'បន្ទាប់ពីធ្វើឱ្យ Deep Search ប្រសើរឡើង អាចរៀបចំឡើងវិញដើម្បីបង្កើនជម្រៅគណនា។ បច្ចុប្បន្នអាចសាកល្បង',
    deepSearchTip3: 'Deep Search ផ្តល់ផែនការដែលសន្សំសំចៃក្តារជាង',
    deepSearchTip4: 'បច្ចុប្បន្នមិនទាន់មានសិទ្ធិរៀបចំ Deep Search។ សូមទាក់ទងការលក់ដើម្បីទិញ។',
    deepSearchTip5: 'បន្ទាប់ពីធ្វើឱ្យ Deep Search ប្រសើរឡើង ទទួលបានថាមពលម៉ាស៊ីនមេផ្តាច់មុខ។ បច្ចុប្បន្នអាចមើលជាមុន'
    }
  }